/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect, useMemo, useCallback, useRef, SetStateAction } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {
  FilterChangedEvent,
  GetRowIdParams,
  ICellRendererParams,
  RowNode,
  ValueFormatterParams,
  IServerSideGetRowsParams,
  RowSelectedEvent,
  SelectionChangedEvent,
  SortChangedEvent,
  FilterModifiedEvent,
  ColDef,
  SetFilterValuesFuncParams,
  GridReadyEvent,
} from 'ag-grid-community';
import { LicenseManager } from '@ag-grid-enterprise/core';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Collapse,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  Menu,
  NativeSelect,
  Tooltip,
  Typography,
} from '@material-ui/core';
import {
  ArrowDropDown,
  Check,
  DonutSmall,
  Equalizer,
  Filter,
  LocalSeeOutlined,
  PieChart,
  PieChartOutlined,
  PieChartRounded,
  SentimentDissatisfied,
  SentimentSatisfied,
  SentimentSatisfiedAlt,
  SentimentVeryDissatisfied,
  SentimentVerySatisfied,
} from '@material-ui/icons';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import {
  ArcElement,
  Chart,
  Tooltip as ChartTooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from 'chart.js';
import { Bar, Doughnut, Pie } from 'react-chartjs-2';
import { CXAgent, CXExtension } from './CxDashboard';
import C2GTimeline from './timeline/C2GTimeline';
import Report from './GenerateReport/Report';
import ActiveFilterView from './timeline/ActiveFilterView';
import { formatSecondsToDuration } from './LiveDashboard/Utilities';

// old one ↓↓↓↓
// const cxCallApi = `https://tmipln5lwe.execute-api.eu-west-2.amazonaws.com/ringcx-calls`;

const cxCallApi = `${
  process.env.REACT_APP_CX_API_URL || 'https://5wnuftmrla.execute-api.us-east-1.amazonaws.com'
}/ringcx-calls`;

const dbName = 'myDb';
let version = 1;
let db: IDBDatabase | null = null;
const rangeColumns = ['index', 'duration', 'talkDuration', 'ringDuration', 'holdDuration'];
const setColumns = [
  'direction',
  'result',
  'recordingExists',
  'sentimentScore',
  'callScore',
  'disposition',
  'component',
  'fromPhoneNumber',
  'toPhoneNumber',
  'fromLink',
  'toLink',
  'fromEx',
  'fromCx',
  'toEx',
  'toCx',
];

const MAX_RETRY = 5;
let newEventsReceived: boolean = false;

const exPhonePattern = '*6503899321*';

interface Model {
  [colId: string]: any;
}

export interface UserState {
  callId: string;
  userId: string;
  index: string;
  recordingId?: string;
  duration?: number;
  ringDuration?: number;
  talkDuration?: number;
  fromLink?: string;
  toLink?: string;
  fromEx?: boolean;
  fromCx?: boolean;
  toEx?: boolean;
  toCx?: boolean;
  callScore?: string;
  recordingsReady?: Array<string>;

  toPhoneNumber?: string;
  fromPhoneNumber?: string | number;
  holdTimeInbound?: number;

  PartitionKey?: string;
  SortKey?: string;
  direction: string;
  hangupTime?: number;
  state?: string;
  eventNo?: string;
  timestamp?: string;
  insights?: {
    sentimentScore?: number;
    transcript?: string;
    disposition?: {
      codeNumber?: string;
      codeDescription?: string;
      time?: string;
    };
  };
}

export interface Call {
  callId?: string;
  direction?: string;
  result?: string;
  duration?: number;
  ringDuration?: number;
  talkDuration?: number;
  holdDuration?: number;
  index: string;
  disposition?: string;
  dispositionTime?: string;
  recordings?: Array<string>;
  recordingsReady?: Array<string>;
  recordingExists?: string;
  sentimentScore?: string;
  callScore?: string;
  transcript?: string;
  users?: Array<any>;
  toPhoneNumber?: string;
  fromPhoneNumber?: string;
  //   fromPhoneList?: Array<string>;
  //   toPhoneList?: Array<string>;
  //   fromPhoneList_index?: Array<Array<string>>;
  //   toPhoneList_index?: Array<Array<string>>;
  //   fromPhoneList_duration?: Array<Array<string | number>>;
  //   toPhoneList_duration?: Array<Array<string | number>>;
  //   fromPhoneList_direction_index?: Array<Array<string>>;
  //   toPhoneList_direction_index?: Array<Array<string>>;
  //   fromPhoneList_result_index?: Array<Array<string>>;
  //   toPhoneList_result_index?: Array<Array<string>>;
  component: string;
  fromLink: string;
  toLink: string;
  fromEx: string;
  fromCx: string;
  toEx: string;
  toCx: string;
}

export interface CallLeg {
  id: string;
  eventTime: string;
  direction: string;
  state: string;
  fromExt?: string;
  fromPhone: string;
  fromName: string;
  toExt?: string;
  toPhone: string;
  toName: string;
  status?: string;
}

interface WidgetGraphData {
  data: Map<string, number | any>;
  visible: boolean;
  title: string;
  metric?: string;
  isBarChart?: boolean;
}

interface WidgetIncr {
  calls?: number;
  recordings?: number;
  transcripts?: number;
  inbound?: number;
  outbound?: number;
  internal?: number;
  veryPositive?: number;
  positive?: number;
  neutral?: number;
  negative?: number;
  veryNegative?: number;
  answered?: number;
  abandoned?: number;
  queueAbandoned?: number;
  faxReceived?: number;
}

LicenseManager.setLicenseKey(
  'CompanyName=Resource Software International Ltd,LicensedApplication=Shadow,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-032296,SupportServicesEnd=20_October_2023_[v2]_MTY5Nzc1NjQwMDAwMA==0c008d8dba7b9997038f1e1fee335d4a',
);

function regexCheck(str: string, number: string): boolean {
  const escapeRegex = (s: string): string => s.replace(/([.+^=!:${}()|\\])/g, '\\$1');

  const temp = '^'.concat(number.split('*').map(escapeRegex).join('.*'), '$');
  const r = new RegExp(temp.split('?').join('.'));

  return r.test(str);
}

const durationFormatter = (params: ValueFormatterParams) => {
  if (params.value === undefined || params.value === -Infinity) return '--:--';
  const hours = Math.floor(params.value / 3600 / 1000);
  let minutes = Math.floor(Math.floor(params.value - hours * 3600 * 1000) / 60 / 1000);
  let seconds = Math.floor((params.value - hours * 3600 * 1000 - minutes * 60 * 1000) / 1000);
  if (seconds === 60) {
    minutes += 1;
    seconds = 0;
  }
  if (hours > 0) {
    return `${hours.toString()}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

const dateFormatter = (params: ValueFormatterParams) =>
  new Date(params.value.replace('#', '')).toLocaleString('en-CA', {
    hour12: false,
  });

const recordingRenderer = (params: ValueFormatterParams) => {
  if (params.value === 'Not Ready') {
    return 'Not Ready';
  }
  if (params.value === 'Ready') {
    return 'Ready';
  }
  return '--';
};

const sentimenthandler = (sentiment: string) => {
  if (sentiment === 'Very Positive') {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title="Very Positive">
          <SentimentVerySatisfied fontSize="large" style={{ color: '#5DCF49' }} />
        </Tooltip>
      </div>
    );
  }
  if (sentiment === 'Positive') {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title="Positive">
          <SentimentSatisfiedAlt fontSize="large" style={{ color: '#009AFF' }} />
        </Tooltip>
      </div>
    );
  }
  if (sentiment === 'Neutral') {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title="Neutral">
          <SentimentSatisfied fontSize="large" style={{ color: '#64BDFD' }} />
        </Tooltip>
      </div>
    );
  }
  if (sentiment === 'Negative') {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title="Negative">
          <SentimentDissatisfied fontSize="large" style={{ color: '#FF9E1C' }} />
        </Tooltip>
      </div>
    );
  }
  if (sentiment === 'Very Negative') {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {' '}
        <Tooltip title="Very Negative">
          <SentimentVeryDissatisfied fontSize="large" style={{ color: '#EE6B6B' }} />
        </Tooltip>
      </div>
    );
  }
  return <div />;
};
const timeDiffFormatter = (i: number, log: CallLeg[]) => {
  if (log[i + 1] === undefined) {
    return '';
  }
  const datePrior = new Date(log[i].eventTime.slice(0, log[i].eventTime.length - 4)).getTime() / 1000;
  const dateNow = new Date(log[i + 1].eventTime.slice(0, log[i + 1].eventTime.length - 4)).getTime() / 1000;
  const difference = dateNow - datePrior;
  const minutes = Math.floor(difference / 60);
  const seconds = Math.floor(difference % 60);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

const durationStringToNumber = (text: string | undefined) => {
  if (text === undefined) {
    return undefined;
  }
  const numbers = text.endsWith(':') ? text.concat('0').split(':') : text.split(':');

  if (numbers.length === 3) {
    const [hours, minutes, seconds] = numbers;
    return parseInt(hours, 10) * 60 * 60 * 1000 + parseInt(minutes, 10) * 60 * 1000 + parseInt(seconds, 10) * 1000;
  }
  if (numbers.length === 2) {
    const [minutes, seconds] = numbers;
    return parseInt(minutes, 10) * 60 * 1000 + parseInt(seconds, 10) * 1000;
  }
  if (numbers.length === 1) {
    const [seconds] = numbers;
    return parseInt(seconds, 10) * 1000;
  }

  return undefined;
};

const compareSentiments = (existingSentiment: string | undefined, newSentimentScore: number) => {
  let newSentiment: string;
  if (newSentimentScore >= 2) {
    newSentiment = 'Very Positive';
  } else if (newSentimentScore >= 1) {
    newSentiment = 'Positive';
  } else if (newSentimentScore > -1) {
    newSentiment = 'Neutral';
  } else if (newSentimentScore > -2) {
    newSentiment = 'Negative';
  } else {
    newSentiment = 'Very Negative';
  }

  if (existingSentiment === 'None' || existingSentiment === undefined) {
    return newSentiment;
  }

  const mySentiments = ['Very Negative', 'Negative', 'Neutral', 'Positive', 'Very Positive'];
  const index1 = mySentiments.indexOf(existingSentiment);
  const index2 = mySentiments.indexOf(newSentiment);
  return index1 < index2 ? existingSentiment : newSentiment;
};

const getEarliestStart = (users: UserState[]) =>
  users.reduce((earliestStart: string | undefined, user: UserState) => {
    const userStart = user.index;
    if (earliestStart === undefined || userStart < earliestStart) {
      return userStart;
    }
    return earliestStart;
  }, users[0].index);

const getEndTime = (user: UserState) =>
  user.duration ? new Date(user.index).getTime() + user.duration : new Date(user.index).getTime();

const getLatestEnd = (users: UserState[]) =>
  users.reduce((latestEnd: number | undefined, user: UserState) => {
    const userEnd = getEndTime(user);

    if (latestEnd === undefined || userEnd > latestEnd) {
      return userEnd;
    }

    return latestEnd;
  }, undefined);

const getLatestUserState = (users: UserState[]) => {
  const first = users[0];
  return users.reduce((myUser: UserState, user: UserState) => {
    if (getEndTime(user) > getEndTime(myUser)) {
      return user;
    }
    return myUser;
  }, first);
};

const getLatestDelta = (users: UserState[]) => {
  const first = users[0];
  return users.reduce((myUser: UserState, user: UserState) => {
    if (user.timestamp && myUser.timestamp && user.timestamp > myUser.timestamp) {
      return user;
    }
    return myUser;
  }, first);
};

// const getMaxRingDuration = (users: UserState[]) =>
//   users.reduce((maxRingDuration: number, user: UserState) => {
//     if (user.ringDuration && user.ringDuration > maxRingDuration) {
//       return user.ringDuration;
//     }

//     return maxRingDuration;
//   }, 0);

function setsAreDifferent(setA: Set<string>, setB: Set<string>) {
  return setA.size !== setB.size || Array.from(setA).some((item) => !setB.has(item));
}

// for headlines
Chart.register(ArcElement, ChartTooltip, CategoryScale, LinearScale, BarElement, Legend, Title);

const heightHandler = (setHeight: React.Dispatch<SetStateAction<number>>, incrimenter: string) => {
  if (incrimenter === 'increase') {
    return setHeight((p: number) => {
      // eslint-disable-next-line no-plusplus, no-param-reassign
      const v = p >= 2 ? 2 : ++p;
      localStorage.setItem('C2G-widget-height', JSON.stringify(v));
      return v;
    });
  }
  return setHeight((p: number) => {
    // eslint-disable-next-line no-plusplus, no-param-reassign
    const v = p <= 0 ? 0 : --p;
    localStorage.setItem('C2G-widget-height', JSON.stringify(v));
    return v;
  });
};

const headlinesHeightGetter = (height: number) => (height === 1 ? 243 : 208);
const headlinesSidebarHeightGetter = (height: number) => (height === 1 ? 219 : 184);
const borderHandler = (mode: string) => {
  if (mode === 'light') {
    return '2px solid #2196f3';
  }
  return '2px solid #2196f3';
};

// customized SVGs
const GrowIcon = ({ color, style }: { color: string; style: React.CSSProperties | undefined }) => (
  <svg
    id="uuid-aef2dc32-ffd4-4a0f-a8b0-a6087087b4c5"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={style}
  >
    <path
      style={{
        strokeWidth: 0,
        fill: color,
      }}
      d="M19.78,19.78H4.22V4.22h7.78v-2.22h-7.78c-1.23,0-2.22,1-2.22,2.22v15.56c0,1.22.99,2.22,2.22,2.22h15.56c1.22,0,2.22-1,2.22-2.22v-7.78h-2.22v7.78ZM14.22,2v2.22h3.99L7.29,15.14l1.57,1.57,10.92-10.92v3.99h2.22V2h-7.78Z"
    />
  </svg>
);

export const ShrinkIcon = ({ color, style }: { color: string; style: React.CSSProperties | undefined }) => (
  <svg
    id="uuid-468f3b88-d0b7-4762-b3f8-b3dee142a90f"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={style}
  >
    <path
      style={{
        strokeWidth: 0,
        fill: color,
      }}
      d="M19.78,19.78H4.22V4.22h7.78v-2.22h-7.78c-1.23,0-2.22,1-2.22,2.22v15.56c0,1.22.99,2.22,2.22,2.22h15.56c1.22,0,2.22-1,2.22-2.22v-7.78h-2.22v7.78ZM15.08,17v-2.31h-4.15L22.29,3.34l-1.63-1.63-11.35,11.35v-4.15h-2.31v8.08h8.08Z"
    />
  </svg>
);

const buttonColorSelector = (mode: string, isBarChart?: boolean) => {
  if (isBarChart) {
    return mode === 'light' ? '#2196f3' : '#2196f3';
  }
  return mode === 'light' ? '#fff' : '#2196f355';
};
function CreateLegend({
  graphData,
  mode,
  widgetSetting,
  data,
}: {
  graphData: WidgetGraphData;
  mode: string;
  widgetSetting: number;
  data: Map<string, number>;
}) {
  const widgetStyles = {
    color: mode === 'light' ? 'black' : 'white',
    fontSize: widgetSetting <= 1 ? '0.8em' : '0.9em',
  };

  function selectorlabel(title: string) {
    let itr;

    if (graphData.metric === undefined) {
      itr = Array.from(graphData.data.values()).reduce((acc: any, num: number) => acc + num, 0);
    } else {
      itr = Array.from(data.values()).reduce((sum: number, num: number) => sum + num, 0);
    }
    if (title === 'Queue Results' || title === 'Call States' || title === 'Call Type') {
      return `${itr} ${itr === 0 || itr > 1 ? 'Calls' : 'Call'}`;
    }
    if (title === 'Call Recordings') {
      return `${graphData.data.get('Recordings')! || 0} ${
        graphData.data.get('Recordings')! === 0 || graphData.data.get('Recordings')! > 1 ? 'Calls' : 'Call'
      }`;
    }
    if (title === 'Sentiment Score' || title === 'Call Results') {
      return `${itr} ${itr === 0 || itr > 1 ? 'Results' : 'Result'}`;
    }
    return ' ';
  }

  function LegendContainer({ bgs }: { bgs: string[] }) {
    return (
      <div className={`C2G-donut-legend legend-setting-${widgetSetting}`} style={{ height: 'calc(100% - 10px)' }}>
        <div className="C2G-widget-header-container">
          <h4 style={{ color: mode === 'light' ? '#444' : '#ccc' }} className="C2G-header-secondary">
            {graphData.title.substring(0, 1).toUpperCase() + graphData.title.substring(1)}
          </h4>
          <h2 style={{ color: mode === 'light' ? 'black' : 'white' }} className="C2G-header-primary">
            {selectorlabel(graphData.title)}
          </h2>
        </div>
        <div className="legend-container">
          {graphData.metric === undefined
            ? Array.from(graphData.data).map(([state, value], i) => (
                <div className={`C2G-legend-row setting-${widgetSetting}`}>
                  {/* eslint-disable-next-line react/destructuring-assignment */}
                  <div
                    className="C2G-legend-blip"
                    style={{
                      backgroundColor: bgs[i],
                      border: `1px solid ${bgs[i]}`,
                    }}
                  />
                  <Tooltip
                    arrow
                    placement="right"
                    title={
                      <span style={{ fontSize: '1.3em', margin: 0 }}>
                        {`(${value})`} {state.substring(0, 1) + state.substring(1).toLowerCase()}
                      </span>
                    }
                  >
                    <span style={widgetStyles}>{state.substring(0, 1) + state.substring(1).toLowerCase()}</span>
                  </Tooltip>
                </div>
              ))
            : Array.from(data).map(([state, value], i) => (
                <div className={`C2G-legend-row setting-${widgetSetting}`}>
                  {/* eslint-disable-next-line react/destructuring-assignment */}
                  <div
                    className="C2G-legend-blip"
                    style={{
                      backgroundColor: bgs[i],
                      border: `1px solid ${bgs[i]}`,
                    }}
                  />
                  <Tooltip
                    arrow
                    placement="right"
                    title={
                      <span style={{ fontSize: '1.3em', margin: 0 }}>
                        {`(${value})`} {state.substring(0, 1) + state.substring(1).toLowerCase()}
                      </span>
                    }
                  >
                    <span style={widgetStyles}>{state.substring(0, 1) + state.substring(1).toLowerCase()}</span>
                  </Tooltip>
                </div>
              ))}
        </div>
      </div>
    );
  }
  if (
    graphData.title === 'Queue Results' ||
    graphData.title === 'Call States' ||
    graphData.title === 'Call Type' ||
    graphData.title === 'Call Recordings'
  ) {
    return <LegendContainer bgs={chartBgs} />;
  }
  if (graphData.title === 'Call Results') {
    return <LegendContainer bgs={resultBgs} />;
  }
  if (graphData.title === 'Sentiment Score') {
    return <LegendContainer bgs={sentimentBgs} />;
  }
  return <></>;
}

export const chartBgs = ['#86CF6Ec0', '#EE6B6Bc0', '#FF9E1Cc0', '#00a2ffc0', '#ea07ffc0', '#6200ffc0', '#ff008cc0'];
export const resultBgs = [
  '#86CF6Ec0',
  '#EE6B6Bc0',
  '#ff6600c0',
  '#ffcc00c0',
  '#3399ccc0',
  '#990066c0',
  '#cc3399c0',
  '#ccee66c0',
  '#ff9900c0',
  '#004599c0',
];

export const sentimentBgs = ['#EE6B6Bc0', '#FF9E1Cc0', '#64BDFDc0', '#009AFFc0', '#86CF6Ec0'];

function handleOnDragEnd(
  r: any,
  graphData: Map<string, WidgetGraphData>,
  setGraphData: React.Dispatch<React.SetStateAction<Map<string, WidgetGraphData>>>,
) {
  const { source, destination, type } = r;
  if (!destination || !source) {
    return;
  }
  if (destination.droppableId === source.droppableId && source.index === destination.index) {
    return;
  }
  if (type !== 'group') {
    return;
  }
  const graphEntries = Array.from(graphData.entries());
  const [sourceEntry] = graphEntries.splice(source.index, 1);
  graphEntries.splice(destination.index, 0, sourceEntry);
  graphEntries.sort(([, a], [, b]) => {
    // move those hidden items
    if (!a.visible && b.visible) {
      return 1;
    }
    if (a.visible && !b.visible) {
      return -1;
    }
    return 0;
  });
  const configurations = Array.from(graphEntries).map(([key, value]) => ({
    key,
    visible: value.visible,
    title: value.title,
  }));

  localStorage.setItem('C2G-graphs', JSON.stringify(configurations));
  const newGraphData = new Map(graphEntries);

  setGraphData(newGraphData);
}

function handleSidebarOnDragEnd(result: any, layout: any, setLayout: any) {
  if (!result.destination) return;
  const items = Array.from(layout);
  const [reorderedItem] = items.splice(result.source.index, 1);
  items.splice(result.destination.index, 0, reorderedItem);
  localStorage.setItem('C2G-layout-config', JSON.stringify(items));
  setLayout(items);
}
function gapHandler(height: number, property: string) {
  switch (property) {
    case 'xs':
      if (height >= 2) {
        return 12;
      }
      break;
    case 'md':
      if (height >= 2) {
        return height === 2 ? 6 : 6;
      }
      break;
    case 'lg':
      if (height >= 2) {
        return height === 2 ? 4 : 6;
      }
      break;
    case 'xl':
      if (height >= 2) {
        return height === 2 ? 3 : 4;
      }
      return 0;
    default:
      return 0;
  }
  return 0;
}
function dimensionsHandler(setting: number, property: string) {
  switch (property) {
    case 'widgetWidth':
      if (setting === 0) {
        return 310;
      }
      if (setting === 1) {
        return 350;
      }
      if (setting === 2) {
        return '100%';
      }
      return '100%';
    case 'widgetHeight':
      if (setting === 0) {
        return 180;
      }
      if (setting === 1) {
        return 215;
      }
      if (setting === 2) {
        return 240;
      }
      return 280;
    case 'graphDimensions':
      if (setting === 0) {
        return 170;
      }
      if (setting === 1) {
        return 200;
      }
      if (setting === 2) {
        return '25%';
      }
      return 300;
    default:
      return 0;
  }
}

// still gotta work on this one, will be useful
const labelLine = {
  id: 'labelLine',
  afterDatasetsDraw(chart: any) {
    const {
      ctx,
      chartArea: { top, bottom, left, right, width, height },
    } = chart;
    chart.data.datasets.forEach((dataset: any, i: number) => {
      chart.getDatasetMeta(i).data.forEach((dp: any, j: number) => {
        const { x, y } = dp.tooltipPosition();
        const halfWidth = width / 2;
        const halfHeight = height / 2;
        const xLine = x >= halfWidth ? x + 15 : x - 15;
        const yLine = y >= halfHeight ? y + 10 : y - 10;
        const templateLine = x >= halfWidth ? 3 : -3;

        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(xLine, yLine);
        ctx.lineTo(xLine + templateLine, yLine);
        ctx.strokeStyle = dataset.borderColor[j];
        ctx.stroke();
        ctx.font = '10px Helvetica';
        ctx.color = 'white';
        ctx.textBaseline = 'bottom';
        ctx.fillStyle = dataset.borderColor[j];
        ctx.fillText(chart.data.labels[j], xLine, yLine);
      });
    });
  },
};
// const insertPercentage = {
//   id: "insertPercentage",
//   afterDatasetsDraw(chart: any) {
//     const {
//       ctx,
//       chartArea: { top, bottom, left, right, width, height },
//     } = chart;
//     chart.data.datasets.forEach((_: any, i: number) => {
//       chart.getDatasetMeta(i).data.forEach((dp: any, j: number) => {
//         const totals = Math.floor(
//           (chart.data.datasets[0].data[j] /
//             chart.data.datasets[0].data.reduce(
//               (acc: any, num: number) => acc + num,
//               0
//             )) *
//           100
//         );
//         const { x, y } = dp.tooltipPosition();
//         ctx.beginPath();
//         ctx.moveTo(
//           x >= width / 2 ? x + 2 : x - 2,
//           y >= height / 2 ? y + 2 : y - 2
//         );
//         ctx.font = "11px Helvetica";
//         ctx.color = "white";
//         ctx.textBaseline = "left";
//         ctx.fillStyle = "white";
//         if (!Number.isNaN(totals)) {
//           ctx.fillText(totals < 5 ? "" : `${totals}%`, x - 12, y + 4);
//         }
//       });
//     });
//   },
// };
const resetGraphData = (
  _graphData: Map<string, WidgetGraphData>,
  setGraphData: React.Dispatch<SetStateAction<Map<string, WidgetGraphData>>>,
) => {
  setGraphData((prevGraphData) => {
    const updatedGraphData = new Map(prevGraphData);
    updatedGraphData.forEach((graph) => {
      graph.data.forEach((_value, key, map) => {
        map.set(key, 0);
      });
    });
    return updatedGraphData;
  });
};

const C2GHeadlinesWidget = ({
  title,
  widgetSetting,
  graphData,
  mode,
  loading,
  filterRef,
  organizationId,
  indexesModified,
  isBarChart,
}: {
  title: string;
  widgetSetting: number;
  graphData: WidgetGraphData;
  mode: string;
  loading: boolean;
  filterRef: { [colId: string]: any };
  organizationId: string | undefined;
  indexesModified: number | undefined;
  isBarChart: boolean;
}) => {
  const [data, setData] = useState<Map<string, number>>(new Map());

  useEffect(() => {
    if (organizationId === undefined) {
      return;
    }
    if (indexesModified === undefined) {
      return;
    }
    if (graphData.metric) {
      let RESULTSET = Array.from(graphData.data.keys());
      const sets = Object.keys(filterRef).filter((key) => {
        if (key === graphData.metric) {
          RESULTSET = RESULTSET.filter((resultset) => filterRef[key].values.includes(resultset));

          return false;
        }

        return filterRef[key].filterType === 'set';
      });

      const ranges = Object.keys(filterRef).filter((key) => filterRef[key].filterType !== 'set');
      const potentialIndexes: Map<
        string,
        {
          set: string | undefined;
          // multiSet?: boolean;
          range: string;
        }
      > = new Map();

      if (sets.length) {
        sets.forEach((set) => {
          if (ranges.length) {
            ranges.forEach((range) => {
              // if (multiSetColumns.has(set)) {
              //   potentialIndexes.set(
              //     `${multiSetColumns.get(set)}_${graphData.metric}_${range}`,
              //     { set, multiSet: true, range }
              //   );
              // } else {
              potentialIndexes.set(`${graphData.metric}-${set}-${range}`, {
                set,
                range,
              });
              // }
            });
          } else {
            rangeColumns.forEach((range) => {
              // if (multiSetColumns.has(set)) {
              //   potentialIndexes.set(
              //     `${multiSetColumns.get(set)}_${graphData.metric}_${range}`,
              //     { set, multiSet: true, range }
              //   );
              // } else {
              potentialIndexes.set(`${graphData.metric}-${set}-${range}`, {
                set,
                range,
              });
              // }
            });
          }
        });
      } else if (ranges.length) {
        ranges.forEach((range) => {
          potentialIndexes.set(`${graphData.metric}-${range}`, {
            set: undefined,
            range,
          });
        });
      } else {
        rangeColumns.forEach((range) => {
          potentialIndexes.set(`${graphData.metric}-${range}`, {
            set: undefined,
            range,
          });
        });
      }

      if (db === null) {
        return;
      }

      const transaction = db.transaction([`calls-${organizationId}`], 'readonly');
      const objectStore = transaction.objectStore(`calls-${organizationId}`);

      const index = Array.from(potentialIndexes.keys()).find((name) => objectStore.indexNames.contains(name));

      if (index === undefined) {
        return;
      }

      const {
        set,
        range,
        // multiSet = false
      } = potentialIndexes.get(index)!;

      const myIndex = objectStore.index(index);

      const counts: Array<{ count: IDBRequest<number>; label: string }> = [];

      let lowerRange = -1;
      let upperRange: string | number = '\uffff';

      if (filterRef[range]) {
        if (filterRef[range].type === 'lessThan') {
          if (range === 'duration') {
            upperRange = parseInt(filterRef[range].filter, 10) * 1000;
          } else {
            upperRange = parseInt(filterRef[range].filter, 10);
          }
        }
        if (filterRef[range].type === 'moreThan') {
          if (range === 'duration') {
            lowerRange = parseInt(filterRef[range].filter, 10) * 1000;
          } else {
            lowerRange = parseInt(filterRef[range].filter, 10);
          }
        }
        if (filterRef[range].type === 'between') {
          if (range === 'duration') {
            lowerRange = parseInt(filterRef[range].filter, 10) * 1000;
            upperRange = parseInt(filterRef[range].filterTo, 10) * 1000;
          } else {
            lowerRange = parseInt(filterRef[range].filter, 10);
            upperRange = parseInt(filterRef[range].filterTo, 10);
          }
        }
      }

      if (set === undefined) {
        RESULTSET.forEach((resultset) => {
          counts.push({
            count: myIndex.count(IDBKeyRange.bound([resultset, lowerRange], [resultset, upperRange])),
            label: `${resultset}`,
          });
        });
      } else {
        filterRef[set].values.forEach((value: string) => {
          RESULTSET.forEach((resultset) => {
            // if (multiSet) {
            //   counts.push({
            //     count: myIndex.count(
            //       IDBKeyRange.bound(
            //         [value, resultset, lowerRange],
            //         [value, resultset, upperRange]
            //       )
            //     ),
            //     label: `${resultset}-${value}`,
            //   });
            // } else {
            counts.push({
              count: myIndex.count(IDBKeyRange.bound([resultset, value, lowerRange], [resultset, value, upperRange])),
              label: `${resultset}-${value}`,
            });
            // }
          });
        });
      }
      (async () => {
        await Promise.all(
          counts.map(
            ({ count, label }) =>
              new Promise((resolve) => {
                // eslint-disable-next-line no-param-reassign
                count.onsuccess = () => {
                  resolve({ count: count.result, label });
                };
              }),
          ),
        ).then((temp: Array<any>) => {
          setData(() =>
            temp.reduce((sum, { count, label }) => {
              const update = new Map(sum);

              update.set(label.split('-')[0], (update.get(label.split('-')[0]) || 0) + count);

              return update;
            }, new Map() as Map<string, number>),
          );
        });
      })();
    }
  }, [filterRef, organizationId, indexesModified]);

  return (
    <div
      className="C2G-widget-container"
      style={{
        width: widgetSetting > 1 ? '' : dimensionsHandler(widgetSetting, 'widgetWidth'),
        background:
          mode === 'light' ? 'linear-gradient(0deg, #f7f7f7, #ffffff)' : 'linear-gradient(10deg, #141414, #252829)',
        border: mode === 'light' ? '1px solid #cecece' : '1px solid #363c3f',
        boxShadow:
          mode === 'light'
            ? 'inset 0px -7px 19px #ebf1ff6e, inset 0px -3px 3px #dde4ff6a'
            : 'inset 100px -49px 79px #17171787',
        height: widgetSetting > 1 ? '' : dimensionsHandler(widgetSetting, 'widgetHeight'),
        margin: widgetSetting <= 1 ? 3 : 0,
        // aspectRatio: widgetSetting > 1 ? '5/7' : '3/2'
      }}
    >
      <div className="C2G-donut-container">
        <div
          className="C2G-donut"
          style={{
            width: '100%',
            height: '100%',
            //  width: isBarChart ? "90%" : donutDimensionsHandler(widgetSetting, "graphDimensions"),
            //  height: isBarChart ? barDimensionsHandler(widgetSetting, "graphDimensions") : donutDimensionsHandler(widgetSetting, "graphDimensions"),
          }}
        >
          {loading ? (
            <div className="loader" />
          ) : (
            <>
              {
                // donut configs
                !isBarChart && (
                  <>
                    {title === 'Call States' && (
                      <Doughnut
                        plugins={[]}
                        options={{
                          layout: {
                            padding: widgetSetting > 1 ? 10 : 20,
                          },
                          responsive: true,
                          aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                          plugins: {
                            title: {
                              display: true,
                              align: widgetSetting > 1 ? 'start' : 'center',
                              color: mode === 'light' ? 'black' : 'white',
                              padding: 0,
                              font: {
                                size: 17,
                              },
                              text: `Call States - ${Array.from(graphData.data.values()).reduce(
                                (acc: any, num: number) => acc + num,
                                0,
                              )} results`,
                            },
                            legend: {
                              display: widgetSetting > 1,
                              position: 'right',
                              align: 'center',
                              rtl: true,
                              labels: {
                                usePointStyle: true,
                                pointStyle: 'rectRounded',
                                color: mode === 'light' ? '#333' : '#ccc',
                                font: {
                                  size: 10,
                                  style: 'normal',
                                },
                              },
                            },
                          },
                        }}
                        data={{
                          labels: Array.from(graphData.data.keys()),
                          datasets: [
                            {
                              data: Array.from(graphData.data.values()),
                              backgroundColor: chartBgs,
                              borderColor: chartBgs,
                              borderWidth: 1,
                            },
                          ],
                        }}
                      />
                    )}
                    {title === 'Sentiment Score' && (
                      <Doughnut
                        plugins={[]}
                        options={{
                          cutout: widgetSetting <= 1 ? '67%' : '70%',
                          layout: {
                            padding: widgetSetting > 1 ? 10 : 20,
                          },
                          responsive: true,
                          aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                          plugins: {
                            title: {
                              display: true,
                              align: widgetSetting > 1 ? 'start' : 'center',
                              color: mode === 'light' ? 'black' : 'white',
                              padding: 0,
                              font: {
                                size: 17,
                              },
                              text: `Sentiment Score - ${Array.from(graphData.data.values()).reduce(
                                (acc: any, num: number) => acc + num,
                                0,
                              )} results`,
                            },
                            legend: {
                              display: widgetSetting > 1,
                              position: 'right',
                              align: 'center',
                              rtl: true,
                              labels: {
                                usePointStyle: true,
                                pointStyle: 'rectRounded',
                                color: mode === 'light' ? '#333' : '#ccc',
                                font: {
                                  size: 10,
                                  style: 'normal',
                                },
                              },
                            },
                          },
                        }}
                        data={{
                          labels: Array.from(graphData.data.keys()),
                          datasets: [
                            {
                              data: Array.from(graphData.data.values()),
                              backgroundColor: sentimentBgs,
                              borderColor: sentimentBgs,
                              borderWidth: 1,
                              circumference: 190,
                              rotation: 265,
                            },
                          ],
                        }}
                      />
                    )}
                    {title === 'Call Type' && (
                      <Pie
                        options={{
                          responsive: true,
                          aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                          plugins: {
                            title: {
                              display: true,
                              align: widgetSetting > 1 ? 'start' : 'center',
                              color: mode === 'light' ? 'black' : 'white',
                              padding: 0,
                              font: {
                                size: 17,
                              },
                              text: `Call Type - ${Array.from(graphData.data.values()).reduce(
                                (acc: any, num: number) => acc + num,
                                0,
                              )} results`,
                            },
                            legend: {
                              display: widgetSetting > 1,
                              position: 'right',
                              rtl: true,
                              align: 'center',
                              labels: {
                                usePointStyle: true,
                                pointStyle: 'rectRounded',
                                color: mode === 'light' ? '#333' : '#ccc',
                                font: {
                                  size: 10,
                                  style: 'normal',
                                },
                              },
                            },
                          },
                          layout: {
                            padding: widgetSetting > 1 ? 10 : 20,
                          },
                        }}
                        data={{
                          labels: Array.from(data.keys()),
                          datasets: [
                            {
                              data: Array.from(data.values()),
                              backgroundColor: chartBgs,
                              borderColor: chartBgs,
                              borderWidth: 1,
                            },
                          ],
                        }}
                      />
                    )}
                    {title === 'Call Recordings' && (
                      <Doughnut
                        options={{
                          responsive: true,
                          aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                          plugins: {
                            title: {
                              display: true,
                              align: widgetSetting > 1 ? 'start' : 'center',
                              color: mode === 'light' ? 'black' : 'white',
                              padding: 0,
                              font: {
                                size: 17,
                              },
                              text: `Call Recordings - ${Array.from(graphData.data.values()).reduce(
                                (acc: any, num: number) => acc + num,
                                0,
                              )} results`,
                            },
                            legend: {
                              display: widgetSetting > 1,
                              rtl: true,
                              position: 'right',
                              align: 'center',
                              labels: {
                                usePointStyle: true,
                                pointStyle: 'rectRounded',
                                color: mode === 'light' ? '#333' : '#ccc',
                                font: {
                                  size: 10,
                                  style: 'normal',
                                },
                              },
                            },
                          },
                          layout: {
                            padding: widgetSetting > 1 ? 10 : 20,
                          },
                        }}
                        data={{
                          labels: ['Recordings', 'Transcripts'],
                          datasets: [
                            {
                              data: Array.from(graphData.data.values()),
                              backgroundColor: chartBgs,
                              borderColor: chartBgs,
                              borderWidth: 1,
                            },
                          ],
                        }}
                      />
                    )}
                    {title === 'Call Results' && (
                      <Doughnut
                        options={{
                          responsive: true,
                          aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                          plugins: {
                            title: {
                              display: true,
                              align: widgetSetting > 1 ? 'start' : 'center',
                              color: mode === 'light' ? 'black' : 'white',
                              font: {
                                size: 17,
                              },
                              padding: {
                                bottom: 15,
                              },
                              text: `Call Results - ${Array.from(data.values()).reduce(
                                (acc: any, num: number) => acc + num,
                                0,
                              )} results`,
                            },
                            legend: {
                              display: widgetSetting > 1,
                              position: 'right',
                              align: 'center',
                              rtl: true,
                              labels: {
                                usePointStyle: true,
                                pointStyle: 'rectRounded',
                                color: mode === 'light' ? '#333' : '#ccc',
                                font: {
                                  size: 10,
                                  style: 'normal',
                                },
                              },
                            },
                          },
                          layout: {
                            padding: widgetSetting > 1 ? 10 : 20,
                          },
                        }}
                        data={{
                          labels: Array.from(data.keys() || []),
                          datasets: [
                            {
                              data: Array.from(data.values() || []),
                              backgroundColor: resultBgs,
                              borderColor: resultBgs,
                              borderWidth: 1,
                            },
                          ],
                        }}
                      />
                    )}
                    {title === 'Platform Transfers' && (
                      <Doughnut
                        options={{
                          responsive: true,
                          aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                          plugins: {
                            title: {
                              display: true,
                              align: widgetSetting > 1 ? 'start' : 'center',
                              color: mode === 'light' ? 'black' : 'white',
                              padding: 0,
                              font: {
                                size: 17,
                              },
                              text: `Platform Transfers - ${Array.from(data.values()).reduce(
                                (acc: any, num: number) => acc + num,
                                0,
                              )} transfers`,
                            },
                            legend: {
                              display: widgetSetting > 1,
                              position: 'right',
                              align: 'center',
                              rtl: true,
                              labels: {
                                usePointStyle: true,
                                pointStyle: 'rectRounded',
                                color: mode === 'light' ? '#333' : '#ccc',
                                font: {
                                  size: 10,
                                  style: 'normal',
                                },
                              },
                            },
                          },
                          layout: {
                            padding: widgetSetting > 1 ? 10 : 20,
                          },
                        }}
                        data={{
                          labels: Array.from(data.keys() || []),
                          datasets: [
                            {
                              data: Array.from(data.values() || []),
                              backgroundColor: resultBgs,
                              borderColor: resultBgs,
                              borderWidth: 1,
                            },
                          ],
                        }}
                      />
                    )}
                  </>
                )
              }
              {isBarChart && (
                <>
                  {title === 'Call Results' && (
                    <Bar
                      options={{
                        responsive: true,
                        aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                        plugins: {
                          title: {
                            display: true,
                            color: mode === 'light' ? 'black' : 'white',
                            font: {
                              size: 17,
                            },
                            text: `Call Results - ${Array.from(graphData.data.values()).reduce(
                              (acc: any, num: number) => acc + num,
                              0,
                            )} results`,
                          },
                          legend: {
                            display: false,
                            labels: {
                              color: mode === 'light' ? '#333' : '#ddd',
                              font: {
                                size: 10,
                              },
                            },
                          },
                        },
                        layout: {
                          padding: 15,
                        },
                        scales: {
                          x: {
                            ticks: {
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                          y: {
                            ticks: {
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                        },
                      }}
                      data={{
                        labels: Array.from(data)
                          .sort((a, b) => b[1] - a[1])
                          .map(([key, _]) => key)
                          .slice(0, 5),
                        datasets: [
                          {
                            data: Array.from(data)
                              .sort((a, b) => b[1] - a[1])
                              .map(([_, value]) => value)
                              .slice(0, 5),
                            backgroundColor: resultBgs,
                            borderColor: resultBgs,
                            borderWidth: 1,
                          },
                        ],
                      }}
                    />
                  )}
                  {title === 'Call States' && (
                    <Bar
                      options={{
                        responsive: true,
                        aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                        plugins: {
                          title: {
                            display: true,
                            color: mode === 'light' ? 'black' : 'white',
                            font: {
                              size: 17,
                            },
                            text: `Call States - ${Array.from(graphData.data.values()).reduce(
                              (acc: any, num: number) => acc + num,
                              0,
                            )} results`,
                          },
                          legend: {
                            display: false,
                            labels: {
                              color: mode === 'light' ? '#333' : '#ddd',
                              font: {
                                size: 10,
                              },
                            },
                          },
                        },
                        layout: {
                          padding: 15,
                        },
                        scales: {
                          x: {
                            ticks: {
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                          y: {
                            ticks: {
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                        },
                      }}
                      data={{
                        labels: Array.from(graphData.data.keys()),
                        datasets: [
                          {
                            data: Array.from(graphData.data.values()),
                            backgroundColor: chartBgs,
                            borderColor: chartBgs,
                            borderWidth: 1,
                          },
                        ],
                      }}
                    />
                  )}
                  {title === 'Sentiment Score' && (
                    <Bar
                      plugins={isBarChart ? [] : []}
                      options={{
                        aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                        responsive: true,
                        plugins: {
                          title: {
                            display: true,
                            color: mode === 'light' ? 'black' : 'white',
                            font: {
                              size: 17,
                            },
                            text: `Sentiment Score - ${Array.from(graphData.data.values()).reduce(
                              (acc: any, num: number) => acc + num,
                              0,
                            )} results`,
                          },
                          legend: {
                            display: false,
                            labels: {
                              color: mode === 'light' ? '#333' : '#ddd',
                              font: {
                                size: 10,
                              },
                            },
                          },
                        },
                        layout: {
                          padding: 15,
                        },
                        scales: {
                          x: {
                            ticks: {
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                          y: {
                            ticks: {
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                        },
                      }}
                      data={{
                        labels: Array.from(graphData.data.keys()),
                        datasets: [
                          {
                            data: Array.from(graphData.data.values()),
                            backgroundColor: sentimentBgs,
                            borderColor: sentimentBgs,
                            borderWidth: 1,
                          },
                        ],
                      }}
                    />
                  )}
                  {title === 'Call Type' && (
                    <Bar
                      options={{
                        responsive: true,
                        aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                        plugins: {
                          title: {
                            display: true,
                            color: mode === 'light' ? 'black' : 'white',
                            font: {
                              size: 17,
                            },
                            text: `Call Type - ${Array.from(graphData.data.values()).reduce(
                              (acc: any, num: number) => acc + num,
                              0,
                            )} results`,
                          },
                          legend: {
                            display: false,
                            labels: {
                              color: mode === 'light' ? '#333' : '#ddd',
                              font: {
                                size: 10,
                              },
                            },
                          },
                        },
                        layout: {
                          padding: 15,
                        },
                        scales: {
                          x: {
                            ticks: {
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                          y: {
                            ticks: {
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                        },
                      }}
                      data={{
                        labels: Array.from(data.keys()),
                        datasets: [
                          {
                            data: Array.from(data.values()),
                            backgroundColor: chartBgs,
                            borderColor: chartBgs,
                            borderWidth: 1,
                          },
                        ],
                      }}
                    />
                  )}
                  {title === 'Call Recordings' && (
                    <Bar
                      options={{
                        responsive: true,
                        aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                        plugins: {
                          title: {
                            display: true,
                            color: mode === 'light' ? 'black' : 'white',
                            font: {
                              size: 17,
                            },
                            text: `Call Recordings - ${Array.from(graphData.data.values()).reduce(
                              (acc: any, num: number) => acc + num,
                              0,
                            )} results`,
                          },
                          legend: {
                            display: false,
                            labels: {
                              color: mode === 'light' ? '#333' : '#ddd',
                              font: {
                                size: 10,
                              },
                            },
                          },
                        },
                        layout: {
                          padding: 15,
                        },
                        scales: {
                          x: {
                            ticks: {
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                          y: {
                            stacked: true,
                            ticks: {
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                        },
                      }}
                      data={{
                        labels: ['Recordings', 'Transcripts'],
                        datasets: [
                          {
                            data: Array.from(graphData.data.values()),
                            backgroundColor: chartBgs,
                            borderColor: chartBgs,
                            borderWidth: 1,
                          },
                        ],
                      }}
                    />
                  )}
                  {title === 'Platform Transfers' && (
                    <Bar
                      options={{
                        responsive: true,
                        aspectRatio: widgetSetting > 1 ? 1.4 : 1.5,
                        plugins: {
                          title: {
                            display: true,
                            color: mode === 'light' ? 'black' : 'white',
                            font: {
                              size: 17,
                            },
                            text: `Platform Transfers - ${
                              Array.from(graphData?.data?.values())?.[0] &&
                              Array.from(graphData?.data?.values())?.[1] &&
                              Array.from(graphData?.data?.values())?.[0]?.reduce(
                                (acc: any, num: number) => acc + num,
                                0,
                              ) +
                                Array.from(graphData?.data?.values())?.[1]?.reduce(
                                  (acc: any, num: number) => acc + num,
                                  0,
                                )
                            } results`,
                          },
                          legend: {
                            display: false,
                            labels: {
                              color: mode === 'light' ? '#333' : '#ddd',
                              font: {
                                size: 10,
                              },
                            },
                          },
                        },
                        layout: {
                          padding: 15,
                        },
                        scales: {
                          x: {
                            stacked: true,
                            ticks: {
                              stepSize: 5,
                              precision: 0,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                          y: {
                            stacked: true,
                            ticks: {
                              precision: 0,
                              stepSize: 5,
                              color: mode === 'light' ? 'black' : 'white',
                              autoSkip: false,
                              font: {
                                size: 8 + widgetSetting,
                              },
                            },
                          },
                        },
                      }}
                      data={{
                        labels: ['CX', 'EX'],
                        datasets: [
                          {
                            //   transfers from
                            data: Array.from(graphData.data.values())?.map((arr) => arr[0]),
                            borderColor: chartBgs,
                            backgroundColor: chartBgs,
                            borderWidth: 1,
                          },
                          {
                            //  transfers to
                            data: Array.from(graphData.data.values())?.map((arr) => arr[1]),
                            borderColor: chartBgs.reverse(),
                            backgroundColor: chartBgs.reverse(),
                            borderWidth: 1,
                          },
                        ],
                      }}
                    />
                  )}
                </>
              )}
            </>
          )}
        </div>
        {/* <CreateLegend
          graphData={graphData}
          mode={mode}
          widgetSetting={widgetSetting}
          data={data}
        /> */}
      </div>
    </div>
  );
};

let dateChanged: number;

const mockTranscript = [
  {
    end: 2.36,
    text: 'This call is being recorded.',
    start: 0.44,
    speakerId: 'UNKNOWN_SPEAKER_1',
  },
  {
    end: 11,
    text: 'This is a test.',
    start: 9.4,
    speakerId: 'p-a78ce150b5102z19884a504a2z30a9d0000-1',
  },
  {
    end: 14.44,
    text: "I'm going to hang up.",
    start: 12.92,
    speakerId: 'p-a78ce150b5102z19884a504a2z30a9d0000-1',
  },
];

const formatTranscriptFloatsToMMSS = (start: number) => {
  const diff = Math.abs(start);
  const minutes = Math.floor(diff / 60);
  const seconds = Math.floor(diff % 60);
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
export default function C2GReport({
  token,
  mode,
  organizationId,
  cxToken,
  cxMessages,
  setCxMessages,
  //   ringSenseEvents,
  //   setRingSenseEvents,
  leaderboardUrl,
  historicalUsers,
  historicalQueues,
  cxAgents,
  legacyUI,
  cxEnabled,
  realTimeUserStates,
  setRealTimeUserStates,
}: {
  token: string;
  mode: string;
  organizationId: string | undefined;
  cxToken: string | null;
  cxMessages: Array<Array<CXExtension>>;
  setCxMessages: React.Dispatch<React.SetStateAction<Array<Array<CXExtension>>>>;
  //   ringSenseEvents: Array<Array<RingSenseEvent>>;
  //   setRingSenseEvents: React.Dispatch<React.SetStateAction<Array<Array<RingSenseEvent>>>>;
  leaderboardUrl: string | undefined;
  historicalUsers: any;
  historicalQueues: any;
  cxAgents: CXAgent[] | undefined;
  legacyUI: boolean;
  cxEnabled: boolean;
  realTimeUserStates: Array<UserState>;
  setRealTimeUserStates: React.Dispatch<React.SetStateAction<Array<UserState>>>;
}) {
  const [lastIndex, setLastIndex] = useState('');
  const [dbVersion, setDbVersion] = useState(version);
  const [reportFilter, setReportFilter] = useState<Model>();
  const [dbCleared, setDbCleared] = useState<boolean>(true);
  const [dbCreated, setDbCreated] = useState<boolean>(false);
  const [dbDeleted, setDbDeleted] = useState<boolean>(false);
  const [gridReady, setGridReady] = useState<boolean>(false);
  const [indexesModified, setIndexesModified] = useState<undefined | number>();
  const [ws, setWs] = useState<WebSocket | undefined>();
  const [wsError, setWsError] = useState<boolean>(false);
  const [, setRetries] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [callLog, setCallLog] = useState<undefined | CallLeg[]>();

  const [userStateData, setUserStateData] = useState<Array<Array<UserState>>>([]);
  const [processingUserState, setProcessingUserState] = useState<Array<UserState> | undefined>();
  const [processingCxMessage, setProcessingCxMessage] = useState<Array<CXExtension> | undefined>();
  //   const [processingRingSenseEvent, setProcessingRingSenseEvent] = useState<Array<RingSenseEvent> | undefined>();
  const [dateRangeSelected, setDateRangeSelected] = useState<string>('initial');
  const [openRangeForm, setOpenRangeForm] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const startTimeRef = useRef<HTMLInputElement | null>(null);
  const endTimeRef = useRef<HTMLInputElement | null>(null);
  const gridRef = useRef<AgGridReact>(null);
  const [gridHeightValue, setGridHeightValue] = useState(4);
  const [fontValue, setFontValue] = useState(1);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [sidebarOptions, setSidebarOptions] = useState('');
  //   const [selectedC2Ginfo, setSelectedC2GInfo] = useState<Call | undefined>();
  const [progress, setProgress] = useState<number>(0);
  const [filterRef, setFilterRef] = useState<{ [colId: string]: any }>({});
  const [summaryFilterRef, setSummaryFilterRef] = useState<{
    [colId: string]: any;
  }>({});
  const [expandedAccordions, setCallsAccordionExpanded] = useState({
    calls: true,
    headlines: true,
    timeline: true,
    c2g: true,
    report: true,
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [widgetSetting, setWidgetSetting] = useState<number>(1);
  const [timelineEvents, setTimelineEvents] = useState<any>();
  const [transferEvents, setTransferEvents] = useState<{
    from?: any;
    to?: any;
    fromLeg?: any;
    toLeg?: any;
  }>();

  const [recordingsDisplay, setRecordingsDisplay] = useState<
    Array<{ id: String; recordingUrl: string | undefined; transcriptUrl: string | undefined }> | undefined
  >();
  const [layout, setLayout] = useState([
    {
      title: 'Calls',
      visible: true,
    },
    {
      title: 'Report',
      visible: true,
    },
    // {
    //   title: "Headlines",
    //   visible: true,
    // },
    {
      title: 'Transcript & Playback',
      visible: true,
    },
    {
      title: 'Cradle to Grave',
      visible: true,
    },
  ]);
  const [graphData, setGraphData] = useState<Map<string, WidgetGraphData>>(
    new Map([
      [
        'Sentiment Score',
        {
          data: new Map([
            ['Very Negative', 0],
            ['Negative', 0],
            ['Neutral', 0],
            ['Positive', 0],
            ['Very Positive', 0],
          ]),
          visible: true,
          title: 'Sentiment Score',
          isBarChart: false,
        },
      ],
      [
        'Call Results',
        {
          data: new Map([
            ['COMPLETE', 0],
            ['ABANDONED', 0],
            ['TRANSFERRED', 0],
            ['MISSED', 0],
            ['ABANDONED VOICEMAIL', 0],
            ['LEFT VOICEMAIL', 0],
            ['FAX RECEIVED', 0],
            ['QUEUE ABANDONED', 0],
            ['QUEUE LEFT VOICEMAIL', 0],
            ['QUEUE ABANDONED VOICEMAIL', 0],
          ]),
          visible: true,
          title: 'Call Results',
          metric: 'result',
          isBarChart: false,
        },
      ],
      [
        'Call States',
        {
          data: new Map([
            ['TALKING', 0],
            ['HOLDING', 0],
            ['RINGING', 0],
            ['TO VOICEMAIL', 0],
            ['NOT CONNECTED', 0],
            ['FAX INCOMING', 0],
            ['TALKING', 0],
          ]),
          visible: true,
          title: 'Call States',
          isBarChart: false,
        },
      ],
      [
        'Call Type',
        {
          data: new Map([
            ['Inbound', 0],
            ['Outbound', 0],
            ['Internal', 0],
          ]),
          visible: true,
          title: 'Call Type',
          metric: 'direction',
          isBarChart: false,
        },
      ],
      [
        'Call Recordings',
        {
          data: new Map([
            ['Recordings', 0],
            ['Transcripts', 0],
          ]),
          visible: true,
          title: 'Call Recordings',
          isBarChart: true,
        },
      ],
      [
        'Platform Transfers',
        {
          data: new Map([
            //     CX transfer from     CX transfer to
            ['CX', [1, 2]],
            //     EX transfer from     EX transfer to
            ['EX', [3, 4]],
          ]),
          visible: true,
          title: 'Platform Transfers',
          isBarChart: true,
        },
      ],
    ]),
  );
  const [fromPhoneLoaded, setFromPhoneLoaded] = useState<boolean>(false);
  const [toPhoneLoaded, setToPhoneLoaded] = useState<boolean>(false);
  const [resultLoaded, setResultLoaded] = useState<boolean>(false);
  const [dispositionLoaded, setDispositionLoaded] = useState<boolean>(false);
  const [callScoreLoaded, setCallScoreLoaded] = useState<boolean>(false);
  const [headlinesEnabled, setHeadlinesEnabled] = useState(false);
  const textColor = useCallback((m: string) => (m === 'light' ? 'white' : 'white'), [mode]);
  const [fetchedTranscript, setFetchedTranscript] = useState<
    undefined | Array<{ start: number; end: number; text: string }>
  >(undefined);
  const recordingPlayerRef = useRef<HTMLAudioElement | null>(null);

  const recordingNavigation = (time: number) => {
    if (recordingPlayerRef && recordingPlayerRef.current) {
      recordingPlayerRef.current.currentTime = Math.floor(time);
      recordingPlayerRef.current.play();
    }
  };

  useEffect(() => {
    if (!recordingsDisplay || recordingsDisplay.length === 0 || recordingsDisplay[0].transcriptUrl === undefined)
      return;

    const fetchTranscript = async () => {
      if (recordingsDisplay[0].transcriptUrl === undefined) return;
      try {
        const transcriptRes = await fetch(recordingsDisplay[0].transcriptUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!transcriptRes.ok) {
          throw new Error('Failed to fetch transcript resource URL');
        }

        const transcriptData = await transcriptRes.json();
        setFetchedTranscript(transcriptData);
      } catch (err: any) {
        setError(err.message);
      }
    };

    fetchTranscript();
  }, [leaderboardUrl, recordingsDisplay, token]);

  useEffect(() => {
    if (gridReady) {
      const savedGridConfig = localStorage.getItem('C2G-saveGridConfig');
      if (savedGridConfig) {
        gridRef.current?.columnApi.applyColumnState({
          state: JSON.parse(savedGridConfig),
          applyOrder: true,
        });
      }
    }
  }, [gridReady]);

  useEffect(() => {
    const getConfig = localStorage.getItem('C2G-layout-config');
    const getSidebarConfig = localStorage.getItem('C2G-sidebar');
    const getGraphs = localStorage.getItem('C2G-graphs');
    const getHeight = localStorage.getItem('C2G-widget-height');
    if (getHeight) {
      setWidgetSetting(JSON.parse(getHeight));
    }
    if (getGraphs) {
      const graphsPulledFromStorage = JSON.parse(getGraphs);
      const newGraphMap = new Map();

      graphsPulledFromStorage.forEach(
        (graph: { key: string; visible: boolean; title: string; isBarChart: boolean }) => {
          const existingPulledGraph = graphData.get(graph.key);
          if (existingPulledGraph) {
            const newGraph = {
              ...existingPulledGraph,
              visible: graph.visible,
              title: graph.title,
              isBarChart: graph.isBarChart,
            };
            newGraphMap.set(graph.key, newGraph);
          }
        },
      );
      if (!newGraphMap.get('Platform Transfers')) {
        newGraphMap.set('Platform Transfers', {
          data: new Map([
            ['CX', [0, 0]],
            ['EX', [0, 0]],
          ]),
          visible: true,
          title: 'Platform Transfers',
          isBarChart: true,
        });
      }
      setGraphData(newGraphMap);
    }
    if (getConfig) {
      setLayout(JSON.parse(getConfig));
    }
    if (getSidebarConfig) {
      setOpenSidebar(JSON.parse(getSidebarConfig));
    }
  }, []);

  const handleDateRangeClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event?.currentTarget);
  }, []);
  const handleDateRangeClose = useCallback(() => {
    setAnchorEl(null);
    setOpenRangeForm(false);
  }, []);

  const convertIndexFilterValue = useCallback((value: string) => {
    setError(undefined);
    try {
      return new Date(value).toISOString();
    } catch (err) {
      console.log('err', err);
      setError('Invalid filter value');
      return undefined;
    }
  }, []);

  useEffect(() => {
    if (wsError) {
      return;
    }

    let cb: any;
    let temp: WebSocket;

    const connect = () => {
      //   console.log("connect");
      clearTimeout(cb);

      //   if (
      //     dateRangeSelected === "yesterday" ||
      //     dateRangeSelected === "lastMonth" ||
      //     dateRangeSelected === "last7Days" ||
      //     (dateRangeSelected.includes(",") &&
      //       dateRangeSelected.split(",")[1] !== "")
      //   ) {
      //     setWs((oldWs) => {
      //       oldWs?.close();
      //       return undefined;
      //     });

      //     return;
      //   }

      // dateRangeSelected can create duplicated websockets - close any existing WebSocket connection before creating a new one
      //   setWs((oldWs) => {
      //     oldWs?.close();
      //     return undefined;
      //   });

      cb = setTimeout(connect, 90 * 60 * 1000);

      temp = new WebSocket(`wss://dtifs6pvi5.execute-api.eu-west-2.amazonaws.com/production/?authorization=${token}`);

      temp.onclose = () => {
        console.log('reconnecting...');
        setRetries((retry) => {
          if (retry < MAX_RETRY) {
            cb = setTimeout(connect, 1000);
          } else {
            setWsError(true);
          }
          return retry + 1;
        });
      };

      temp.onerror = (err) => {
        console.log(err);
        clearTimeout(cb);
        setWsError(true);
      };

      temp.onopen = () => {
        setRetries(0);

        setWs(temp);
      };
    };

    connect();

    // eslint-disable-next-line consistent-return
    return () => {
      if (temp) {
        temp.close();
      }
      clearTimeout(cb);
    };
  }, [wsError]);

  const listener = useCallback((event: any) => {
    const data = JSON.parse(event.data) as UserState | Event;
    if ('pong' in data) {
      // ping();
    } else if ('event' in data) {
      // nothing
    } else {
      const myData = data as UserState;
      setRealTimeUserStates((oldRealTimeUserStates) => oldRealTimeUserStates.concat([myData]));
      newEventsReceived = true;
    }
  }, []);

  useEffect(() => {
    if (ws === undefined) {
      return;
    }

    // console.log("add event listener");
    ws.addEventListener('message', listener);

    // eslint-disable-next-line consistent-return
    return () => {
      ws.removeEventListener('message', listener);
    };
  }, [ws, listener]);

  useEffect(() => {
    if (ws === undefined) {
      return;
    }

    let callback: any;

    const ping = () => {
      callback = setTimeout(() => {
        // console.log("ping");
        ws.send(JSON.stringify({ action: 'ping' }));

        ping();
      }, 30 * 1000);
    };

    ping();

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(callback);
    };
  }, [ws]);

  const findSetValues = useCallback(
    async (indexName: string) =>
      new Promise<string[]>((resolve, reject) => {
        if (db !== null) {
          const transaction = db.transaction([`calls-${organizationId}`], 'readonly');
          const objectStore = transaction.objectStore(`calls-${organizationId}`);
          const index = objectStore.index(indexName);
          const uniqueValues: Set<string> = new Set();
          const cursorRequest = index.openKeyCursor(null, 'nextunique');
          // eslint-disable-next-line consistent-return
          cursorRequest.onsuccess = (event) => {
            const cursor = (event.target as IDBRequest).result;

            if (cursor) {
              // Push the unique key into the array
              uniqueValues.add(cursor.key);
              cursor.continue(); // Move to the next unique value
            } else {
              // All unique values processed
              resolve(Array.from(uniqueValues));
            }
          };
          cursorRequest.onerror = (event) => {
            console.error('Error opening to key cursor');
            reject((event.target as IDBRequest).error);
          };
        }
      }),
    [organizationId],
  );

  const getFromPhoneValues = useCallback(
    async (params: SetFilterValuesFuncParams) => {
      const myValues = await findSetValues('fromPhoneNumber');
      setFromPhoneLoaded(true);
      params.success(myValues);
    },
    [organizationId],
  );

  const getToPhoneValues = useCallback(
    async (params: SetFilterValuesFuncParams) => {
      const myValues = await findSetValues('toPhoneNumber');
      setToPhoneLoaded(true);
      params.success(myValues);
    },
    [organizationId],
  );

  const getResultValues = useCallback(
    async (params: SetFilterValuesFuncParams) => {
      const myValues = await findSetValues('result');
      setResultLoaded(true);
      params.success(myValues);
    },
    [organizationId],
  );

  const getDispositionValues = useCallback(
    async (params: SetFilterValuesFuncParams) => {
      const myValues = await findSetValues('disposition');
      setDispositionLoaded(true);
      params.success(myValues);
    },
    [organizationId],
  );

  const getCallScoreValues = useCallback(
    async (params: SetFilterValuesFuncParams) => {
      const myValues = await findSetValues('callScore');
      setCallScoreLoaded(true);
      params.success(myValues);
    },
    [organizationId],
  );

  const columnDefs = useMemo(
    () => [
      {
        field: 'index',
        headerName: 'Date Time',
        sort: 'desc' as const,
        sortingOrder: ['asc' as const, 'desc' as const],
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true,
          buttons: ['apply', 'reset'],
          filterOptions: [
            {
              displayKey: 'lessThan',
              displayName: 'Before',
              predicate: ([filterValue]: [string], cellValue: string) => cellValue < filterValue,
            },
            {
              displayKey: 'moreThan',
              displayName: 'After',
              predicate: ([filterValue]: [string], cellValue: string) => cellValue >= filterValue,
            },
            {
              displayKey: 'between',
              displayName: 'Between',
              numberOfInputs: 2,
              predicate: ([filterValue1, filterValue2]: [string, string], cellValue: string) =>
                cellValue >= filterValue1 && cellValue < filterValue2,
            },
          ],
        },

        valueFormatter: dateFormatter,
      },
      {
        field: 'component',
        headerName: 'Platform',

        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: ['EX', 'CX'],
        },
      },
      {
        field: 'direction',
        headerName: 'Direction',

        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: ['Internal', 'Inbound', 'Outbound'],
        },
      },
      {
        field: 'fromPhoneNumber',
        headerName: 'Caller',

        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: getFromPhoneValues,
          refreshValuesOnOpen: true,
        },
      },
      {
        field: 'toPhoneNumber',
        headerName: 'Callee',
        filter: 'agSetColumnFilter',

        filterParams: {
          buttons: ['apply', 'reset'],
          values: getToPhoneValues,
          refreshValuesOnOpen: true,
        },
      },
      {
        field: 'duration',
        headerName: 'Duration',
        valueFormatter: durationFormatter,
        sortingOrder: ['asc' as const, 'desc' as const],
        sortable: true,

        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true,
          buttons: ['apply', 'reset'],
          filterOptions: [
            {
              displayKey: 'lessThan',
              displayName: 'Less Than',
              predicate: ([filterValue]: [string], cellValue: string) => cellValue < filterValue,
            },
            {
              displayKey: 'moreThan',
              displayName: 'Greater Than',
              predicate: ([filterValue]: [string], cellValue: string) => cellValue > filterValue,
            },
            {
              displayKey: 'between',
              displayName: 'Between',
              numberOfInputs: 2,
              predicate: ([filterValue1, filterValue2]: [string, string], cellValue: string) =>
                cellValue > filterValue1 && cellValue < filterValue2,
            },
          ],
        },
      },
      {
        field: 'result',
        headerName: 'Result',

        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: getResultValues,
          refreshValuesOnOpen: true,
        },
      },
      {
        field: 'recordingExists',
        headerName: 'Has recording',

        minWidth: 320,
        maxWidth: 320,
        width: 320,
        hide: true,
        supressSizeToFit: false,
        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: ['Ready', 'Not Ready', 'No'],
        },
        cellRenderer: recordingRenderer,
      },
      {
        field: 'sentimentScore',
        filter: 'agSetColumnFilter',

        hide: true,
        filterParams: {
          buttons: ['apply', 'reset'],
          values: ['Very Positive', 'Positive', 'Neutral', 'Negative', 'Very Negative', 'None'],
        },
        cellRenderer: (params: ValueFormatterParams) => {
          if (params && params.value) {
            if (params.value === 'Very Positive') {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Tooltip title={params.value}>
                    <SentimentVerySatisfied fontSize="large" style={{ color: '#5DCF49' }} />
                  </Tooltip>
                </div>
              );
            }
            if (params.value === 'Positive') {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Tooltip title={params.value}>
                    <SentimentSatisfiedAlt fontSize="large" style={{ color: '#009AFF' }} />
                  </Tooltip>
                </div>
              );
            }
            if (params.value === 'Neutral') {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Tooltip title={params.value}>
                    <SentimentSatisfied fontSize="large" style={{ color: '#64BDFD' }} />
                  </Tooltip>
                </div>
              );
            }
            if (params.value === 'Negative') {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Tooltip title={params.value}>
                    <SentimentDissatisfied fontSize="large" style={{ color: '#FF9E1C' }} />
                  </Tooltip>
                </div>
              );
            }
            if (params.value === 'Very Negative') {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {' '}
                  <Tooltip title={params.value}>
                    <SentimentVeryDissatisfied fontSize="large" style={{ color: '#EE6B6B' }} />
                  </Tooltip>
                </div>
              );
            }
            return '--';
          }
          return '--';
        },
      },
      {
        field: 'callScore',
        filter: 'agSetColumnFilter',

        filterParams: {
          buttons: ['apply', 'reset'],
          values: getCallScoreValues,
          refreshValuesOnOpen: true,
        },
      },
      {
        field: 'disposition',
        filter: 'agSetColumnFilter',

        filterParams: {
          buttons: ['apply', 'reset'],
          values: getDispositionValues,
          refreshValuesOnOpen: true,
        },
      },
      {
        field: 'fromLink',
        headerName: 'Transfer from',

        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: ['CX', 'EX', 'None'],
        },
      },
      {
        field: 'toLink',
        headerName: 'Transfer to',

        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: ['CX', 'EX', 'None'],
        },
      },
      {
        field: 'toEx',
        headerName: 'To EX',

        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: ['true', '--'],
        },
      },
      {
        field: 'toCx',
        headerName: 'To CX',

        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: ['true', '--'],
        },
      },
      {
        field: 'fromEx',
        headerName: 'From EX',

        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: ['true', '--'],
        },
      },
      {
        field: 'fromCx',
        headerName: 'From CX',

        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          values: ['true', '--'],
        },
      },
    ],
    [
      getResultValues,
      getToPhoneValues,
      getFromPhoneValues,
      getDispositionValues,
      getCallScoreValues,
      recordingRenderer,
    ],
  );

  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      minWidth: 100,
      sortable: false,
      resizable: true,
      cellClassRules: {
        small: () => fontValue === 1,
        medium: () => fontValue === 2,
        large: () => fontValue === 3,
      },
    }),
    [fontValue],
  );

  const fetchData = useCallback(
    async (startTime: string, endTime: string | undefined, timestamp: number, callApi: string) => {
      const attempt = async (
        fn: (arg: string | undefined) => Promise<any>,
        arg: string | undefined,
        delayMs: number,
      ) => {
        if (timestamp !== dateChanged) {
          return;
        }
        try {
          await fn(arg);
        } catch (err) {
          if (delayMs > 320 * 1000) {
            console.log(err);
            setError('Error loading data');
            return;
          }
          await new Promise((resolve) => setTimeout(resolve, delayMs));
          await attempt(fn, arg, delayMs * 2);
        }
      };

      const getExData = async (next: string | undefined) => {
        console.log('next', next, token);
        let api: string;
        // api always requires startTime
        if (next) {
          api = next;
        } else if (startTime && endTime) {
          api = `${callApi}?startTime=${startTime}&endTime=${endTime}`;
        } else {
          api = `${callApi}?startTime=${startTime}`;
        }

        const res = await fetch(api, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const resp = await res.json();
        console.log('resp', resp);

        const lines: Array<UserState> = resp.calls;

        const widgetIncr: WidgetIncr = {};

        await Promise.all(
          lines.map(
            async (newState) =>
              // Process each line as needed
              new Promise((resolve, reject) => {
                if (db !== null && timestamp === dateChanged) {
                  const myTransaction = db.transaction([`calls-${organizationId}`], 'readwrite');
                  // Store values in objectStore.
                  const callStore = myTransaction.objectStore(`calls-${organizationId}`);
                  const getCallRequest = callStore.get(newState.callId);

                  getCallRequest.onsuccess = (event) => {
                    let addCall: Call | undefined;

                    const existingCall = (event.target as IDBRequest<Call>).result;

                    // const fromPhoneList: Set<string> =
                    //   new Set(existingCall?.fromPhoneList) || new Set();
                    // const toPhoneList: Set<string> =
                    //   new Set(existingCall?.toPhoneList) || new Set();
                    const recordingsList: Set<string> = new Set(existingCall?.recordings) || new Set();
                    const recordingsReady: Set<string> = new Set(existingCall?.recordingsReady) || new Set();

                    // if (newState.fromPhoneNumber?.toString()) {
                    //   fromPhoneList.add(newState.fromPhoneNumber?.toString());
                    // }
                    // if (newState.toPhoneNumber?.toString()) {
                    //   toPhoneList.add(newState.toPhoneNumber?.split("-")[0]);
                    // }

                    if (newState.recordingId) {
                      recordingsList.add(newState.recordingId);
                    }
                    if (newState.recordingsReady && newState.recordingsReady.length > 0) {
                      newState.recordingsReady.forEach((item) => recordingsReady.add(item));
                    }

                    let recordingExists = 'No';

                    if (
                      existingCall?.recordingExists === 'Ready' ||
                      (newState.recordingsReady && newState.recordingsReady.length > 0)
                    ) {
                      recordingExists = 'Ready';
                    } else if (
                      existingCall?.recordingExists === 'Not Ready' ||
                      (newState.recordingId && recordingsReady.size === 0)
                    ) {
                      recordingExists = 'Not Ready';
                    }

                    let sentiment;
                    if (newState.insights?.sentimentScore !== undefined) {
                      sentiment = compareSentiments(existingCall?.sentimentScore, newState.insights?.sentimentScore);
                    } else if (existingCall?.sentimentScore) {
                      sentiment = existingCall?.sentimentScore;
                    } else {
                      sentiment = 'None';
                    }

                    let callScore;
                    if (newState.callScore !== undefined) {
                      callScore = newState.callScore;
                    } else if (existingCall?.callScore) {
                      callScore = existingCall?.callScore;
                    } else {
                      callScore = 'None';
                    }

                    let disposition;
                    let dispositionTime;
                    if (existingCall?.dispositionTime === undefined) {
                      disposition = newState.insights?.disposition
                        ? `${newState.insights.disposition.codeNumber}:${newState.insights.disposition.codeDescription}`
                        : 'None';
                      dispositionTime = newState.insights?.disposition?.time;
                    } else if (
                      existingCall?.dispositionTime &&
                      newState.insights?.disposition?.time &&
                      new Date(newState.insights?.disposition?.time).getTime() >
                        new Date(existingCall?.dispositionTime).getTime()
                    ) {
                      disposition = newState.insights?.disposition
                        ? `${newState.insights.disposition.codeNumber}:${newState.insights.disposition.codeDescription}`
                        : 'None';
                      dispositionTime = newState.insights?.disposition?.time;
                    } else {
                      disposition = existingCall?.disposition;
                      dispositionTime = existingCall?.dispositionTime;
                    }

                    const fromLink = existingCall?.fromLink === 'CX' || newState.fromLink ? 'CX' : 'None';
                    const toLink = existingCall?.toLink === 'CX' || newState.toLink ? 'CX' : 'None';

                    const toEx = existingCall?.toEx === 'true' || newState.toEx ? 'true' : '--';
                    const fromEx = existingCall?.fromEx === 'true' || newState.fromEx ? 'true' : '--';
                    const toCx = existingCall?.toCx === 'true' || newState.toCx ? 'true' : '--';
                    const fromCx = existingCall?.fromEx === 'true' || newState.fromEx ? 'true' : '--';

                    if (existingCall === undefined) {
                      // no such call in db yet - add it
                      addCall = {
                        component: 'EX',
                        callId: newState.callId,
                        ringDuration: newState.ringDuration || 0,
                        talkDuration: newState.talkDuration || 0,
                        holdDuration: newState.holdTimeInbound || 0,
                        index: newState.index,
                        recordings: Array.from(recordingsList),
                        recordingsReady: Array.from(recordingsReady),
                        // recordingsNumber: recordingsList.size.toString(),
                        recordingExists,
                        sentimentScore: sentiment,
                        callScore,
                        disposition,
                        dispositionTime,
                        fromLink,
                        toLink,
                        toEx,
                        fromEx,
                        toCx,
                        fromCx,
                        fromPhoneNumber: newState.fromPhoneNumber?.toString(),
                        toPhoneNumber: newState.toPhoneNumber?.split('-')[0],
                        direction: newState.direction,
                        result: newState.state?.split('-')[0] || '',
                        duration: newState.duration || 0,
                        users: [newState],
                        // fromPhoneList: Array.from(fromPhoneList),
                        // toPhoneList: Array.from(toPhoneList),
                        // fromPhoneList_index: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newState.index]
                        // ),
                        // toPhoneList_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newState.index]
                        // ),
                        // fromPhoneList_duration: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newState.duration || 0]
                        // ),
                        // toPhoneList_duration: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newState.duration || 0]
                        // ),
                        // fromPhoneList_direction_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   newState.direction,
                        //   newState.index,
                        // ]),
                        // fromPhoneList_result_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   newState.state?.split("-")[0] || "",
                        //   newState.index,
                        // ]),
                        // toPhoneList_result_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [
                        //     phoneNumber,
                        //     newState.state?.split("-")[0] || "",
                        //     newState.index,
                        //   ]
                        // ),
                        // toPhoneList_direction_index: Array.from(
                        //   toPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   newState.direction,
                        //   newState.index,
                        // ]),
                      };
                    } else {
                      // call record already exists, might need to be updated
                      const callUsers = existingCall.users || [];
                      const userAdded = callUsers.find((userState) => userState.userId === newState.userId);
                      if (userAdded === undefined) {
                        // no record about this user - call needs to be updated
                        callUsers.push(newState);

                        const latestEnd = getLatestEnd(callUsers);
                        const earliestStart = getEarliestStart(callUsers);
                        const newDuration =
                          latestEnd && earliestStart ? latestEnd - new Date(earliestStart).getTime() : 0;
                        const latestUserState = getLatestUserState(callUsers);
                        addCall = {
                          ...existingCall,
                          index: earliestStart,
                          duration: newDuration,
                          direction: latestUserState.direction,
                          result: latestUserState.state?.split('-')[0],
                          recordings: Array.from(recordingsList),
                          //   recordingsNumber: recordingsList.size.toString(),
                          recordingExists,
                          recordingsReady: Array.from(recordingsReady),
                          sentimentScore: sentiment,
                          callScore,
                          disposition,
                          dispositionTime,
                          fromLink,
                          toLink,
                          fromCx,
                          toCx,
                          fromEx,
                          toEx,
                          fromPhoneNumber: latestUserState.fromPhoneNumber?.toString(),
                          toPhoneNumber: latestUserState.toPhoneNumber?.split('-')[0],
                          users: callUsers,
                          //   fromPhoneList: Array.from(fromPhoneList),
                          //   toPhoneList: Array.from(toPhoneList),
                          //   fromPhoneList_index: Array.from(fromPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, earliestStart]
                          //   ),
                          //   toPhoneList_index: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, earliestStart]
                          //   ),
                          //   fromPhoneList_duration: Array.from(fromPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, newDuration]
                          //   ),
                          //   toPhoneList_duration: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, newDuration]
                          //   ),
                          //   fromPhoneList_direction_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     latestUserState.direction,
                          //     earliestStart,
                          //   ]),
                          //   toPhoneList_direction_index: Array.from(
                          //     toPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     latestUserState.direction,
                          //     earliestStart,
                          //   ]),
                          //   fromPhoneList_result_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     latestUserState.state?.split("-")[0] || "",
                          //     earliestStart,
                          //   ]),
                          //   toPhoneList_result_index: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [
                          //       phoneNumber,
                          //       latestUserState.state?.split("-")[0] || "",
                          //       earliestStart,
                          //     ]
                          //   ),
                        };
                      }
                      // check if newState is recent one
                      else if (newState.duration && newState.duration > userAdded.duration) {
                        // update record
                        const updatedCallUsers = callUsers.map((userState) => {
                          if (userState.userId === newState.userId) {
                            return {
                              ...userState,
                              ...newState,
                            };
                          }
                          return userState;
                        });

                        const latestEnd = getLatestEnd(updatedCallUsers);
                        const earliestStart = getEarliestStart(updatedCallUsers);
                        const newDuration =
                          latestEnd && earliestStart ? latestEnd - new Date(earliestStart).getTime() : 0;
                        const latestUserState = getLatestUserState(updatedCallUsers);
                        addCall = {
                          ...existingCall,
                          recordings: Array.from(recordingsList),
                          //   recordingsNumber: recordingsList.size.toString(),
                          recordingExists,
                          recordingsReady: Array.from(recordingsReady),
                          sentimentScore: sentiment,
                          callScore,
                          index: earliestStart,
                          duration: newDuration,
                          disposition,
                          dispositionTime,
                          fromLink,
                          toLink,
                          fromCx,
                          toCx,
                          fromEx,
                          toEx,
                          direction: latestUserState.direction,
                          result: latestUserState.state?.split('-')[0],
                          fromPhoneNumber: latestUserState.fromPhoneNumber?.toString(),
                          toPhoneNumber: latestUserState.toPhoneNumber?.split('-')[0],
                          users: updatedCallUsers,
                          //   fromPhoneList: Array.from(fromPhoneList),
                          //   toPhoneList: Array.from(toPhoneList),
                          //   fromPhoneList_index: Array.from(fromPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, earliestStart]
                          //   ),
                          //   toPhoneList_index: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, earliestStart]
                          //   ),
                          //   fromPhoneList_duration: Array.from(fromPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, newDuration]
                          //   ),
                          //   toPhoneList_duration: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, newDuration]
                          //   ),
                          //   fromPhoneList_direction_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     latestUserState.direction,
                          //     earliestStart,
                          //   ]),
                          //   toPhoneList_direction_index: Array.from(
                          //     toPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     latestUserState.direction,
                          //     earliestStart,
                          //   ]),
                          //   fromPhoneList_result_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     latestUserState.state?.split("-")[0] || "",
                          //     earliestStart,
                          //   ]),
                          //   toPhoneList_result_index: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [
                          //       phoneNumber,
                          //       latestUserState.state?.split("-")[0] || "",
                          //       earliestStart,
                          //     ]
                          //   ),
                        };
                        // we should keep all phone numbers belong to this call, even older ones if they are not in db yet
                      } else if (
                        // setsAreDifferent(
                        //   new Set(existingCall.fromPhoneList),
                        //   fromPhoneList
                        // ) ||
                        // setsAreDifferent(
                        //   new Set(existingCall.toPhoneList),
                        //   toPhoneList
                        // ) ||

                        setsAreDifferent(new Set(existingCall.recordings), recordingsList) ||
                        recordingExists !== existingCall.recordingExists ||
                        sentiment !== existingCall?.sentimentScore ||
                        callScore !== existingCall?.callScore ||
                        disposition !== existingCall.disposition ||
                        fromLink !== existingCall?.fromLink ||
                        toLink !== existingCall?.toLink ||
                        fromCx !== existingCall?.fromCx ||
                        toCx !== existingCall?.toCx ||
                        fromEx !== existingCall?.fromEx ||
                        toEx !== existingCall?.toEx
                      ) {
                        addCall = {
                          ...existingCall,
                          recordings: Array.from(recordingsList),
                          //   recordingsNumber: recordingsList.size.toString(),
                          recordingExists,
                          recordingsReady: Array.from(recordingsReady),
                          sentimentScore: sentiment,
                          callScore,
                          disposition,
                          dispositionTime,
                          fromLink,
                          toLink,
                          toCx,
                          fromCx,
                          toEx,
                          fromEx,
                          //   fromPhoneList: Array.from(fromPhoneList),
                          //   toPhoneList: Array.from(toPhoneList),
                          //   fromPhoneList_index: Array.from(fromPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, existingCall.index]
                          //   ),
                          //   toPhoneList_index: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, existingCall.index]
                          //   ),
                          //   fromPhoneList_duration: Array.from(fromPhoneList).map(
                          //     (phoneNumber) => [
                          //       phoneNumber,
                          //       existingCall.duration || 0,
                          //     ]
                          //   ),
                          //   toPhoneList_duration: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [
                          //       phoneNumber,
                          //       existingCall.duration || 0,
                          //     ]
                          //   ),
                          //   fromPhoneList_direction_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     existingCall.direction || "",
                          //     existingCall.index,
                          //   ]),
                          //   toPhoneList_direction_index: Array.from(
                          //     toPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     existingCall.direction || "",
                          //     existingCall.index,
                          //   ]),
                          //   fromPhoneList_result_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     existingCall.result || "",
                          //     existingCall.index,
                          //   ]),
                          //   toPhoneList_result_index: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [
                          //       phoneNumber,
                          //       existingCall.result || "",
                          //       existingCall.index,
                          //     ]
                          //   ),
                        };
                      }
                      // else got older one and no any new data - no action required
                    }

                    if (addCall !== undefined) {
                      addCall.transcript = newState.insights?.transcript;

                      if (existingCall !== undefined && (existingCall.transcript as string | undefined) !== undefined) {
                        widgetIncr.transcripts = (widgetIncr.transcripts || 0) - 1;
                      }

                      if (addCall !== undefined && (addCall.transcript as string | undefined) !== undefined) {
                        widgetIncr.transcripts = (widgetIncr.transcripts || 0) + 1;
                      }
                    }

                    if (addCall !== undefined) {
                      const updateRequest = callStore.put(addCall);

                      updateRequest.onsuccess = () => {
                        // console.log("Record updated successfully", addCall);
                      };

                      updateRequest.onerror = (e) => {
                        console.error('Error updating record: ', (e.target as IDBRequest).error);
                      };

                      // [
                      //   ["call", undefined, "calls"],
                      //   ["recordingExists", "Ready", "recordings"],
                      //   ["direction", "Inbound", "inbound"],
                      //   ["direction", "Outbound", "outbound"],
                      //   ["direction", "Internal", "internal"],
                      //   ["sentimentScore", "Very Positive", "veryPositive"],
                      //   ["sentimentScore", "Positive", "positive"],
                      //   ["sentimentScore", "Neutral", "neutral"],
                      //   ["sentimentScore", "Negative", "negative"],
                      //   ["sentimentScore", "Very Negative", "veryNegative"],
                      //   ["result", "ANSWERED", "answered"],
                      //   ["result", "ABANDONED", "abandoned"],
                      //   ["result", "QUEUE ABANDONED", "queueAbandoned"],
                      //   ["result", "FAX RECEIVED", "faxReceived"],
                      // ].forEach((item: Array<any>) => {
                      //   if (
                      //     existingCall !== undefined &&
                      //     (existingCall[item[0] as keyof Call] as
                      //       | string
                      //       | undefined) === item[1]
                      //   ) {
                      //     widgetIncr[item[2] as keyof WidgetIncr] =
                      //       (widgetIncr[item[2] as keyof WidgetIncr] || 0) - 1;
                      //   }

                      //   if (
                      //     addCall !== undefined &&
                      //     (addCall[item[0] as keyof Call] as
                      //       | string
                      //       | undefined) === item[1]
                      //   ) {
                      //     widgetIncr[item[2] as keyof WidgetIncr] =
                      //       (widgetIncr[item[2] as keyof WidgetIncr] || 0) + 1;
                      //   }
                      // });

                      const callResults = graphData.get('Call Results')!.data;
                      const callType = graphData.get('Call Type')!.data;
                      const callRecordings = graphData.get('Call Recordings')!.data;
                      const sentimentScores = graphData.get('Sentiment Score')!.data;
                      const callStates = graphData.get('Call States')!.data;

                      const callResultKeys = [...callResults.keys()];
                      const sentimentScoreKeys = [...sentimentScores.keys()];
                      const callStateKeys = [...callStates.keys()];

                      if (addCall !== undefined) {
                        callResultKeys.forEach((key) => {
                          if (addCall?.result !== undefined && addCall?.result === key) {
                            callResults.set(key, callResults.get(key)! + 1);
                          }
                        });
                        callStateKeys.forEach((key) => {
                          if (addCall?.result !== undefined && addCall?.result === key) {
                            callStates.set(key, callStates.get(key)! + 1);
                          }
                        });
                        if (addCall?.direction === 'Outbound') {
                          callType.set('Outbound', callType.get('Outbound')! + 1);
                        }
                        if (addCall?.direction === 'Inbound') {
                          callType.set('Inbound', callType.get('Inbound')! + 1);
                        }
                        if (addCall?.direction === 'Internal') {
                          callType.set('Internal', callType.get('Internal')! + 1);
                        }
                        if (addCall !== undefined && (addCall?.transcript as string | undefined) !== undefined) {
                          callRecordings.set('Transcripts', callRecordings.get('Transcripts')! + 1);
                        }
                        if (addCall !== undefined && (addCall?.transcript as string | undefined) !== undefined) {
                          callRecordings.set('Recordings', callRecordings.get('Recordings')! + 1);
                        }
                        if (addCall?.sentimentScore !== undefined && addCall?.sentimentScore !== 'None') {
                          sentimentScoreKeys.forEach((key) => {
                            if (addCall?.sentimentScore === key) {
                              sentimentScores.set(key, sentimentScores.get(key)! + 1);
                            }
                          });
                        }
                      }

                      if (existingCall !== undefined) {
                        callResultKeys.forEach((key) => {
                          if (existingCall?.result !== undefined && existingCall?.result === key) {
                            callResults.set(key, callResults.get(key)! - 1);
                          }
                        });
                        callStateKeys.forEach((key) => {
                          if (existingCall?.result !== undefined && existingCall?.result === key) {
                            callStates.set(key, callStates.get(key)! - 1);
                          }
                        });
                        if (existingCall?.direction === 'Outbound') {
                          callType.set('Outbound', callType.get('Outbound')! - 1);
                        }
                        if (existingCall?.direction === 'Inbound') {
                          callType.set('Inbound', callType.get('Inbound')! - 1);
                        }
                        if (existingCall?.direction === 'Internal') {
                          callType.set('Internal', callType.get('Internal')! - 1);
                        }
                        if (
                          existingCall !== undefined &&
                          (existingCall?.transcript as string | undefined) !== undefined
                        ) {
                          callRecordings.set('Transcripts', callRecordings.get('Transcripts')! - 1);
                        }
                        if (
                          existingCall !== undefined &&
                          (existingCall?.transcript as string | undefined) !== undefined
                        ) {
                          callRecordings.set('Recordings', callRecordings.get('Recordings')! - 1);
                        }
                        if (existingCall?.sentimentScore !== undefined && existingCall?.sentimentScore !== 'None') {
                          sentimentScoreKeys.forEach((key) => {
                            if (existingCall?.sentimentScore === key) {
                              sentimentScores.set(key, sentimentScores.get(key)! - 1);
                            }
                          });
                        }
                      }
                    }

                    return resolve('success');
                  };

                  getCallRequest.onerror = (event) => reject((event.target as IDBOpenDBRequest).error);
                }
              }),
          ),
        );

        // setGraphData((oldGraphData) =>
        //   oldGraphData.map((item) => {
        //     if (item.name === "call result") {
        //       return {
        //         ...item,
        //         data: [
        //           (item.data[0] || 0) + (widgetIncr.answered || 0),
        //           (item.data[1] || 0) + (widgetIncr.abandoned || 0),
        //           (item.data[2] || 0) + (widgetIncr.queueAbandoned || 0),
        //           (item.data[3] || 0) + (widgetIncr.faxReceived || 0),
        //         ],
        //       };
        //     }

        //     if (item.name === "sentiment score") {
        //       return {
        //         ...item,
        //         data: [
        //           (item.data[0] || 0) + (widgetIncr.veryPositive || 0),
        //           (item.data[1] || 0) + (widgetIncr.positive || 0),
        //           (item.data[2] || 0) + (widgetIncr.neutral || 0),
        //           (item.data[3] || 0) + (widgetIncr.negative || 0),
        //           (item.data[4] || 0) + (widgetIncr.veryNegative || 0),
        //         ],
        //       };
        //     }

        //     if (item.name === "call type") {
        //       return {
        //         ...item,
        //         data: [
        //           (item.data[0] || 0) + (widgetIncr.inbound || 0),
        //           (item.data[1] || 0) + (widgetIncr.outbound || 0),
        //           (item.data[2] || 0) + (widgetIncr.internal || 0),
        //         ],
        //       };
        //     }

        //     if (item.name === "call recordings") {
        //       return {
        //         ...item,
        //         data: [
        //           (item.data[0] || 0) + (widgetIncr.calls || 0),
        //           (item.data[1] || 0) + (widgetIncr.recordings || 0),
        //           (item.data[2] || 0) + (widgetIncr.transcripts || 0),
        //         ],
        //       };
        //     }

        //     return item;
        //   })
        // );

        gridRef?.current?.api?.refreshServerSide();
        // indicate that db is populated (partially or finally)
        // setDbCleared(false);
        if (resp.next !== undefined) {
          let cb: Promise<void>;

          setProgress((oldProgress) => {
            // only attempt again if we haven't hit the upper limit
            if (oldProgress < 100) {
              cb = attempt(getExData, resp.next, 10 * 1000);
            }
            return oldProgress + 10;
          });
        } else {
          setProgress(100);
        }
      };

      const getCxData = async (next: string | undefined) => {
        console.log('next', next);
        let api: string;
        // api always requires startTime
        if (next) {
          api = next;
        } else if (startTime && endTime) {
          api = `${cxCallApi}?startTime=${startTime}&endTime=${endTime}`;
        } else {
          api = `${cxCallApi}?startTime=${startTime}`;
        }

        const res = await fetch(api, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const resp = await res.json();
        console.log('resp', resp);

        const lines: Array<CXExtension> = resp.messages;

        const widgetIncr: WidgetIncr = {};

        await Promise.all(
          lines.map(
            async (newDelta) =>
              // Process each line as needed
              new Promise((resolve, reject) => {
                if (db !== null && timestamp === dateChanged) {
                  const myTransaction = db.transaction([`calls-${organizationId}`], 'readwrite');
                  // Store values in objectStore.
                  const callStore = myTransaction.objectStore(`calls-${organizationId}`);
                  const getCallRequest = callStore.get(newDelta.callId);
                  const durationInMs = newDelta.duration ? newDelta.duration * 1000 : 0;
                  const index = new Date(newDelta.callStart).toISOString();

                  getCallRequest.onsuccess = (event) => {
                    let addCall: Call | undefined;

                    const existingCall = (event.target as IDBRequest<Call>).result;

                    // const fromPhoneList: Set<string> =
                    //   new Set(existingCall?.fromPhoneList) || new Set();
                    // const toPhoneList: Set<string> =
                    //   new Set(existingCall?.toPhoneList) || new Set();
                    const recordingsList: Set<string> = new Set(existingCall?.recordings) || new Set();

                    // if (newDelta.ani) {
                    //   fromPhoneList.add(newDelta.ani);
                    // }
                    // if (newDelta.dnis) {
                    //   toPhoneList.add(newDelta.dnis);
                    // }

                    // if (
                    //   newDelta.recordingId &&
                    //   newDelta.recordingId.startsWith("https")
                    // ) {
                    //   recordingsList.add(newDelta.recordingId);
                    // }

                    const recordingExists = 'No';
                    // let recordingExists = "No";

                    // if (
                    //   existingCall?.recordingExists === "Yes" ||
                    //   (newDelta.recordingId &&
                    //     newDelta.recordingId.startsWith("https"))
                    // ) {
                    //   recordingExists = "Ready";
                    // } else if (
                    //   existingCall?.recordingExists === "Not Ready" ||
                    //   (newDelta.recordingId &&
                    //     !newDelta.recordingId.startsWith("https"))
                    // ) {
                    //   recordingExists = "Not Ready";
                    // }

                    const sentiment = 'None';
                    // let sentiment;
                    // if (newDelta.sentimentScore !== undefined) {
                    //   sentiment = compareSentiments(
                    //     existingCall?.sentimentScore,
                    //     newDelta.sentimentScore
                    //   );
                    // } else if (existingCall?.sentimentScore) {
                    //   sentiment = existingCall?.sentimentScore;
                    // } else {
                    //   sentiment = "None";
                    // }
                    const callScore = 'None';

                    let disposition;
                    let dispositionTime;
                    if (
                      newDelta.agentDisposition &&
                      (existingCall?.dispositionTime === undefined ||
                        (existingCall?.dispositionTime &&
                          newDelta.timestamp &&
                          new Date(newDelta.timestamp).getTime() > new Date(existingCall?.dispositionTime).getTime()))
                    ) {
                      disposition = newDelta.agentDisposition;
                      dispositionTime = newDelta.timestamp;
                    } else if (existingCall?.disposition && existingCall?.dispositionTime) {
                      disposition = existingCall?.disposition;
                      dispositionTime = existingCall?.dispositionTime;
                    } else {
                      disposition = 'None';
                    }

                    const toLink = existingCall?.toLink === 'EX' || newDelta.toLink ? 'EX' : 'None';
                    const fromLink = existingCall?.fromLink === 'EX' || newDelta.fromLink ? 'EX' : 'None';

                    const toEx = existingCall?.toEx === 'true' || newDelta.toEx ? 'true' : '--';
                    const fromEx = existingCall?.fromEx === 'true' || newDelta.fromEx ? 'true' : '--';
                    const toCx = existingCall?.toCx === 'true' || newDelta.toCx ? 'true' : '--';
                    const fromCx = existingCall?.fromCx === 'true' || newDelta.fromCx ? 'true' : '--';

                    const direction = existingCall?.direction || newDelta.direction || 'Inbound';

                    // let state = "None";
                    // if (newDelta.extension === "queue") {
                    //   if (newDelta.state === "IDLE") {
                    //     if (newDelta.completedCount) {
                    //       state = "COMPLETE";
                    //     } else if (newDelta.abandonedCount) {
                    //       state = "ABANDONED";
                    //     } else {
                    //       state = newDelta.state;
                    //     }
                    //   } else {
                    //     state = newDelta.state || "None";
                    //   }
                    // }

                    if (existingCall === undefined) {
                      // no such call in db yet - add it
                      let state = 'Unknown';
                      if (newDelta.extension === 'queue') {
                        if (newDelta.transferCount && newDelta.transferCount > 0) {
                          //   if (
                          //     newDelta.transferDestination &&
                          //     regexCheck(
                          //       newDelta.transferDestination,
                          //       exPhonePattern
                          //     )
                          //   ) {
                          //     state = "TRANSFERRED TO EX";
                          //   }
                          state = 'TRANSFERRED';
                        } else if (newDelta.completedCount && newDelta.completedCount > 0) {
                          state = 'COMPLETE';
                        } else if (newDelta.voicemailCount && newDelta.voicemailCount > 0) {
                          state = 'VOICEMAIL';
                        } else if (newDelta.abandonedCount && newDelta.abandonedCount > 0) {
                          state = 'ABANDONED';
                        } else if (newDelta.activeCount && newDelta.activeCount > 0) {
                          state = 'ACTIVE';
                        } else if (newDelta.waitingCount && newDelta.waitingCount > 0) {
                          state = 'WAITING';
                        }
                      }
                      addCall = {
                        component: 'CX',
                        callId: newDelta.callId,
                        index,
                        fromLink,
                        toLink,
                        toCx,
                        fromCx,
                        toEx,
                        fromEx,
                        recordings: Array.from(recordingsList),
                        // recordingsNumber: recordingsList.size.toString(),
                        recordingExists,
                        sentimentScore: sentiment,
                        callScore,
                        disposition,
                        dispositionTime,
                        fromPhoneNumber: newDelta.ani,
                        toPhoneNumber: newDelta.dnis,
                        direction,
                        result: state,
                        duration: durationInMs,
                        users: [
                          {
                            index,
                            timestamp: newDelta.timestamp,
                            duration: durationInMs,
                            direction,
                            toPhoneNumber: newDelta.dnis,
                            fromPhoneNumber: newDelta.ani,
                            callId: newDelta.callId,
                            state,
                            extension: newDelta.extension,
                            extensionId: newDelta.extensionId,
                            waitingCount: newDelta.waitingCount,
                            activeCount: newDelta.activeCount,
                            completedCount: newDelta.completedCount,
                            abandonedCount: newDelta.abandonedCount,
                            voicemailCount: newDelta.voicemailCount,
                            transferCount: newDelta.transferCount,
                            transferDestination: newDelta.transferDestination,
                          },
                        ],
                        // fromPhoneList: Array.from(fromPhoneList),
                        // toPhoneList: Array.from(toPhoneList),
                        // fromPhoneList_index: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, index]
                        // ),
                        // toPhoneList_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, index]
                        // ),

                        // fromPhoneList_duration: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, durationInMs]
                        // ),
                        // toPhoneList_duration: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, durationInMs]
                        // ),
                        // fromPhoneList_direction_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [phoneNumber, direction, index]),
                        // toPhoneList_direction_index: Array.from(
                        //   toPhoneList
                        // ).map((phoneNumber) => [phoneNumber, direction, index]),
                        // fromPhoneList_result_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [phoneNumber, state, index]),
                        // toPhoneList_result_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, state, index]
                        // ),
                      };
                    } else {
                      // call record already exists, might need to be updated
                      const callUsers = existingCall.users || [];
                      const userAdded = callUsers.find((delta) => delta.extensionId === newDelta.extensionId);
                      if (userAdded === undefined) {
                        // no record about this user - call needs to be updated
                        let state = 'Unknown';
                        if (newDelta.extension === 'queue') {
                          if (newDelta.transferCount && newDelta.transferCount > 0) {
                            // if (
                            //   newDelta.transferDestination &&
                            //   regexCheck(
                            //     newDelta.transferDestination,
                            //     exPhonePattern
                            //   )
                            // ) {
                            //   state = "TRANSFERRED TO EX";
                            // }
                            state = 'TRANSFERRED';
                          } else if (newDelta.completedCount && newDelta.completedCount > 0) {
                            state = 'COMPLETE';
                          } else if (newDelta.voicemailCount && newDelta.voicemailCount > 0) {
                            state = 'VOICEMAIL';
                          } else if (newDelta.abandonedCount && newDelta.abandonedCount > 0) {
                            state = 'ABANDONED';
                          } else if (newDelta.activeCount && newDelta.activeCount > 0) {
                            state = 'ACTIVE';
                          } else if (newDelta.waitingCount && newDelta.waitingCount > 0) {
                            state = 'WAITING';
                          }
                        }
                        callUsers.push({
                          index,
                          duration: durationInMs,
                          direction,
                          toPhoneNumber: newDelta.dnis,
                          fromPhoneNumber: newDelta.ani,
                          callId: newDelta.callId,
                          timestamp: newDelta.timestamp,
                          state,
                          extension: newDelta.extension,
                          extensionId: newDelta.extensionId,
                          completedCount: newDelta.completedCount,
                          abandonedCount: newDelta.abandonedCount,
                          waitingCount: newDelta.waitingCount,
                          activeCount: newDelta.activeCount,
                          voicemailCount: newDelta.voicemailCount,
                          transferCount: newDelta.transferCount,
                          transferDestination: newDelta.transferDestination,
                        });

                        const latestEnd = getLatestEnd(callUsers);
                        const earliestStart = getEarliestStart(callUsers);
                        const newDuration =
                          latestEnd && earliestStart ? latestEnd - new Date(earliestStart).getTime() : 0;
                        const latestDelta = getLatestDelta(callUsers);
                        const latestQueueDelta = getLatestDelta(
                          callUsers.filter((record) => record.extension === 'queue'),
                        );

                        addCall = {
                          ...existingCall,
                          index: earliestStart,
                          duration: newDuration,
                          direction,
                          result: latestQueueDelta ? latestQueueDelta.state : 'Unknown',
                          recordings: Array.from(recordingsList),
                          //   recordingsNumber: recordingsList.size.toString(),
                          recordingExists,
                          sentimentScore: sentiment,
                          callScore,
                          disposition,
                          dispositionTime,
                          fromLink,
                          toLink,
                          toCx,
                          fromCx,
                          toEx,
                          fromEx,
                          fromPhoneNumber: latestDelta.fromPhoneNumber?.toString(),
                          toPhoneNumber: latestDelta.toPhoneNumber?.toString(),
                          users: callUsers,
                          //   fromPhoneList: Array.from(fromPhoneList),
                          //   toPhoneList: Array.from(toPhoneList),
                          //   fromPhoneList_index: Array.from(fromPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, earliestStart]
                          //   ),
                          //   toPhoneList_index: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, earliestStart]
                          //   ),
                          //   fromPhoneList_duration: Array.from(fromPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, newDuration]
                          //   ),
                          //   toPhoneList_duration: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, newDuration]
                          //   ),
                          //   fromPhoneList_direction_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     direction,
                          //     earliestStart,
                          //   ]),
                          //   toPhoneList_direction_index: Array.from(
                          //     toPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     direction,
                          //     earliestStart,
                          //   ]),
                          //   fromPhoneList_result_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     latestQueueDelta && latestQueueDelta.state
                          //       ? latestQueueDelta.state
                          //       : "Unknown",
                          //     earliestStart,
                          //   ]),
                          //   toPhoneList_result_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     latestQueueDelta && latestQueueDelta.state
                          //       ? latestQueueDelta.state
                          //       : "Unknown",
                          //     earliestStart,
                          //   ]),
                        };
                      }
                      // check if newState is recent one
                      else if (userAdded) {
                        // update record
                        const updatedCallUsers = callUsers.map((delta) => {
                          if (delta.extensionId === newDelta.extensionId) {
                            let state = 'Unknown';
                            const completedCount: number = (newDelta.completedCount || 0) + (delta.completedCount || 0);
                            const abandonedCount: number = (newDelta.abandonedCount || 0) + (delta.abandonedCount || 0);
                            const waitingCount: number = (newDelta.waitingCount || 0) + (delta.waitingCount || 0);
                            const activeCount: number = (newDelta.activeCount || 0) + (delta.activeCount || 0);
                            const transferCount: number = (newDelta.transferCount || 0) + (delta.transferCount || 0);
                            const transferDestination = newDelta.transferDestination || delta.transferDestination;
                            const voicemailCount: number = (newDelta.voicemailCount || 0) + (delta.voicemailCount || 0);
                            if (newDelta.extension === 'queue') {
                              if (transferCount > 0) {
                                // if (
                                //   transferDestination &&
                                //   regexCheck(
                                //     transferDestination,
                                //     exPhonePattern
                                //   )
                                // ) {
                                //   state = "TRANSFERRED TO EX";
                                // }
                                state = 'TRANSFERRED';
                              } else if (completedCount > 0) {
                                state = 'COMPLETE';
                              } else if (voicemailCount > 0) {
                                state = 'VOICEMAIL';
                              } else if (abandonedCount > 0) {
                                state = 'ABANDONED';
                              } else if (activeCount > 0) {
                                state = 'ACTIVE';
                              } else if (waitingCount > 0) {
                                state = 'WAITING';
                              }
                            }
                            return {
                              ...delta,
                              index,
                              duration: (delta.duration || 0) + durationInMs,
                              direction,
                              toPhoneNumber:
                                delta.timestamp === undefined ||
                                (newDelta.timestamp && newDelta.timestamp > delta.timestamp)
                                  ? newDelta.dnis
                                  : delta.toPhoneNumber,
                              fromPhoneNumber:
                                delta.timestamp === undefined ||
                                (newDelta.timestamp && newDelta.timestamp > delta.timestamp)
                                  ? newDelta.ani
                                  : delta.fromPhoneNumber,
                              callId: newDelta.callId,
                              state,

                              extension: newDelta.extension,
                              extensionId: newDelta.extensionId,
                              timestamp:
                                delta.timestamp === undefined ||
                                (newDelta.timestamp && newDelta.timestamp > delta.timestamp)
                                  ? newDelta.timestamp
                                  : delta.timestamp,
                              completedCount,
                              abandonedCount,
                              waitingCount,
                              activeCount,
                              voicemailCount,
                              transferCount,
                              transferDestination,
                            };
                          }
                          return delta;
                        });

                        const latestEnd = getLatestEnd(updatedCallUsers);
                        const earliestStart = getEarliestStart(updatedCallUsers);
                        const newDuration =
                          latestEnd && earliestStart ? latestEnd - new Date(earliestStart).getTime() : 0;
                        const latestDelta = getLatestDelta(updatedCallUsers);
                        const latestQueueDelta = getLatestDelta(
                          updatedCallUsers.filter((record) => record.extension === 'queue'),
                        );
                        addCall = {
                          ...existingCall,
                          recordings: Array.from(recordingsList),
                          //   recordingsNumber: recordingsList.size.toString(),
                          recordingExists,
                          sentimentScore: sentiment,
                          callScore,
                          index: earliestStart,
                          duration: newDuration,
                          disposition,
                          dispositionTime,
                          fromLink,
                          toLink,
                          toCx,
                          fromCx,
                          toEx,
                          fromEx,
                          direction,
                          result: latestQueueDelta ? latestQueueDelta.state : 'Unknown',
                          fromPhoneNumber: latestDelta.fromPhoneNumber?.toString(),
                          toPhoneNumber: latestDelta.toPhoneNumber?.toString(),
                          users: updatedCallUsers,
                          //   fromPhoneList: Array.from(fromPhoneList),
                          //   toPhoneList: Array.from(toPhoneList),
                          //   fromPhoneList_index: Array.from(fromPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, earliestStart]
                          //   ),
                          //   toPhoneList_index: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, earliestStart]
                          //   ),
                          //   fromPhoneList_duration: Array.from(fromPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, newDuration]
                          //   ),
                          //   toPhoneList_duration: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [phoneNumber, newDuration]
                          //   ),
                          //   fromPhoneList_direction_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     direction,
                          //     earliestStart,
                          //   ]),
                          //   fromPhoneList_result_index: Array.from(
                          //     fromPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     latestQueueDelta && latestQueueDelta.state
                          //       ? latestQueueDelta.state
                          //       : "Unknown",
                          //     earliestStart,
                          //   ]),
                          //   toPhoneList_direction_index: Array.from(
                          //     toPhoneList
                          //   ).map((phoneNumber) => [
                          //     phoneNumber,
                          //     direction,
                          //     earliestStart,
                          //   ]),
                          //   toPhoneList_result_index: Array.from(toPhoneList).map(
                          //     (phoneNumber) => [
                          //       phoneNumber,
                          //       latestQueueDelta && latestQueueDelta.state
                          //         ? latestQueueDelta.state
                          //         : "Unknown",
                          //       earliestStart,
                          //     ]
                          //   ),
                        };
                      }
                      //   else if (
                      // setsAreDifferent(
                      //   new Set(existingCall.fromPhoneList),
                      //   fromPhoneList
                      // ) ||
                      // setsAreDifferent(
                      //   new Set(existingCall.toPhoneList),
                      //   toPhoneList
                      // ) ||
                      //     setsAreDifferent(
                      //       new Set(existingCall.recordings),
                      //       recordingsList
                      //     ) ||
                      //     recordingExists !== existingCall.recordingExists ||
                      //     sentiment !== existingCall?.sentimentScore ||
                      //     disposition !== existingCall.disposition ||
                      //     fromLink !== existingCall?.fromLink ||
                      //     toLink !== existingCall?.toLink
                      //   ) {
                      //     addCall = {
                      //       ...existingCall,
                      //       recordings: Array.from(recordingsList),
                      //       //   recordingsNumber: recordingsList.size.toString(),
                      //       recordingExists,
                      //       sentimentScore: sentiment,
                      //       disposition,
                      //       dispositionTime,
                      //   fromPhoneList: Array.from(fromPhoneList),
                      //   toPhoneList: Array.from(toPhoneList),
                      //   fromPhoneList_index: Array.from(fromPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, existingCall.index]
                      //   ),
                      //   toPhoneList_index: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, existingCall.index]
                      //   ),
                      //   fromPhoneList_duration: Array.from(fromPhoneList).map(
                      //     (phoneNumber) => [
                      //       phoneNumber,
                      //       existingCall.duration || 0,
                      //     ]
                      //   ),
                      //   toPhoneList_duration: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [
                      //       phoneNumber,
                      //       existingCall.duration || 0,
                      //     ]
                      //   ),
                      //   fromPhoneList_direction_index: Array.from(
                      //     fromPhoneList
                      //   ).map((phoneNumber) => [
                      //     phoneNumber,
                      //     existingCall.direction || "",
                      //     existingCall.index,
                      //   ]),
                      //   toPhoneList_direction_index: Array.from(
                      //     toPhoneList
                      //   ).map((phoneNumber) => [
                      //     phoneNumber,
                      //     existingCall.direction || "",
                      //     existingCall.index,
                      //   ]),
                      //   fromPhoneList_result_index: Array.from(
                      //     fromPhoneList
                      //   ).map((phoneNumber) => [
                      //     phoneNumber,
                      //     existingCall.result || "",
                      //     existingCall.index,
                      //   ]),
                      //   toPhoneList_result_index: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [
                      //       phoneNumber,
                      //       existingCall.result || "",
                      //       existingCall.index,
                      //     ]
                      //   ),
                      //     };
                      //   }
                      // else got older one and no any new data - no action required
                    }

                    // no trancsript for now
                    // if (addCall !== undefined) {
                    //   addCall.transcript = newState.insights?.transcript;

                    //   if (
                    //     existingCall !== undefined &&
                    //     (existingCall.transcript as string | undefined) !==
                    //       undefined
                    //   ) {
                    //     widgetIncr.transcripts =
                    //       (widgetIncr.transcripts || 0) - 1;
                    //   }

                    //   if (
                    //     addCall !== undefined &&
                    //     (addCall.transcript as string | undefined) !== undefined
                    //   ) {
                    //     widgetIncr.transcripts =
                    //       (widgetIncr.transcripts || 0) + 1;
                    //   }
                    // }

                    if (addCall !== undefined) {
                      const updateRequest = callStore.put(addCall);

                      updateRequest.onsuccess = () => {
                        console.log('Record updated successfully', addCall);
                      };

                      updateRequest.onerror = (e) => {
                        console.error('Error updating record: ', (e.target as IDBRequest).error);
                      };

                      const callResults = graphData.get('Call Results')!.data;
                      const callType = graphData.get('Call Type')!.data;
                      const callRecordings = graphData.get('Call Recordings')!.data;
                      const sentimentScores = graphData.get('Sentiment Score')!.data;
                      const callStates = graphData.get('Call States')!.data;

                      const callResultKeys = [...callResults.keys()];
                      const sentimentScoreKeys = [...sentimentScores.keys()];
                      const callStateKeys = [...callStates.keys()];

                      if (addCall !== undefined) {
                        callResultKeys.forEach((key) => {
                          if (addCall?.result !== undefined && addCall?.result === key) {
                            callResults.set(key, callResults.get(key)! + 1);
                          }
                        });
                        callStateKeys.forEach((key) => {
                          if (addCall?.result !== undefined && addCall?.result === key) {
                            callStates.set(key, callStates.get(key)! + 1);
                          }
                        });
                        if (addCall?.direction === 'Outbound') {
                          callType.set('Outbound', callType.get('Outbound')! + 1);
                        }
                        if (addCall?.direction === 'Inbound') {
                          callType.set('Inbound', callType.get('Inbound')! + 1);
                        }
                        if (addCall?.direction === 'Internal') {
                          callType.set('Internal', callType.get('Internal')! + 1);
                        }
                        if (addCall !== undefined && (addCall?.transcript as string | undefined) !== undefined) {
                          callRecordings.set('Transcripts', callRecordings.get('Transcripts')! + 1);
                        }
                        if (addCall !== undefined && (addCall?.transcript as string | undefined) !== undefined) {
                          callRecordings.set('Recordings', callRecordings.get('Recordings')! + 1);
                        }
                        if (addCall?.sentimentScore !== undefined && addCall?.sentimentScore !== 'None') {
                          sentimentScoreKeys.forEach((key) => {
                            if (addCall?.sentimentScore === key) {
                              sentimentScores.set(key, sentimentScores.get(key)! + 1);
                            }
                          });
                        }
                      }

                      if (existingCall !== undefined) {
                        callResultKeys.forEach((key) => {
                          if (existingCall?.result !== undefined && existingCall?.result === key) {
                            callResults.set(key, callResults.get(key)! - 1);
                          }
                        });
                        callStateKeys.forEach((key) => {
                          if (existingCall?.result !== undefined && existingCall?.result === key) {
                            callStates.set(key, callStates.get(key)! - 1);
                          }
                        });
                        if (existingCall?.direction === 'Outbound') {
                          callType.set('Outbound', callType.get('Outbound')! - 1);
                        }
                        if (existingCall?.direction === 'Inbound') {
                          callType.set('Inbound', callType.get('Inbound')! - 1);
                        }
                        if (existingCall?.direction === 'Internal') {
                          callType.set('Internal', callType.get('Internal')! - 1);
                        }
                        if (
                          existingCall !== undefined &&
                          (existingCall?.transcript as string | undefined) !== undefined
                        ) {
                          callRecordings.set('Transcripts', callRecordings.get('Transcripts')! - 1);
                        }
                        if (
                          existingCall !== undefined &&
                          (existingCall?.transcript as string | undefined) !== undefined
                        ) {
                          callRecordings.set('Recordings', callRecordings.get('Recordings')! - 1);
                        }
                        if (existingCall?.sentimentScore !== undefined && existingCall?.sentimentScore !== 'None') {
                          sentimentScoreKeys.forEach((key) => {
                            if (existingCall?.sentimentScore === key) {
                              sentimentScores.set(key, sentimentScores.get(key)! - 1);
                            }
                          });
                        }
                      }
                    }

                    return resolve('success');
                  };

                  getCallRequest.onerror = (event) => reject((event.target as IDBOpenDBRequest).error);
                }
              }),
          ),
        );

        gridRef?.current?.api?.refreshServerSide();
        // indicate that db is populated (partially or finally)
        // setDbCleared(false);
        if (resp.next !== undefined) {
          let cb: Promise<void>;

          setProgress((oldProgress) => {
            // only attempt again if we haven't hit the upper limit
            if (oldProgress < 100) {
              cb = attempt(getCxData, resp.next, 10 * 1000);
            }
            return oldProgress + 10;
          });
        } else {
          setProgress(100);
        }
      };

      await attempt(getExData, undefined, 10 * 1000);
      if (cxEnabled) {
        await attempt(getCxData, undefined, 10 * 1000);
      }
      setLoading(false);
      // setLockFilters(false);
    },
    [token, organizationId, cxToken],
  );

  useEffect(() => {
    // fix fir switching between pages
    if (db !== null) {
      db.close();
      db = null;
    }
    // clear db on app load - doean't work without it
    window.indexedDB.deleteDatabase(dbName);
    setDbDeleted(true);
  }, []);

  useEffect(() => {
    if (!dbDeleted) {
      return;
    }
    // create db iinitially
    (async () => {
      const request: IDBOpenDBRequest = window.indexedDB.open(dbName, version);

      request.onerror = (event) => {
        // Handle errors
        console.log('error opening db');
      };

      request.onsuccess = (event) => {
        const myDb: IDBDatabase = (event.target as IDBOpenDBRequest).result;
        db = myDb;
        setDbCreated(true);
        console.log('Db created');
      };

      request.onupgradeneeded = async (event) => {
        const myDb: IDBDatabase = (event.target as IDBOpenDBRequest).result;

        // create call store
        const callObjectStore = myDb.createObjectStore(`calls-${organizationId}`, {
          keyPath: 'callId',
        });

        // create default indexes
        rangeColumns.concat(setColumns).forEach((col) => {
          callObjectStore.createIndex(col, col);
        });

        // multiSetColumns.forEach((col) => {
        //   callObjectStore.createIndex(col, col, {
        //     multiEntry: true,
        //   });
        // });

        // placeholder for all headlines
        rangeColumns.forEach((rangeCol) => {
          Array.from(graphData.values())
            .filter((graph) => graph.metric)
            .forEach((graph) => {
              callObjectStore.createIndex(`${graph.metric!}-${rangeCol}`, [graph.metric!, rangeCol]);
            });
        });

        // callObjectStore.transaction.oncomplete = () => {
        //   setIndexesModified(
        //     (oldIndexesModified) => (oldIndexesModified || 0) + 1
        //   );
        // };
      };
    })();
  }, [dbDeleted, organizationId]);

  useEffect(() => {
    // Ensure that db is cleared when populating it
    if (!dbCleared) {
      return;
    }
    // ensure that db is created when populating it
    if (!dbCreated) {
      return;
    }

    if (leaderboardUrl === undefined) {
      return;
    }

    setDbCleared(false); // solves problem with time range changes
    // get data based on dates
    (async () => {
      let myStart: string | undefined;
      let myEnd: string | undefined;

      switch (dateRangeSelected) {
        case 'initial': {
          const todayStart = new Date();
          todayStart.setHours(0, 0, 0, 0);
          myStart = todayStart.toISOString();
          break;
        }
        case 'today': {
          const todayStart = new Date();
          todayStart.setHours(0, 0, 0, 0);
          myStart = todayStart.toISOString();
          break;
        }
        case 'yesterday': {
          const todayStart = new Date();
          todayStart.setHours(0, 0, 0, 0);
          const yesterdayStart = new Date(todayStart);
          yesterdayStart.setDate(todayStart.getDate() - 1);
          myStart = yesterdayStart.toISOString();
          myEnd = todayStart.toISOString();
          break;
        }
        case 'last7Days': {
          const todayStart = new Date();
          todayStart.setHours(0, 0, 0, 0);
          const weekAgo = new Date(todayStart);
          weekAgo.setDate(todayStart.getDate() - 7);
          myStart = weekAgo.toISOString();
          myEnd = todayStart.toISOString();
          break;
        }
        case 'lastMonth': {
          const thisMonthStart = new Date();
          thisMonthStart.setHours(0, 0, 0, 0);
          thisMonthStart.setDate(1);
          const lastMonthStart = new Date(thisMonthStart);
          lastMonthStart.setMonth(thisMonthStart.getMonth() - 1);
          myStart = lastMonthStart.toISOString();
          myEnd = thisMonthStart.toISOString();
          break;
        }
        case 'thisMonth': {
          const monthStart = new Date();
          monthStart.setHours(0, 0, 0, 0);
          monthStart.setDate(1);
          myStart = monthStart.toISOString();
          break;
        }

        default: {
          const [start, end] = dateRangeSelected.split(',');
          myStart = start;
          if (end !== '') {
            myEnd = new Date(end).toISOString();
          }
          break;
        }
      }
      dateChanged = new Date().getTime();
      await fetchData(myStart, myEnd, dateChanged, leaderboardUrl.replace('/summary', '/call'));

      setIndexesModified((oldIndexesModified) => (oldIndexesModified || 0) + 1);
    })();
  }, [dbCleared, dateRangeSelected, fetchData, dbCreated, leaderboardUrl]);

  useEffect(() => {
    if (realTimeUserStates.length) {
      setRealTimeUserStates((realTimeStates) => realTimeStates.slice(1));
    }
  }, [realTimeUserStates]);

  useEffect(() => {
    if (realTimeUserStates.length && realTimeUserStates[0]) {
      setUserStateData((oldData) => (oldData || []).concat([[realTimeUserStates[0]]]));
    }
  }, [realTimeUserStates]);

  useEffect(() => {
    if (!dbCreated) {
      return;
    }
    if (userStateData?.length) {
      if (
        dateRangeSelected === 'yesterday' ||
        dateRangeSelected === 'lastMonth' ||
        dateRangeSelected === 'last7Days' ||
        (dateRangeSelected.includes(',') && dateRangeSelected.split(',')[1] !== '')
      ) {
        setUserStateData(() => []);
        return;
      }
      // data is paging
      setUserStateData((oldData) => oldData?.slice(1));
    }
  }, [dbCreated, userStateData, dateRangeSelected]);

  useEffect(() => {
    if (
      dateRangeSelected === 'yesterday' ||
      dateRangeSelected === 'lastMonth' ||
      dateRangeSelected === 'last7Days' ||
      (dateRangeSelected.includes(',') && dateRangeSelected.split(',')[1] !== '')
    ) {
      setProcessingUserState(undefined);
      return;
    }
    if (userStateData?.length && userStateData[0]) {
      setProcessingUserState(userStateData[0]);
    }
  }, [userStateData, dateRangeSelected]);

  useEffect(() => {
    if (!dbCreated) return;

    if (cxMessages.length) {
      if (
        dateRangeSelected === 'yesterday' ||
        dateRangeSelected === 'lastMonth' ||
        dateRangeSelected === 'last7Days' ||
        (dateRangeSelected.includes(',') && dateRangeSelected.split(',')[1] !== '')
      ) {
        setCxMessages(() => []);
        return;
      }
      setCxMessages((msgs) => msgs.slice(1));
    }
  }, [cxMessages, dbCreated, dateRangeSelected]);

  useEffect(() => {
    if (
      dateRangeSelected === 'yesterday' ||
      dateRangeSelected === 'lastMonth' ||
      dateRangeSelected === 'last7Days' ||
      (dateRangeSelected.includes(',') && dateRangeSelected.split(',')[1] !== '')
    ) {
      setProcessingCxMessage(undefined);
      return;
    }
    setProcessingCxMessage(cxMessages[0]);
  }, [cxMessages, dateRangeSelected]);

  useEffect(() => {
    const items = processingCxMessage;
    console.log('cx message', processingCxMessage);

    if (!dbCreated || items === undefined) {
      return;
    }

    // add or update calls in db
    (async () => {
      const widgetIncr: WidgetIncr = {};

      await Promise.all(
        items.map(
          async (newDelta) =>
            new Promise((resolve, reject) => {
              if (db !== null) {
                const myTransaction = db.transaction([`calls-${organizationId}`], 'readwrite');
                // Store values in objectStore.
                const callStore = myTransaction.objectStore(`calls-${organizationId}`);
                const getCallRequest = callStore.get(newDelta.callId);

                const durationInMs = newDelta.duration ? newDelta.duration * 1000 : 0;
                const index = new Date(newDelta.callStart).toISOString();

                getCallRequest.onsuccess = (event) => {
                  let addCall: Call | undefined;

                  const existingCall = (event.target as IDBRequest<Call>).result;

                  //   const fromPhoneList: Set<string> =
                  //     new Set(existingCall?.fromPhoneList) || new Set();
                  //   const toPhoneList: Set<string> =
                  //     new Set(existingCall?.toPhoneList) || new Set();
                  const recordingsList: Set<string> = new Set(existingCall?.recordings) || new Set();

                  //   if (newDelta.ani) {
                  //     fromPhoneList.add(newDelta.ani);
                  //   }
                  //   if (newDelta.dnis) {
                  //     toPhoneList.add(newDelta.dnis);
                  //   }

                  const recordingExists = 'No';
                  const direction = existingCall?.direction || newDelta.direction || 'Inbound';
                  const sentiment = 'None';
                  const callScore = 'None';

                  let disposition;
                  let dispositionTime;
                  if (
                    newDelta.agentDisposition &&
                    (existingCall?.dispositionTime === undefined ||
                      (existingCall?.dispositionTime &&
                        newDelta.timestamp &&
                        new Date(newDelta.timestamp).getTime() > new Date(existingCall?.dispositionTime).getTime()))
                  ) {
                    disposition = newDelta.agentDisposition;
                    dispositionTime = newDelta.timestamp;
                  } else if (existingCall?.disposition && existingCall?.dispositionTime) {
                    disposition = existingCall?.disposition;
                    dispositionTime = existingCall?.dispositionTime;
                  } else {
                    disposition = 'None';
                  }

                  const toLink = existingCall?.toLink === 'EX' || newDelta.toLink ? 'EX' : 'None';
                  const fromLink = existingCall?.fromLink === 'EX' || newDelta.fromLink ? 'EX' : 'None';

                  const toEx = existingCall?.toEx === 'true' || newDelta.toEx ? 'true' : '--';
                  const fromEx = existingCall?.fromEx === 'true' || newDelta.fromEx ? 'true' : '--';
                  const toCx = existingCall?.toCx === 'true' || newDelta.toCx ? 'true' : '--';
                  const fromCx = existingCall?.fromCx === 'true' || newDelta.fromCx ? 'true' : '--';

                  if (existingCall === undefined) {
                    // no such call in db yet - add it
                    let state = 'Unknown';
                    if (newDelta.extension === 'queue') {
                      if (newDelta.transferCount && newDelta.transferCount > 0) {
                        // if (
                        //   newDelta.transferDestination &&
                        //   regexCheck(
                        //     newDelta.transferDestination,
                        //     exPhonePattern
                        //   )
                        // ) {
                        //   state = "TRANSFERRED TO EX";
                        // }
                        state = 'TRANSFERRED';
                      } else if (newDelta.completedCount && newDelta.completedCount > 0) {
                        state = 'COMPLETE';
                      } else if (newDelta.voicemailCount && newDelta.voicemailCount > 0) {
                        state = 'VOICEMAIL';
                      } else if (newDelta.abandonedCount && newDelta.abandonedCount > 0) {
                        state = 'ABANDONED';
                      } else if (newDelta.activeCount && newDelta.activeCount > 0) {
                        state = 'ACTIVE';
                      } else if (newDelta.waitingCount && newDelta.waitingCount > 0) {
                        state = 'WAITING';
                      }
                    }

                    addCall = {
                      component: 'CX',
                      callId: newDelta.callId,
                      index,
                      recordings: Array.from(recordingsList),
                      fromLink,
                      toLink,
                      toCx,
                      fromCx,
                      toEx,
                      fromEx,
                      // recordingsNumber: recordingsList.size.toString(),
                      recordingExists,
                      sentimentScore: sentiment,
                      callScore,
                      disposition,
                      dispositionTime,
                      fromPhoneNumber: newDelta.ani,
                      toPhoneNumber: newDelta.dnis,
                      direction,
                      result: state,
                      duration: durationInMs,
                      users: [
                        {
                          index,
                          duration: durationInMs,
                          timestamp: newDelta.timestamp,
                          direction,
                          toPhoneNumber: newDelta.dnis,
                          fromPhoneNumber: newDelta.ani,
                          callId: newDelta.callId,
                          state,
                          extension: newDelta.extension,
                          extensionId: newDelta.extensionId,
                          waitingCount: newDelta.waitingCount,
                          activeCount: newDelta.activeCount,
                          completedCount: newDelta.completedCount,
                          abandonedCount: newDelta.abandonedCount,
                          voicemailCount: newDelta.voicemailCount,
                          transferCount: newDelta.transferCount,
                          transferDestination: newDelta.transferDestination,
                        },
                      ],
                      //   fromPhoneList: Array.from(fromPhoneList),
                      //   toPhoneList: Array.from(toPhoneList),
                      //   fromPhoneList_index: Array.from(fromPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, index]
                      //   ),
                      //   toPhoneList_index: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, index]
                      //   ),

                      //   fromPhoneList_duration: Array.from(fromPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, durationInMs]
                      //   ),
                      //   toPhoneList_duration: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, durationInMs]
                      //   ),
                      //   fromPhoneList_direction_index: Array.from(
                      //     fromPhoneList
                      //   ).map((phoneNumber) => [phoneNumber, direction, index]),
                      //   toPhoneList_direction_index: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, direction, index]
                      //   ),
                      //   fromPhoneList_result_index: Array.from(fromPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, state, index]
                      //   ),
                      //   toPhoneList_result_index: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, state, index]
                      //   ),
                    };
                  } else {
                    // call record already exists, might need to be updated
                    const callUsers = existingCall.users || [];
                    const userAdded = callUsers.find((delta) => delta.extensionId === newDelta.extensionId);
                    if (userAdded === undefined) {
                      let state = 'Unknown';
                      if (newDelta.extension === 'queue') {
                        if (newDelta.transferCount && newDelta.transferCount > 0) {
                          // if (
                          //   newDelta.transferDestination &&
                          //   regexCheck(
                          //     newDelta.transferDestination,
                          //     exPhonePattern
                          //   )
                          // ) {
                          //   state = "TRANSFERRED TO EX";
                          // }
                          state = 'TRANSFERRED';
                        } else if (newDelta.completedCount && newDelta.completedCount > 0) {
                          state = 'COMPLETE';
                        } else if (newDelta.voicemailCount && newDelta.voicemailCount > 0) {
                          state = 'VOICEMAIL';
                        } else if (newDelta.abandonedCount && newDelta.abandonedCount > 0) {
                          state = 'ABANDONED';
                        } else if (newDelta.activeCount && newDelta.activeCount > 0) {
                          state = 'ACTIVE';
                        } else if (newDelta.waitingCount && newDelta.waitingCount > 0) {
                          state = 'WAITING';
                        }
                      }
                      // no record about this user - call needs to be updated
                      callUsers.push({
                        index,
                        duration: durationInMs,
                        direction,
                        toPhoneNumber: newDelta.dnis,
                        fromPhoneNumber: newDelta.ani,
                        callId: newDelta.callId,
                        state,
                        extension: newDelta.extension,
                        extensionId: newDelta.extensionId,
                        timestamp: newDelta.timestamp,
                        waitingCount: newDelta.waitingCount,
                        activeCount: newDelta.activeCount,
                        completedCount: newDelta.completedCount,
                        abandonedCount: newDelta.abandonedCount,
                        voicemailCount: newDelta.voicemailCount,
                        transferCount: newDelta.transferCount,
                        transferDestination: newDelta.transferDestination,
                      });

                      const latestEnd = getLatestEnd(callUsers);
                      const earliestStart = getEarliestStart(callUsers);
                      const newDuration =
                        latestEnd && earliestStart ? latestEnd - new Date(earliestStart).getTime() : 0;
                      const latestDelta = getLatestDelta(callUsers);
                      const latestQueueDelta = getLatestDelta(
                        callUsers.filter((record) => record.extension === 'queue'),
                      );

                      addCall = {
                        ...existingCall,
                        index: earliestStart,
                        duration: newDuration,
                        direction,
                        result: latestQueueDelta ? latestQueueDelta.state : 'Unknown',
                        recordings: Array.from(recordingsList),
                        //   recordingsNumber: recordingsList.size.toString(),
                        recordingExists,
                        sentimentScore: sentiment,
                        callScore,
                        disposition,
                        dispositionTime,
                        fromLink,
                        toLink,
                        toCx,
                        fromCx,
                        toEx,
                        fromEx,
                        fromPhoneNumber: latestDelta.fromPhoneNumber?.toString(),
                        toPhoneNumber: latestDelta.toPhoneNumber?.toString(),
                        users: callUsers,
                        // fromPhoneList: Array.from(fromPhoneList),
                        // toPhoneList: Array.from(toPhoneList),
                        // fromPhoneList_index: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, earliestStart]
                        // ),
                        // toPhoneList_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, earliestStart]
                        // ),
                        // fromPhoneList_duration: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newDuration]
                        // ),
                        // toPhoneList_duration: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newDuration]
                        // ),
                        // fromPhoneList_direction_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   direction,
                        //   earliestStart,
                        // ]),
                        // toPhoneList_direction_index: Array.from(
                        //   toPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   direction,
                        //   earliestStart,
                        // ]),
                        // fromPhoneList_result_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   latestQueueDelta && latestQueueDelta.state
                        //     ? latestQueueDelta.state
                        //     : "Unknown",
                        //   earliestStart,
                        // ]),
                        // toPhoneList_result_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [
                        //     phoneNumber,
                        //     latestQueueDelta && latestQueueDelta.state
                        //       ? latestQueueDelta.state
                        //       : "Unknown",
                        //     earliestStart,
                        //   ]
                        // ),
                      };
                    } else if (userAdded) {
                      // update record
                      const updatedCallUsers = callUsers.map((delta) => {
                        if (delta.extensionId === newDelta.extensionId) {
                          let state = 'Unknown';

                          const completedCount: number = (newDelta.completedCount || 0) + (delta.completedCount || 0);
                          const abandonedCount: number = (newDelta.abandonedCount || 0) + (delta.abandonedCount || 0);
                          const waitingCount: number = (newDelta.waitingCount || 0) + (delta.waitingCount || 0);
                          const activeCount: number = (newDelta.activeCount || 0) + (delta.activeCount || 0);
                          const transferCount: number = (newDelta.transferCount || 0) + (delta.transferCount || 0);
                          const transferDestination = newDelta.transferDestination || delta.transferDestination;
                          const voicemailCount: number = (newDelta.voicemailCount || 0) + (delta.voicemailCount || 0);
                          if (newDelta.extension === 'queue') {
                            if (transferCount > 0) {
                              state = 'TRANSFERRED';
                            } else if (completedCount > 0) {
                              state = 'COMPLETE';
                            } else if (voicemailCount > 0) {
                              state = 'VOICEMAIL';
                            } else if (abandonedCount > 0) {
                              state = 'ABANDONED';
                            } else if (activeCount > 0) {
                              state = 'ACTIVE';
                            } else if (waitingCount > 0) {
                              state = 'WAITING';
                            }
                          }
                          return {
                            ...delta,
                            index,
                            duration: (delta.duration || 0) + durationInMs,
                            direction,
                            toPhoneNumber:
                              delta.timestamp === undefined ||
                              (newDelta.timestamp && newDelta.timestamp > delta.timestamp)
                                ? newDelta.dnis
                                : delta.toPhoneNumber,
                            fromPhoneNumber:
                              delta.timestamp === undefined ||
                              (newDelta.timestamp && newDelta.timestamp > delta.timestamp)
                                ? newDelta.ani
                                : delta.fromPhoneNumber,
                            callId: newDelta.callId,
                            state,

                            extension: newDelta.extension,
                            extensionId: newDelta.extensionId,
                            timestamp:
                              delta.timestamp === undefined ||
                              (newDelta.timestamp && newDelta.timestamp > delta.timestamp)
                                ? newDelta.timestamp
                                : delta.timestamp,
                            completedCount,
                            abandonedCount,
                            waitingCount,
                            activeCount,
                            voicemailCount,
                            transferCount,
                            transferDestination,
                          };
                        }
                        return delta;
                      });

                      const latestEnd = getLatestEnd(updatedCallUsers);
                      const earliestStart = getEarliestStart(updatedCallUsers);
                      const newDuration =
                        latestEnd && earliestStart ? latestEnd - new Date(earliestStart).getTime() : 0;
                      const latestDelta = getLatestDelta(updatedCallUsers);
                      const latestQueueDelta = getLatestDelta(
                        updatedCallUsers.filter((record) => record.extension === 'queue'),
                      );
                      addCall = {
                        ...existingCall,
                        recordings: Array.from(recordingsList),
                        //   recordingsNumber: recordingsList.size.toString(),
                        recordingExists,
                        sentimentScore: sentiment,
                        callScore,
                        index: earliestStart,
                        duration: newDuration,
                        disposition,
                        dispositionTime,
                        direction,
                        fromLink,
                        toLink,
                        toCx,
                        fromCx,
                        toEx,
                        fromEx,
                        result: latestQueueDelta ? latestQueueDelta.state : 'Unknown',
                        fromPhoneNumber: latestDelta.fromPhoneNumber?.toString(),
                        toPhoneNumber: latestDelta.toPhoneNumber?.toString(),
                        users: updatedCallUsers,
                        // fromPhoneList: Array.from(fromPhoneList),
                        // toPhoneList: Array.from(toPhoneList),
                        // fromPhoneList_index: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, earliestStart]
                        // ),
                        // toPhoneList_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, earliestStart]
                        // ),
                        // fromPhoneList_duration: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newDuration]
                        // ),
                        // toPhoneList_duration: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newDuration]
                        // ),
                        // fromPhoneList_direction_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   direction,
                        //   earliestStart,
                        // ]),
                        // toPhoneList_direction_index: Array.from(
                        //   toPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   direction,
                        //   earliestStart,
                        // ]),
                        // fromPhoneList_result_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   latestQueueDelta && latestQueueDelta.state
                        //     ? latestQueueDelta.state
                        //     : "Unknown",
                        //   earliestStart,
                        // ]),
                        // toPhoneList_result_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [
                        //     phoneNumber,
                        //     latestQueueDelta && latestQueueDelta.state
                        //       ? latestQueueDelta.state
                        //       : "Unknown",
                        //     earliestStart,
                        //   ]
                        // ),
                      };
                      // we should keep all phone numbers belong to this call, even older ones if they are not in db yet
                    }
                    // else if (
                    //   setsAreDifferent(
                    //     new Set(existingCall.fromPhoneList),
                    //     fromPhoneList
                    //   ) ||
                    //   setsAreDifferent(
                    //     new Set(existingCall.toPhoneList),
                    //     toPhoneList
                    //   ) ||
                    //   setsAreDifferent(
                    //     new Set(existingCall.recordings),
                    //     recordingsList
                    //   ) ||
                    //   recordingExists !== existingCall.recordingExists ||
                    //   sentiment !== existingCall?.sentimentScore ||
                    //   disposition !== existingCall.disposition ||
                    //   fromLink !== existingCall?.fromLink ||
                    //   toLink !== existingCall?.toLink
                    // ) {
                    //   addCall = {
                    //     ...existingCall,
                    //     recordings: Array.from(recordingsList),
                    //     //   recordingsNumber: recordingsList.size.toString(),
                    //     recordingExists,
                    //     sentimentScore: sentiment,
                    //     disposition,
                    //     dispositionTime,
                    //     // fromPhoneList: Array.from(fromPhoneList),
                    //     // toPhoneList: Array.from(toPhoneList),
                    //     // fromPhoneList_index: Array.from(fromPhoneList).map(
                    //     //   (phoneNumber) => [phoneNumber, existingCall.index]
                    //     // ),
                    //     // toPhoneList_index: Array.from(toPhoneList).map(
                    //     //   (phoneNumber) => [phoneNumber, existingCall.index]
                    //     // ),
                    //     // fromPhoneList_duration: Array.from(fromPhoneList).map(
                    //     //   (phoneNumber) => [
                    //     //     phoneNumber,
                    //     //     existingCall.duration || 0,
                    //     //   ]
                    //     // ),
                    //     // toPhoneList_duration: Array.from(toPhoneList).map(
                    //     //   (phoneNumber) => [
                    //     //     phoneNumber,
                    //     //     existingCall.duration || 0,
                    //     //   ]
                    //     // ),
                    //     // fromPhoneList_direction_index: Array.from(
                    //     //   fromPhoneList
                    //     // ).map((phoneNumber) => [
                    //     //   phoneNumber,
                    //     //   existingCall.direction || "",
                    //     //   existingCall.index,
                    //     // ]),
                    //     // toPhoneList_direction_index: Array.from(
                    //     //   toPhoneList
                    //     // ).map((phoneNumber) => [
                    //     //   phoneNumber,
                    //     //   existingCall.direction || "",
                    //     //   existingCall.index,
                    //     // ]),
                    //     // fromPhoneList_result_index: Array.from(
                    //     //   fromPhoneList
                    //     // ).map((phoneNumber) => [
                    //     //   phoneNumber,
                    //     //   existingCall.result || "",
                    //     //   existingCall.index,
                    //     // ]),
                    //     // toPhoneList_result_index: Array.from(toPhoneList).map(
                    //     //   (phoneNumber) => [
                    //     //     phoneNumber,
                    //     //     existingCall.result || "",
                    //     //     existingCall.index,
                    //     //   ]
                    //     // ),
                    //   };
                    // }
                    // else got older one and no any new data - no action required
                  }

                  //   if (addCall !== undefined) {
                  //     addCall.transcript = newState.insights?.transcript;

                  //     if (
                  //       existingCall !== undefined &&
                  //       (existingCall.transcript as string | undefined) !==
                  //         undefined
                  //     ) {
                  //       widgetIncr.transcripts =
                  //         (widgetIncr.transcripts || 0) - 1;
                  //     }

                  //     if (
                  //       addCall !== undefined &&
                  //       (addCall.transcript as string | undefined) !== undefined
                  //     ) {
                  //       widgetIncr.transcripts =
                  //         (widgetIncr.transcripts || 0) + 1;
                  //     }
                  //   }

                  if (addCall !== undefined) {
                    const updateRequest = callStore.put(addCall);

                    updateRequest.onsuccess = () => {
                      // console.log("Record updated successfully", addCall);
                    };

                    updateRequest.onerror = (e) => {
                      console.error('Error updating record: ', (e.target as IDBRequest).error);
                      reject((event.target as IDBOpenDBRequest).error);
                    };

                    const callResults = graphData.get('Call Results')!.data;
                    const callType = graphData.get('Call Type')!.data;
                    const callRecordings = graphData.get('Call Recordings')!.data;
                    const sentimentScores = graphData.get('Sentiment Score')!.data;
                    const callStates = graphData.get('Call States')!.data;

                    const callResultKeys = [...callResults.keys()];
                    const sentimentScoreKeys = [...sentimentScores.keys()];
                    const callStateKeys = [...callStates.keys()];

                    if (addCall !== undefined) {
                      callResultKeys.forEach((key) => {
                        if (addCall?.result !== undefined && addCall?.result === key) {
                          callResults.set(key, callResults.get(key)! + 1);
                        }
                      });
                      callStateKeys.forEach((key) => {
                        if (addCall?.result !== undefined && addCall?.result === key) {
                          callStates.set(key, callStates.get(key)! + 1);
                        }
                      });
                      if (addCall?.direction === 'Outbound') {
                        callType.set('Outbound', callType.get('Outbound')! + 1);
                      }
                      if (addCall?.direction === 'Inbound') {
                        callType.set('Inbound', callType.get('Inbound')! + 1);
                      }
                      if (addCall?.direction === 'Internal') {
                        callType.set('Internal', callType.get('Internal')! + 1);
                      }
                      if (addCall !== undefined && (addCall?.transcript as string | undefined) !== undefined) {
                        callRecordings.set('Transcripts', callRecordings.get('Transcripts')! + 1);
                      }
                      if (addCall !== undefined && (addCall?.transcript as string | undefined) !== undefined) {
                        callRecordings.set('Recordings', callRecordings.get('Recordings')! + 1);
                      }
                      if (addCall?.sentimentScore !== undefined && addCall?.sentimentScore !== 'None') {
                        sentimentScoreKeys.forEach((key) => {
                          if (addCall?.sentimentScore === key) {
                            sentimentScores.set(key, sentimentScores.get(key)! + 1);
                          }
                        });
                      }
                    }
                    if (existingCall !== undefined) {
                      callResultKeys.forEach((key) => {
                        if (existingCall?.result !== undefined && existingCall?.result === key) {
                          callResults.set(key, callResults.get(key)! - 1);
                        }
                      });
                      callStateKeys.forEach((key) => {
                        if (existingCall?.result !== undefined && existingCall?.result === key) {
                          callStates.set(key, callStates.get(key)! - 1);
                        }
                      });
                      if (existingCall?.direction === 'Outbound') {
                        callType.set('Outbound', callType.get('Outbound')! - 1);
                      }
                      if (existingCall?.direction === 'Inbound') {
                        callType.set('Inbound', callType.get('Inbound')! - 1);
                      }
                      if (existingCall?.direction === 'Internal') {
                        callType.set('Internal', callType.get('Internal')! - 1);
                      }
                      if (
                        existingCall !== undefined &&
                        (existingCall?.transcript as string | undefined) !== undefined
                      ) {
                        callRecordings.set('Transcripts', callRecordings.get('Transcripts')! - 1);
                      }
                      if (
                        existingCall !== undefined &&
                        (existingCall?.transcript as string | undefined) !== undefined
                      ) {
                        callRecordings.set('Recordings', callRecordings.get('Recordings')! - 1);
                      }
                      if (existingCall?.sentimentScore !== undefined && existingCall?.sentimentScore !== 'None') {
                        sentimentScoreKeys.forEach((key) => {
                          if (existingCall?.sentimentScore === key) {
                            sentimentScores.set(key, sentimentScores.get(key)! - 1);
                          }
                        });
                      }
                    }
                  }
                  return resolve('success');
                };

                getCallRequest.onerror = (event) => reject((event.target as IDBOpenDBRequest).error);
              }
            }),
        ),
      );

      setProcessingCxMessage(undefined);
      newEventsReceived = true;
    })();
  }, [processingCxMessage, dbCreated, organizationId]);

  useEffect(() => {
    const item = processingUserState;

    if (!dbCreated || item === undefined) {
      return;
    }

    // add or update calls in db
    (async () => {
      const widgetIncr: WidgetIncr = {};

      await Promise.all(
        item.map(
          async (newState) =>
            new Promise((resolve, reject) => {
              if (db !== null) {
                const myTransaction = db.transaction([`calls-${organizationId}`], 'readwrite');
                // Store values in objectStore.
                const callStore = myTransaction.objectStore(`calls-${organizationId}`);
                const getCallRequest = callStore.get(newState.callId);

                getCallRequest.onsuccess = (event) => {
                  let addCall: Call | undefined;

                  const existingCall = (event.target as IDBRequest<Call>).result;

                  //   const fromPhoneList: Set<string> =
                  //     new Set(existingCall?.fromPhoneList) || new Set();
                  //   const toPhoneList: Set<string> =
                  //     new Set(existingCall?.toPhoneList) || new Set();
                  const recordingsList: Set<string> = new Set(existingCall?.recordings) || new Set();
                  const recordingsReady: Set<string> = new Set(existingCall?.recordingsReady) || new Set();

                  // if (newState.fromPhoneNumber?.toString()) {
                  //   fromPhoneList.add(newState.fromPhoneNumber?.toString());
                  // }
                  // if (newState.toPhoneNumber?.toString()) {
                  //   toPhoneList.add(newState.toPhoneNumber?.split("-")[0]);
                  // }

                  if (newState.recordingId) {
                    recordingsList.add(newState.recordingId);
                  }
                  if (newState.recordingsReady && newState.recordingsReady.length > 0) {
                    newState.recordingsReady.forEach((i) => recordingsReady.add(i));
                  }

                  let recordingExists = 'No';

                  if (
                    existingCall?.recordingExists === 'Ready' ||
                    (newState.recordingsReady && newState.recordingsReady.length > 0)
                  ) {
                    recordingExists = 'Ready';
                  } else if (
                    existingCall?.recordingExists === 'Not Ready' ||
                    (newState.recordingId && recordingsReady.size === 0)
                  ) {
                    recordingExists = 'Not Ready';
                  }

                  let sentiment;
                  if (newState.insights?.sentimentScore !== undefined) {
                    sentiment = compareSentiments(existingCall?.sentimentScore, newState.insights?.sentimentScore);
                  } else if (existingCall?.sentimentScore) {
                    sentiment = existingCall?.sentimentScore;
                  } else {
                    sentiment = 'None';
                  }

                  let callScore;
                  if (newState.callScore !== undefined) {
                    callScore = newState.callScore;
                  } else if (existingCall?.callScore) {
                    callScore = existingCall?.callScore;
                  } else {
                    callScore = 'None';
                  }

                  let disposition;
                  let dispositionTime;
                  if (existingCall?.dispositionTime === undefined) {
                    disposition = newState.insights?.disposition
                      ? `${newState.insights.disposition.codeNumber}:${newState.insights.disposition.codeDescription}`
                      : 'None';
                    dispositionTime = newState.insights?.disposition?.time;
                  } else if (
                    existingCall?.dispositionTime &&
                    newState.insights?.disposition?.time &&
                    new Date(newState.insights?.disposition?.time).getTime() >
                      new Date(existingCall?.dispositionTime).getTime()
                  ) {
                    disposition = newState.insights?.disposition
                      ? `${newState.insights.disposition.codeNumber}:${newState.insights.disposition.codeDescription}`
                      : 'None';
                    dispositionTime = newState.insights?.disposition?.time;
                  } else {
                    disposition = existingCall?.disposition;
                    dispositionTime = existingCall?.dispositionTime;
                  }

                  const toLink = existingCall?.toLink === 'CX' || newState.toLink ? 'CX' : 'None';
                  const fromLink = existingCall?.fromLink === 'CX' || newState.fromLink ? 'CX' : 'None';

                  const toEx = existingCall?.toEx === 'true' || newState.toEx ? 'true' : '--';
                  const fromEx = existingCall?.fromEx === 'true' || newState.fromEx ? 'true' : '--';
                  const toCx = existingCall?.toCx === 'true' || newState.toCx ? 'true' : '--';
                  const fromCx = existingCall?.fromCx === 'true' || newState.fromCx ? 'true' : '--';
                  if (existingCall === undefined) {
                    // no such call in db yet - add it
                    addCall = {
                      component: 'EX',
                      callId: newState.callId,
                      index: newState.index.split('#')[0],
                      recordings: Array.from(recordingsList),
                      //   recordingsNumber: recordingsList.size.toString(),
                      recordingExists,
                      sentimentScore: sentiment,
                      callScore,
                      disposition,
                      dispositionTime,
                      fromLink,
                      toLink,
                      fromCx,
                      toCx,
                      fromEx,
                      toEx,
                      fromPhoneNumber: newState.fromPhoneNumber?.toString(),
                      toPhoneNumber: newState.toPhoneNumber?.split('-')[0],
                      direction: newState.direction,
                      result: newState.state?.split('-')[0] || '',
                      duration: newState.duration || 0,
                      users: [newState],
                      //   fromPhoneList: Array.from(fromPhoneList),
                      //   toPhoneList: Array.from(toPhoneList),
                      //   fromPhoneList_index: Array.from(fromPhoneList).map(
                      //     (phoneNumber) => [
                      //       phoneNumber,
                      //       newState.index.split("#")[0],
                      //     ]
                      //   ),
                      //   toPhoneList_index: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [
                      //       phoneNumber,
                      //       newState.index.split("#")[0],
                      //     ]
                      //   ),
                      //   fromPhoneList_duration: Array.from(fromPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, newState.duration || 0]
                      //   ),
                      //   toPhoneList_duration: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [phoneNumber, newState.duration || 0]
                      //   ),
                      //   fromPhoneList_direction_index: Array.from(
                      //     fromPhoneList
                      //   ).map((phoneNumber) => [
                      //     phoneNumber,
                      //     newState.direction,
                      //     newState.index.split("#")[0],
                      //   ]),
                      //   toPhoneList_direction_index: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [
                      //       phoneNumber,
                      //       newState.direction,
                      //       newState.index.split("#")[0],
                      //     ]
                      //   ),
                      //   fromPhoneList_result_index: Array.from(fromPhoneList).map(
                      //     (phoneNumber) => [
                      //       phoneNumber,
                      //       newState.state?.split("-")[0] || "",
                      //       newState.index.split("#")[0],
                      //     ]
                      //   ),
                      //   toPhoneList_result_index: Array.from(toPhoneList).map(
                      //     (phoneNumber) => [
                      //       phoneNumber,
                      //       newState.state?.split("-")[0] || "",
                      //       newState.index.split("#")[0],
                      //     ]
                      //   ),
                    };
                  } else {
                    // call record already exists, might need to be updated
                    const callUsers = existingCall.users || [];
                    const userAdded = callUsers.find((userState) => userState.userId === newState.userId);
                    if (userAdded === undefined) {
                      // no record about this user - call needs to be updated
                      callUsers.push({
                        ...newState,
                        index: newState.index.split('#')[0],
                      });

                      const latestEnd = getLatestEnd(callUsers);
                      const earliestStart = getEarliestStart(callUsers);
                      const newDuration =
                        latestEnd && earliestStart ? latestEnd - new Date(earliestStart).getTime() : 0;
                      const latestUserState = getLatestUserState(callUsers);
                      addCall = {
                        ...existingCall,
                        index: earliestStart,
                        duration: newDuration,
                        direction: latestUserState.direction,
                        result: latestUserState.state?.split('-')[0],
                        recordings: Array.from(recordingsList),
                        //   recordingsNumber: recordingsList.size.toString(),
                        recordingExists,
                        sentimentScore: sentiment,
                        callScore,
                        disposition,
                        dispositionTime,
                        fromPhoneNumber: latestUserState.fromPhoneNumber?.toString(),
                        toPhoneNumber: latestUserState.toPhoneNumber?.split('-')[0],
                        users: callUsers,
                        // fromPhoneList: Array.from(fromPhoneList),
                        // toPhoneList: Array.from(toPhoneList),
                        // fromPhoneList_index: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, earliestStart]
                        // ),
                        // toPhoneList_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, earliestStart]
                        // ),
                        // fromPhoneList_duration: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newDuration]
                        // ),
                        // toPhoneList_duration: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newDuration]
                        // ),
                        // fromPhoneList_direction_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   latestUserState.direction,
                        //   earliestStart,
                        // ]),
                        // toPhoneList_direction_index: Array.from(
                        //   toPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   latestUserState.direction,
                        //   earliestStart,
                        // ]),
                        // fromPhoneList_result_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   latestUserState.state?.split("-")[0] || "",
                        //   earliestStart,
                        // ]),
                        // toPhoneList_result_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [
                        //     phoneNumber,
                        //     latestUserState.state?.split("-")[0] || "",
                        //     earliestStart,
                        //   ]
                        // ),
                      };
                    }
                    // check if newState is recent one
                    else if (newState.duration && newState.duration > userAdded.duration) {
                      // update record
                      const updatedCallUsers = callUsers.map((userState) => {
                        if (userState.userId === newState.userId) {
                          return {
                            ...userState,
                            ...newState,
                            index: newState.index.split('#')[0],
                          };
                        }
                        return userState;
                      });

                      const latestEnd = getLatestEnd(updatedCallUsers);
                      const earliestStart = getEarliestStart(updatedCallUsers);
                      const newDuration =
                        latestEnd && earliestStart ? latestEnd - new Date(earliestStart).getTime() : 0;
                      const latestUserState = getLatestUserState(updatedCallUsers);
                      addCall = {
                        ...existingCall,
                        index: earliestStart,
                        duration: newDuration,
                        direction: latestUserState.direction,
                        result: latestUserState.state?.split('-')[0],
                        recordings: Array.from(recordingsList),
                        //   recordingsNumber: recordingsList.size.toString(),
                        recordingExists,
                        sentimentScore: sentiment,
                        callScore,
                        disposition,
                        dispositionTime,
                        fromLink,
                        toLink,
                        fromCx,
                        toCx,
                        fromEx,
                        toEx,
                        fromPhoneNumber: latestUserState.fromPhoneNumber?.toString(),
                        toPhoneNumber: latestUserState.toPhoneNumber?.split('-')[0],
                        users: updatedCallUsers,
                        // fromPhoneList: Array.from(fromPhoneList),
                        // toPhoneList: Array.from(toPhoneList),
                        // fromPhoneList_index: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, earliestStart]
                        // ),
                        // toPhoneList_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, earliestStart]
                        // ),
                        // fromPhoneList_duration: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newDuration]
                        // ),
                        // toPhoneList_duration: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, newDuration]
                        // ),
                        // fromPhoneList_direction_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   latestUserState.direction,
                        //   earliestStart,
                        // ]),
                        // toPhoneList_direction_index: Array.from(
                        //   toPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   latestUserState.direction,
                        //   earliestStart,
                        // ]),
                        // fromPhoneList_result_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   latestUserState.state?.split("-")[0] || "",
                        //   earliestStart,
                        // ]),
                        // toPhoneList_result_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [
                        //     phoneNumber,
                        //     latestUserState.state?.split("-")[0] || "",
                        //     earliestStart,
                        //   ]
                        // ),
                      };
                      // we should keep all phone numbers belong to this call, even older ones if they are not in db yet
                    } else if (
                      //   setsAreDifferent(
                      //     new Set(existingCall.fromPhoneList),
                      //     fromPhoneList
                      //   ) ||
                      //   setsAreDifferent(
                      //     new Set(existingCall.toPhoneList),
                      //     toPhoneList
                      //   ) ||
                      setsAreDifferent(new Set(existingCall.recordings), recordingsList) ||
                      recordingExists !== existingCall.recordingExists ||
                      sentiment !== existingCall?.sentimentScore ||
                      callScore !== existingCall?.callScore ||
                      disposition !== existingCall?.disposition ||
                      fromLink !== existingCall?.fromLink ||
                      toLink !== existingCall?.toLink ||
                      toCx !== existingCall?.toCx ||
                      fromCx !== existingCall?.fromCx ||
                      toEx !== existingCall?.toEx ||
                      fromEx !== existingCall?.fromEx
                    ) {
                      addCall = {
                        ...existingCall,
                        recordings: Array.from(recordingsList),
                        // recordingsNumber: recordingsList.size.toString(),
                        recordingExists,
                        sentimentScore: sentiment,
                        callScore,
                        disposition,
                        dispositionTime,
                        fromLink,
                        toLink,
                        toCx,
                        fromCx,
                        toEx,
                        fromEx,
                        // fromPhoneList: Array.from(fromPhoneList),
                        // toPhoneList: Array.from(toPhoneList),
                        // fromPhoneList_index: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, existingCall.index]
                        // ),
                        // toPhoneList_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [phoneNumber, existingCall.index]
                        // ),
                        // fromPhoneList_duration: Array.from(fromPhoneList).map(
                        //   (phoneNumber) => [
                        //     phoneNumber,
                        //     existingCall.duration || 0,
                        //   ]
                        // ),
                        // toPhoneList_duration: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [
                        //     phoneNumber,
                        //     existingCall.duration || 0,
                        //   ]
                        // ),
                        // fromPhoneList_direction_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   existingCall.direction || "",
                        //   existingCall.index,
                        // ]),
                        // toPhoneList_direction_index: Array.from(
                        //   toPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   existingCall.direction || "",
                        //   existingCall.index,
                        // ]),
                        // fromPhoneList_result_index: Array.from(
                        //   fromPhoneList
                        // ).map((phoneNumber) => [
                        //   phoneNumber,
                        //   existingCall.result || "",
                        //   existingCall.index,
                        // ]),
                        // toPhoneList_result_index: Array.from(toPhoneList).map(
                        //   (phoneNumber) => [
                        //     phoneNumber,
                        //     existingCall.result || "",
                        //     existingCall.index,
                        //   ]
                        // ),
                      };
                    }
                    // else got older one and no any new data - no action required
                  }

                  if (addCall !== undefined) {
                    addCall.transcript = newState.insights?.transcript;

                    if (existingCall !== undefined && (existingCall.transcript as string | undefined) !== undefined) {
                      widgetIncr.transcripts = (widgetIncr.transcripts || 0) - 1;
                    }

                    if (addCall !== undefined && (addCall.transcript as string | undefined) !== undefined) {
                      widgetIncr.transcripts = (widgetIncr.transcripts || 0) + 1;
                    }
                  }

                  if (addCall !== undefined) {
                    const updateRequest = callStore.put(addCall);

                    updateRequest.onsuccess = () => {
                      // console.log("Record updated successfully", addCall);
                    };

                    updateRequest.onerror = (e) => {
                      console.error('Error updating record: ', (e.target as IDBRequest).error);
                      reject((event.target as IDBOpenDBRequest).error);
                    };

                    // [
                    //   ["call", undefined, "calls"],
                    //   ["recordingExists", "Ready", "recordings"],
                    //   ["direction", "Inbound", "inbound"],
                    //   ["direction", "Outbound", "outbound"],
                    //   ["direction", "Internal", "internal"],
                    //   ["sentimentScore", "Very Positive", "veryPositive"],
                    //   ["sentimentScore", "Positive", "positive"],
                    //   ["sentimentScore", "Neutral", "neutral"],
                    //   ["sentimentScore", "Negative", "negative"],
                    //   ["sentimentScore", "Very Negative", "veryNegative"],
                    //   ["result", "ANSWERED", "answered"],
                    //   ["result", "ABANDONED", "abandoned"],
                    //   ["result", "QUEUE ABANDONED", "queueAbandoned"],
                    //   ["result", "FAX RECEIVED", "faxReceived"],
                    // ].forEach((temp: Array<any>) => {
                    //   if (
                    //     existingCall !== undefined &&
                    //     (existingCall[temp[0] as keyof Call] as
                    //       | string
                    //       | undefined) === temp[1]
                    //   ) {
                    //     widgetIncr[temp[2] as keyof WidgetIncr] =
                    //       (widgetIncr[temp[2] as keyof WidgetIncr] || 0) - 1;
                    //   }

                    //   if (
                    //     addCall !== undefined &&
                    //     (addCall[temp[0] as keyof Call] as
                    //       | string
                    //       | undefined) === temp[1]
                    //   ) {
                    //     widgetIncr[temp[2] as keyof WidgetIncr] =
                    //       (widgetIncr[temp[2] as keyof WidgetIncr] || 0) + 1;
                    //   }
                    // });
                    const callResults = graphData.get('Call Results')!.data;
                    const callType = graphData.get('Call Type')!.data;
                    const callRecordings = graphData.get('Call Recordings')!.data;
                    const sentimentScores = graphData.get('Sentiment Score')!.data;
                    const callStates = graphData.get('Call States')!.data;

                    const callResultKeys = [...callResults.keys()];
                    const sentimentScoreKeys = [...sentimentScores.keys()];
                    const callStateKeys = [...callStates.keys()];

                    if (addCall !== undefined) {
                      callResultKeys.forEach((key) => {
                        if (addCall?.result !== undefined && addCall?.result === key) {
                          callResults.set(key, callResults.get(key)! + 1);
                        }
                      });
                      callStateKeys.forEach((key) => {
                        if (addCall?.result !== undefined && addCall?.result === key) {
                          callStates.set(key, callStates.get(key)! + 1);
                        }
                      });
                      if (addCall?.direction === 'Outbound') {
                        callType.set('Outbound', callType.get('Outbound')! + 1);
                      }
                      if (addCall?.direction === 'Inbound') {
                        callType.set('Inbound', callType.get('Inbound')! + 1);
                      }
                      if (addCall?.direction === 'Internal') {
                        callType.set('Internal', callType.get('Internal')! + 1);
                      }
                      if (addCall !== undefined && (addCall?.transcript as string | undefined) !== undefined) {
                        callRecordings.set('Transcripts', callRecordings.get('Transcripts')! + 1);
                      }
                      if (addCall !== undefined && (addCall?.transcript as string | undefined) !== undefined) {
                        callRecordings.set('Recordings', callRecordings.get('Recordings')! + 1);
                      }
                      if (addCall?.sentimentScore !== undefined && addCall?.sentimentScore !== 'None') {
                        sentimentScoreKeys.forEach((key) => {
                          if (addCall?.sentimentScore === key) {
                            sentimentScores.set(key, sentimentScores.get(key)! + 1);
                          }
                        });
                      }
                    }
                    if (existingCall !== undefined) {
                      callResultKeys.forEach((key) => {
                        if (existingCall?.result !== undefined && existingCall?.result === key) {
                          callResults.set(key, callResults.get(key)! - 1);
                        }
                      });
                      callStateKeys.forEach((key) => {
                        if (existingCall?.result !== undefined && existingCall?.result === key) {
                          callStates.set(key, callStates.get(key)! - 1);
                        }
                      });
                      if (existingCall?.direction === 'Outbound') {
                        callType.set('Outbound', callType.get('Outbound')! - 1);
                      }
                      if (existingCall?.direction === 'Inbound') {
                        callType.set('Inbound', callType.get('Inbound')! - 1);
                      }
                      if (existingCall?.direction === 'Internal') {
                        callType.set('Internal', callType.get('Internal')! - 1);
                      }
                      if (
                        existingCall !== undefined &&
                        (existingCall?.transcript as string | undefined) !== undefined
                      ) {
                        callRecordings.set('Transcripts', callRecordings.get('Transcripts')! - 1);
                      }
                      if (
                        existingCall !== undefined &&
                        (existingCall?.transcript as string | undefined) !== undefined
                      ) {
                        callRecordings.set('Recordings', callRecordings.get('Recordings')! - 1);
                      }
                      if (existingCall?.sentimentScore !== undefined && existingCall?.sentimentScore !== 'None') {
                        sentimentScoreKeys.forEach((key) => {
                          if (existingCall?.sentimentScore === key) {
                            sentimentScores.set(key, sentimentScores.get(key)! - 1);
                          }
                        });
                      }
                    }
                  }
                  return resolve('success');
                };

                getCallRequest.onerror = (event) => reject((event.target as IDBOpenDBRequest).error);
              }
            }),
        ),
      );

      // setGraphData((oldGraphData) =>
      //   oldGraphData.map((temp) => {
      //     if (temp.name === "call result") {
      //       return {
      //         ...temp,
      //         data: [
      //           (temp.data[0] || 0) + (widgetIncr.answered || 0),
      //           (temp.data[1] || 0) + (widgetIncr.abandoned || 0),
      //           (temp.data[2] || 0) + (widgetIncr.queueAbandoned || 0),
      //           (temp.data[3] || 0) + (widgetIncr.faxReceived || 0),
      //         ],
      //       };
      //     }

      //     if (temp.name === "sentiment score") {
      //       return {
      //         ...temp,
      //         data: [
      //           (temp.data[0] || 0) + (widgetIncr.veryPositive || 0),
      //           (temp.data[1] || 0) + (widgetIncr.positive || 0),
      //           (temp.data[2] || 0) + (widgetIncr.neutral || 0),
      //           (temp.data[3] || 0) + (widgetIncr.negative || 0),
      //           (temp.data[4] || 0) + (widgetIncr.veryNegative || 0),
      //         ],
      //       };
      //     }

      //     if (temp.name === "call type") {
      //       return {
      //         ...temp,
      //         data: [
      //           (temp.data[0] || 0) + (widgetIncr.inbound || 0),
      //           (temp.data[1] || 0) + (widgetIncr.outbound || 0),
      //           (temp.data[2] || 0) + (widgetIncr.internal || 0),
      //         ],
      //       };
      //     }

      //     if (temp.name === "call recordings") {
      //       return {
      //         ...temp,
      //         data: [
      //           (temp.data[0] || 0) + (widgetIncr.calls || 0),
      //           (temp.data[1] || 0) + (widgetIncr.recordings || 0),
      //           (temp.data[2] || 0) + (widgetIncr.transcripts || 0),
      //         ],
      //       };
      //     }

      //     return temp;
      //   })
      // );
      setProcessingUserState(undefined);
      newEventsReceived = true;
    })();
  }, [processingUserState, dbCreated, organizationId]);

  useEffect(() => {
    let timeout: any;
    const checkForUpdate = () => {
      if (newEventsReceived === true) {
        newEventsReceived = false;
        // getUniqueValues();
        gridRef?.current?.api?.refreshServerSide();
      }
      timeout = setTimeout(checkForUpdate, 30000); // check for real time updates each 30 sec
    };
    checkForUpdate();
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const getSortedRows = useCallback(
    (startRow: number, endRow: number, sortCol: string, order: string): Promise<{ rows: Call[] }> =>
      new Promise((resolve, reject) => {
        if (db !== null) {
          const transaction = db.transaction(`calls-${organizationId}`, 'readonly');

          const objectStore = transaction.objectStore(`calls-${organizationId}`);
          const index = objectStore.index(sortCol);

          let cursorRequest: IDBRequest<IDBCursorWithValue | null>;
          if (order === 'desc') {
            cursorRequest = index.openCursor(null, 'prev');
          } else {
            cursorRequest = index.openCursor();
          }

          const rows: Call[] = [];
          let count: number = 0;

          // eslint-disable-next-line consistent-return
          cursorRequest.onsuccess = (event) => {
            const cursor = (event.target as IDBRequest).result as IDBCursorWithValue;

            if (cursor) {
              const value = cursor.value as Call;
              if (count < startRow) {
                count = startRow;
                // move cursor forward to startRow no porition
                cursor.advance(startRow);
              } else if (count >= startRow && count < endRow) {
                rows.push(value);
                count += 1;
                cursor.continue();
              } else {
                // go beyond the endRow
                return resolve({
                  rows,
                });
              }
            } else {
              // all data supplied
              return resolve({
                rows,
              });
            }
          };

          cursorRequest.onerror = (event) => {
            reject();
          };
        }
      }),
    [organizationId],
  );

  const getRowId = useMemo(() => (params: GetRowIdParams) => params.data.callId, []);

  const getSortedAndFilteredByOneCol = useCallback(
    (
      col: string,
      startRow: number,
      endRow: number,
      sortOrder: string | undefined,
      filterType: string | undefined,
      filterValue: string | undefined,
      filterValue2: string | undefined,
    ): Promise<{ rows: Call[] }> =>
      new Promise((resolve, reject) => {
        if (db !== null) {
          const transaction = db.transaction(`calls-${organizationId}`, 'readonly');
          const objectStore = transaction.objectStore(`calls-${organizationId}`);
          const index = objectStore.index(col);
          setLastIndex(col);
          let range: IDBKeyRange | null = null;

          if (col.toLowerCase().includes('duration')) {
            // duration filters
            const filterValueNum = durationStringToNumber(filterValue);
            const filterValueNum2 = durationStringToNumber(filterValue2);

            if (filterType === 'moreThan' && filterValueNum !== undefined) {
              range = IDBKeyRange.lowerBound(filterValueNum);
            } else if (filterType === 'lessThan' && filterValueNum !== undefined) {
              range = IDBKeyRange.upperBound(filterValueNum, true);
            } else if (filterType === 'between' && filterValueNum !== undefined && filterValueNum2 !== undefined) {
              if (filterValueNum2 < filterValueNum) {
                range = IDBKeyRange.lowerBound(filterValueNum);
              } else {
                range = IDBKeyRange.bound(filterValueNum, filterValueNum2);
              }
            }
          } else if (col === 'index') {
            if (filterType === 'moreThan' && filterValue !== undefined) {
              const utcFilterValue = convertIndexFilterValue(filterValue);
              if (utcFilterValue !== undefined) {
                range = IDBKeyRange.lowerBound(utcFilterValue);
              }
            } else if (filterType === 'lessThan' && filterValue !== undefined) {
              const utcFilterValue = convertIndexFilterValue(filterValue);
              if (utcFilterValue !== undefined) {
                range = IDBKeyRange.upperBound(utcFilterValue, true);
              }
            } else if (filterType === 'between' && filterValue !== undefined && filterValue2 !== undefined) {
              const utcFilterValue1 = convertIndexFilterValue(filterValue);
              const utcFilterValue2 = convertIndexFilterValue(filterValue2);
              if (utcFilterValue1 !== undefined && utcFilterValue2 !== undefined) {
                if (utcFilterValue2 < utcFilterValue1) {
                  range = IDBKeyRange.lowerBound(utcFilterValue1);
                } else {
                  range = IDBKeyRange.bound(utcFilterValue1, utcFilterValue2);
                }
              }
            }
          }

          let cursorRequest: IDBRequest<IDBCursorWithValue | null>;
          if (sortOrder === 'desc') {
            cursorRequest = index.openCursor(range, 'prev');
          } else {
            cursorRequest = index.openCursor(range);
          }

          const rows: Call[] = [];
          let count: number = 0;

          // eslint-disable-next-line consistent-return
          cursorRequest.onsuccess = (event) => {
            const cursor = (event.target as IDBRequest).result as IDBCursorWithValue;

            if (cursor === null) {
              return resolve({
                rows,
              });
            }
            const value = cursor.value as Call;
            if (cursor) {
              if (count < startRow) {
                count = startRow;
                // move cursor forward to startRow position
                cursor.advance(startRow);
              } else if (count >= startRow && count < endRow) {
                rows.push(value);
                count += 1;
                cursor.continue();
              } else {
                // go beyond the endRow
                return resolve({
                  rows,
                });
              }
            } else {
              // all data supplied
              return resolve({
                rows,
              });
            }
          };

          cursorRequest.onerror = (event) => reject();
        }
      }),
    [organizationId],
  );

  // get portioned data when set (direction) filter applied
  const getRowsBySetFilter = useCallback(
    (
      setCol: string,
      startRow: number,
      endRow: number,
      setFilterValues: string[],
      rangeCol: string,
      rangeColOrder: string | undefined,
      rangeFilterType: string | undefined,
      rangeFilterValue: string | undefined,
      rangeFilterValue2: string | undefined,
    ): Promise<{ rows: Call[] }> => {
      const getRowsForOneSetValue = async (
        _setCol: string,
        _startRow: number,
        _endRow: number,
        _setFilterValue: string,
        _rangeCol: string,
        _rangeColOrder: string | undefined,
        _rangeFilterType: string | undefined,
        _rangeFilterValue: string | undefined,
        _rangeFilterValue2: string | undefined,
      ): Promise<{ rows: Call[]; count: number }> =>
        new Promise((resolve, reject) => {
          if (db !== null) {
            let indexCount: number = 0;
            const transaction = db.transaction(`calls-${organizationId}`, 'readwrite');
            const objectStore = transaction.objectStore(`calls-${organizationId}`);
            const index = objectStore.index(`${_setCol}-${_rangeCol}`);
            setLastIndex(`${_setCol}-${_rangeCol}`);
            let range: IDBKeyRange | null = null;

            if (_rangeFilterType) {
              if (_rangeCol.toLowerCase().includes('duration')) {
                // duration filters
                const filterValueNum = durationStringToNumber(_rangeFilterValue);
                const filterValueNum2 = durationStringToNumber(_rangeFilterValue2);

                if (_rangeFilterType === 'moreThan' && filterValueNum !== undefined) {
                  range = IDBKeyRange.bound([_setFilterValue, filterValueNum], [_setFilterValue, Infinity]);
                } else if (_rangeFilterType === 'lessThan' && filterValueNum !== undefined) {
                  range = IDBKeyRange.bound([_setFilterValue, -1], [_setFilterValue, filterValueNum], undefined, true);
                } else if (
                  _rangeFilterType === 'between' &&
                  filterValueNum !== undefined &&
                  filterValueNum2 !== undefined
                ) {
                  if (filterValueNum2 < filterValueNum) {
                    range = IDBKeyRange.bound([_setFilterValue, filterValueNum], [_setFilterValue, Infinity]);
                  } else {
                    range = IDBKeyRange.bound([_setFilterValue, filterValueNum], [_setFilterValue, filterValueNum2]);
                  }
                }
              } else if (_rangeCol === 'index') {
                if (_rangeFilterType === 'afterDate' && _rangeFilterValue !== undefined) {
                  const utcFilterValue = convertIndexFilterValue(_rangeFilterValue);
                  if (utcFilterValue !== undefined) {
                    range = IDBKeyRange.bound([_setFilterValue, utcFilterValue], [_setFilterValue, '\uffff']);
                  }
                } else if (_rangeFilterType === 'beforeDate' && _rangeFilterValue !== undefined) {
                  const utcFilterValue = convertIndexFilterValue(_rangeFilterValue);
                  if (utcFilterValue !== undefined) {
                    range = IDBKeyRange.bound(
                      [_setFilterValue, ''],
                      [_setFilterValue, utcFilterValue],
                      undefined,
                      true,
                    );
                  }
                } else if (
                  _rangeFilterType === 'betweenDates' &&
                  _rangeFilterValue !== undefined &&
                  _rangeFilterValue2 !== undefined
                ) {
                  const utcFilterValue1 = convertIndexFilterValue(_rangeFilterValue);
                  const utcFilterValue2 = convertIndexFilterValue(_rangeFilterValue2);
                  if (utcFilterValue1 !== undefined && utcFilterValue2 !== undefined) {
                    if (utcFilterValue2 < utcFilterValue1) {
                      range = IDBKeyRange.bound([_setFilterValue, utcFilterValue1], [_setFilterValue, '\uffff']);
                    } else {
                      range = IDBKeyRange.bound([_setFilterValue, utcFilterValue1], [_setFilterValue, utcFilterValue2]);
                    }
                  }
                }
              }
            } else {
              range = IDBKeyRange.bound([_setFilterValue, -1], [_setFilterValue, '\uffff']);
            }
            const countRequest = range ? index.count(range) : index.count();
            // eslint-disable-next-line consistent-return
            countRequest.onsuccess = () => {
              indexCount = countRequest.result;
              if (indexCount < _startRow) {
                return resolve({
                  rows: [],
                  count: indexCount,
                });
              }
            };

            let cursorRequest: IDBRequest<IDBCursorWithValue | null>;
            if (_rangeColOrder === 'desc') {
              cursorRequest = index.openCursor(range, 'prev');
            } else {
              cursorRequest = index.openCursor(range);
            }

            const rows: Call[] = [];
            let count: number = 0;

            // eslint-disable-next-line consistent-return
            cursorRequest.onsuccess = (event) => {
              const cursor = (event.target as IDBRequest).result as IDBCursorWithValue;

              if (cursor === null) {
                return resolve({ rows, count: indexCount });
              }
              const value = cursor.value as Call;
              if (cursor) {
                if (count < _startRow) {
                  count = _startRow;
                  // move cursor forward to startRow position
                  cursor.advance(_startRow);
                } else if (count >= _startRow && count < _endRow) {
                  rows.push(value);
                  count += 1;
                  cursor.continue();
                } else {
                  // go beyond the endRow
                  return resolve({ rows, count: indexCount });
                }
              } else {
                // all data supplied
                return resolve({ rows, count: indexCount });
              }
            };

            cursorRequest.onerror = (event) => reject();
          }
        });

      const getData = async () => {
        let rowsViewed: number = 0;
        //   let rowsRetrieved: number = 0;
        const records = [];
        for (let i = 0; i < setFilterValues.length; i += 1) {
          const filterValue = setFilterValues[i];
          const rowsRetrieved = records.length;
          const newStartRow = startRow - rowsViewed < 0 ? 0 : startRow - rowsViewed;
          const newEndRow = endRow - rowsViewed;

          if (rowsRetrieved < endRow - startRow) {
            // find data on index
            // eslint-disable-next-line no-await-in-loop
            const myResult = await getRowsForOneSetValue(
              setCol,
              newStartRow,
              newEndRow,
              filterValue,
              rangeCol,
              rangeColOrder,
              rangeFilterType,
              rangeFilterValue,
              rangeFilterValue2,
            );
            records.push(...myResult.rows);
            rowsViewed += myResult.count;
          } else {
            // stop iteration when requiered number of records obtain
            break;
          }
        }

        return {
          rows: records,
        };
      };

      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        if (db !== null) {
          const transaction = db.transaction(`calls-${organizationId}`, 'readwrite');
          const objectStore = transaction.objectStore(`calls-${organizationId}`);

          const indexExists = objectStore.indexNames.contains(`${setCol}-${rangeCol}`);

          // placeholder for all headlines
          const headlinesIndexExists = Array.from(graphData.values())
            .filter((graph) => graph.metric)
            .map((graph) => ({
              metric: graph.metric,
              exists: objectStore.indexNames.contains(`${graph.metric!}-${setCol}-${rangeCol}`),
            }));

          // eslint-disable-next-line consistent-return
          transaction.oncomplete = async (event) => {
            if (!indexExists || headlinesIndexExists.find(({ exists }) => !exists)) {
              //   console.log(`Index doesn't exists.`);
              // index doesn't exist - create index

              const request: IDBOpenDBRequest = window.indexedDB.open(dbName, version + 1);

              db!.onversionchange = () => {
                db!.close();
              };

              request.onerror = (e) => {
                // Handle errors
                console.log('error opening db');
              };

              request.onsuccess = async (e) => {
                const myDb: IDBDatabase = (e.target as IDBOpenDBRequest).result;

                // save db and version to global var
                db = myDb;
                version += 1;
                setDbVersion(version);
                const result = await getData();
                setIndexesModified((oldIndexesModified) => (oldIndexesModified || 0) + 1);
                return resolve(result);
              };

              request.onupgradeneeded = async (e) => {
                // upgrade and create index
                // const myDb = (event.target as IDBOpenDBRequest).result;
                // console.log("upgrade");

                const myTransaction = (e.target as IDBOpenDBRequest).transaction;
                const myStore = myTransaction?.objectStore(`calls-${organizationId}`);
                if (!indexExists) {
                  myStore?.createIndex(`${setCol}-${rangeCol}`, [setCol, rangeCol]);
                }

                headlinesIndexExists
                  .filter(({ exists, metric }) => !exists && metric !== setCol)
                  .forEach(({ metric }) => {
                    myStore?.createIndex(`${metric!}-${setCol}-${rangeCol}`, [metric!, setCol, rangeCol]);
                  });

                // if (myStore) {
                //   myStore.transaction.oncomplete = () => {
                //     setIndexesModified(
                //       (oldIndexesModified) => (oldIndexesModified || 0) + 1
                //     );
                //   };
                // }
              };
            } else {
              const result = await getData();
              return resolve(result);
            }
          };
        }
      });
    },
    [organizationId],
  );

  // get portion data when one multiset filter applied (fromPhoneNumber or toPhoneNumber)
  //   const getRowsByMultiSetFilter = useCallback(
  //     (
  //       setCol: string,
  //       startRow: number,
  //       endRow: number,
  //       setFilterValues: string[],
  //       rangeCol: string,
  //       rangeColOrder: string | undefined,
  //       rangeFilterType: string | undefined,
  //       rangeFilterValue: string | undefined,
  //       rangeFilterValue2: string | undefined
  //     ): Promise<{ rows: Call[] }> => {
  //       const getRowsForOneSetValue = async (
  //         _setCol: string,
  //         _startRow: number,
  //         _endRow: number,
  //         _setFilterValue: string,
  //         _rangeCol: string,
  //         _rangeColOrder: string | undefined,
  //         _rangeFilterType: string | undefined,
  //         _rangeFilterValue: string | undefined,
  //         _rangeFilterValue2: string | undefined
  //       ): Promise<{ rows: Call[]; count: number }> =>
  //         new Promise((resolve, reject) => {
  //           if (db !== null) {
  //             let indexCount: number = 0;
  //             const transaction = db.transaction(
  //               `calls-${organizationId}`,
  //               "readwrite"
  //             );
  //             const objectStore = transaction.objectStore(
  //               `calls-${organizationId}`
  //             );
  //             const matchingCol = multiSetColumns.get(_setCol);
  //             const index = objectStore.index(`${matchingCol}_${_rangeCol}`);
  //             let range: IDBKeyRange | null = null;

  //             if (_rangeFilterType) {
  //               if (_rangeCol.toLowerCase().includes("duration")) {
  //                 // duration filters
  //                 const filterValueNum =
  //                   durationStringToNumber(_rangeFilterValue);
  //                 const filterValueNum2 =
  //                   durationStringToNumber(_rangeFilterValue2);

  //                 if (
  //                   _rangeFilterType === "moreThan" &&
  //                   filterValueNum !== undefined
  //                 ) {
  //                   range = IDBKeyRange.bound(
  //                     [_setFilterValue, filterValueNum],
  //                     [_setFilterValue, Infinity]
  //                   );
  //                 } else if (
  //                   _rangeFilterType === "lessThan" &&
  //                   filterValueNum !== undefined
  //                 ) {
  //                   range = IDBKeyRange.bound(
  //                     [_setFilterValue, -1],
  //                     [_setFilterValue, filterValueNum],
  //                     undefined,
  //                     true
  //                   );
  //                 } else if (
  //                   _rangeFilterType === "between" &&
  //                   filterValueNum !== undefined &&
  //                   filterValueNum2 !== undefined
  //                 ) {
  //                   if (filterValueNum2 < filterValueNum) {
  //                     range = IDBKeyRange.bound(
  //                       [_setFilterValue, filterValueNum],
  //                       [_setFilterValue, Infinity]
  //                     );
  //                   } else {
  //                     range = IDBKeyRange.bound(
  //                       [_setFilterValue, filterValueNum],
  //                       [_setFilterValue, filterValueNum2]
  //                     );
  //                   }
  //                 }
  //               } else if (_rangeCol === "index") {
  //                 if (
  //                   _rangeFilterType === "afterDate" &&
  //                   _rangeFilterValue !== undefined
  //                 ) {
  //                   const utcFilterValue =
  //                     convertIndexFilterValue(_rangeFilterValue);
  //                   if (utcFilterValue !== undefined) {
  //                     range = IDBKeyRange.bound(
  //                       [_setFilterValue, utcFilterValue],
  //                       [_setFilterValue, "\uffff"]
  //                     );
  //                   }
  //                 } else if (
  //                   _rangeFilterType === "beforeDate" &&
  //                   _rangeFilterValue !== undefined
  //                 ) {
  //                   const utcFilterValue =
  //                     convertIndexFilterValue(_rangeFilterValue);
  //                   if (utcFilterValue !== undefined) {
  //                     range = IDBKeyRange.bound(
  //                       [_setFilterValue, ""],
  //                       [_setFilterValue, utcFilterValue],
  //                       undefined,
  //                       true
  //                     );
  //                   }
  //                 } else if (
  //                   _rangeFilterType === "betweenDates" &&
  //                   _rangeFilterValue !== undefined &&
  //                   _rangeFilterValue2 !== undefined
  //                 ) {
  //                   const utcFilterValue =
  //                     convertIndexFilterValue(_rangeFilterValue);
  //                   const utcFilterValue2 =
  //                     convertIndexFilterValue(_rangeFilterValue2);
  //                   if (
  //                     utcFilterValue !== undefined &&
  //                     utcFilterValue2 !== undefined
  //                   ) {
  //                     if (utcFilterValue2 < utcFilterValue) {
  //                       range = IDBKeyRange.bound(
  //                         [_setFilterValue, utcFilterValue],
  //                         [_setFilterValue, "\uffff"]
  //                       );
  //                     } else {
  //                       range = IDBKeyRange.bound(
  //                         [_setFilterValue, utcFilterValue],
  //                         [_setFilterValue, utcFilterValue2]
  //                       );
  //                     }
  //                   }
  //                 }
  //               }
  //             } else {
  //               range = IDBKeyRange.bound(
  //                 [_setFilterValue, -1],
  //                 [_setFilterValue, "\uffff"]
  //               );
  //             }
  //             const countRequest = range ? index.count(range) : index.count();
  //             // eslint-disable-next-line consistent-return
  //             countRequest.onsuccess = () => {
  //               indexCount = countRequest.result;
  //               if (indexCount < _startRow) {
  //                 return resolve({
  //                   rows: [],
  //                   count: indexCount,
  //                 });
  //               }
  //             };

  //             let cursorRequest: IDBRequest<IDBCursorWithValue | null>;
  //             if (_rangeColOrder === "desc") {
  //               cursorRequest = index.openCursor(range, "prev");
  //             } else {
  //               cursorRequest = index.openCursor(range);
  //             }

  //             const rows: Call[] = [];
  //             let count: number = 0;

  //             // eslint-disable-next-line consistent-return
  //             cursorRequest.onsuccess = (event) => {
  //               const cursor = (event.target as IDBRequest)
  //                 .result as IDBCursorWithValue;

  //               if (cursor === null) {
  //                 return resolve({ rows, count: indexCount });
  //               }
  //               const value = cursor.value as Call;
  //               if (cursor) {
  //                 if (count < _startRow) {
  //                   count = _startRow;
  //                   // move cursor forward to startRow position
  //                   cursor.advance(_startRow);
  //                 } else if (count >= _startRow && count < _endRow) {
  //                   rows.push(value);
  //                   count += 1;
  //                   cursor.continue();
  //                 } else {
  //                   // go beyond the endRow
  //                   return resolve({ rows, count: indexCount });
  //                 }
  //               } else {
  //                 // all data supplied
  //                 return resolve({ rows, count: indexCount });
  //               }
  //             };

  //             cursorRequest.onerror = (event) => reject();
  //           }
  //         });

  //       const getData = async () => {
  //         let rowsViewed: number = 0;
  //         //   let rowsRetrieved: number = 0;
  //         const records = [];
  //         for (let i = 0; i < setFilterValues.length; i += 1) {
  //           const filterValue = setFilterValues[i];
  //           const rowsRetrieved = records.length;
  //           const newStartRow =
  //             startRow - rowsViewed < 0 ? 0 : startRow - rowsViewed;
  //           const newEndRow = endRow - rowsViewed;

  //           if (rowsRetrieved < endRow - startRow) {
  //             // find data on index
  //             // eslint-disable-next-line no-await-in-loop
  //             const myResult = await getRowsForOneSetValue(
  //               setCol,
  //               newStartRow,
  //               newEndRow,
  //               filterValue,
  //               rangeCol,
  //               rangeColOrder,
  //               rangeFilterType,
  //               rangeFilterValue,
  //               rangeFilterValue2
  //             );
  //             records.push(...myResult.rows);
  //             rowsViewed += myResult.count;
  //           } else {
  //             // stop iteration when requiered number of records obtain
  //             break;
  //           }
  //         }

  //         return {
  //           rows: records,
  //         };
  //       };
  //       // eslint-disable-next-line no-async-promise-executor
  //       return new Promise(async (resolve, reject) => {
  //         if (db !== null) {
  //           const transaction = db.transaction(
  //             `calls-${organizationId}`,
  //             "readwrite"
  //           );
  //           const objectStore = transaction.objectStore(
  //             `calls-${organizationId}`
  //           );
  //           const matchingCol = multiSetColumns.get(setCol);
  //           const indexExists = objectStore.indexNames.contains(
  //             `${matchingCol}_${rangeCol}`
  //           );
  //           const headlinesIndexExists = objectStore.indexNames.contains(
  //             `${matchingCol}_result_${rangeCol}`
  //           );

  //           // eslint-disable-next-line consistent-return
  //           transaction.oncomplete = async (event) => {
  //             if (!indexExists || !headlinesIndexExists) {
  //               // index doesn't exist - create index
  //               const request: IDBOpenDBRequest = window.indexedDB.open(
  //                 dbName,
  //                 version + 1
  //               );

  //               db!.onversionchange = () => {
  //                 db!.close();
  //               };
  //               request.onerror = (e) => {
  //                 // Handle errors
  //                 console.log("error opening db");
  //               };

  //               request.onsuccess = async (e) => {
  //                 const myDb: IDBDatabase = (e.target as IDBOpenDBRequest).result;

  //                 // save db and version to global var
  //                 db = myDb;
  //                 version += 1;

  //                 const result = await getData();
  //                 setIndexesModified(
  //                   (oldIndexesModified) => (oldIndexesModified || 0) + 1
  //                 );
  //                 return resolve(result);
  //               };

  //               request.onupgradeneeded = async (e) => {
  //                 // upgrade and create index
  //                 const myTransaction = (e.target as IDBOpenDBRequest)
  //                   .transaction;
  //                 const myStore = myTransaction?.objectStore(
  //                   `calls-${organizationId}`
  //                 );

  //                 if (!indexExists) {
  //                   myStore?.createIndex(
  //                     `${matchingCol}_${rangeCol}`,
  //                     `${matchingCol}_${rangeCol}`,
  //                     { multiEntry: true }
  //                   );
  //                 }

  //                 // placeholder for all headlines
  //                 if (!headlinesIndexExists) {
  //                   myStore?.createIndex(
  //                     `${matchingCol}_result_${rangeCol}`,
  //                     `${matchingCol}_result_${rangeCol}`,
  //                     { multiEntry: true }
  //                   );
  //                 }

  //                 // if (myStore) {
  //                 //   myStore.transaction.oncomplete = () => {
  //                 //     setIndexesModified(
  //                 //       (oldIndexesModified) => (oldIndexesModified || 0) + 1
  //                 //     );
  //                 //   };
  //                 // }
  //               };
  //             } else {
  //               const result = await getData();
  //               return resolve(result);
  //             }
  //           };
  //         }
  //       });
  //     },
  //     [organizationId]
  //   );

  //   get portioned data when fromPhoneNumber AND toPhoneNumber filter applied
  const getRowsBy2SetFilters = useCallback(
    (
      setCol1: string,
      setCol2: string,
      startRow: number,
      endRow: number,
      setFilter1Value: string,
      setFilter2Values: string[],
      rangeCol: string,
      rangeColOrder: string | undefined,
      rangeFilterType: string | undefined,
      rangeFilterValue: string | undefined,
      rangeFilterValue2: string | undefined,
    ): Promise<{ rows: Call[] }> => {
      const getRowsForOneValue = async (
        _setCol1: string,
        _setCol2: string,
        _startRow: number,
        _endRow: number,
        _setFilter1Value: string,
        _setFilter2Value: string,
        _rangeCol: string,
        _rangeColOrder: string | undefined,
        _rangeFilterType: string | undefined,
        _rangeFilterValue: string | undefined,
        _rangeFilterValue2: string | undefined,
      ): Promise<{ rows: Call[]; count: number }> =>
        new Promise((resolve, reject) => {
          if (db !== null) {
            let indexCount: number = 0;
            const transaction = db.transaction(`calls-${organizationId}`, 'readwrite');
            const objectStore = transaction.objectStore(`calls-${organizationId}`);
            const index = objectStore.index(`${_setCol1}-${_setCol2}-${_rangeCol}`);
            setLastIndex(`${_setCol1}-${_setCol2}-${_rangeCol}`);
            let range: IDBKeyRange | null = null;

            if (_rangeFilterType) {
              if (_rangeCol.toLowerCase().includes('duration')) {
                // duration filters
                const filterValueNum = durationStringToNumber(_rangeFilterValue);
                const filterValueNum2 = durationStringToNumber(_rangeFilterValue2);

                if (_rangeFilterType === 'moreThan' && filterValueNum !== undefined) {
                  range = IDBKeyRange.bound(
                    [_setFilter1Value, _setFilter2Value, filterValueNum],
                    [_setFilter1Value, _setFilter2Value, Infinity],
                  );
                } else if (_rangeFilterType === 'lessThan' && filterValueNum !== undefined) {
                  range = IDBKeyRange.bound(
                    [_setFilter1Value, _setFilter2Value, -1],
                    [_setFilter1Value, _setFilter2Value, filterValueNum],
                    undefined,
                    true,
                  );
                } else if (
                  _rangeFilterType === 'between' &&
                  filterValueNum !== undefined &&
                  filterValueNum2 !== undefined
                ) {
                  if (filterValueNum2 < filterValueNum) {
                    range = IDBKeyRange.bound(
                      [_setFilter1Value, _setFilter2Value, filterValueNum],
                      [_setFilter1Value, _setFilter2Value, Infinity],
                    );
                  } else {
                    range = IDBKeyRange.bound(
                      [_setFilter1Value, _setFilter2Value, filterValueNum],
                      [_setFilter1Value, _setFilter2Value, filterValueNum2],
                    );
                  }
                }
              } else if (_rangeCol === 'index') {
                if (_rangeFilterType === 'afterDate' && _rangeFilterValue !== undefined) {
                  const utcFilterValue = convertIndexFilterValue(_rangeFilterValue);
                  if (utcFilterValue !== undefined) {
                    range = IDBKeyRange.bound(
                      [_setFilter1Value, _setFilter2Value, utcFilterValue],
                      [_setFilter1Value, _setFilter2Value, '\uffff'],
                    );
                  }
                } else if (_rangeFilterType === 'beforeDate' && _rangeFilterValue !== undefined) {
                  const utcFilterValue = convertIndexFilterValue(_rangeFilterValue);
                  if (utcFilterValue !== undefined) {
                    range = IDBKeyRange.bound(
                      [_setFilter1Value, _setFilter2Value, ''],
                      [_setFilter1Value, _setFilter2Value, utcFilterValue],
                      undefined,
                      true,
                    );
                  }
                } else if (
                  _rangeFilterType === 'betweenDates' &&
                  _rangeFilterValue !== undefined &&
                  _rangeFilterValue2 !== undefined
                ) {
                  const utcFilterValue = convertIndexFilterValue(_rangeFilterValue);
                  const utcFilterValue2 = convertIndexFilterValue(_rangeFilterValue2);
                  if (utcFilterValue !== undefined && utcFilterValue2 !== undefined) {
                    if (utcFilterValue2 < utcFilterValue) {
                      range = IDBKeyRange.bound(
                        [_setFilter1Value, _setFilter2Value, utcFilterValue],
                        [_setFilter1Value, _setFilter2Value, '\uffff'],
                      );
                    } else {
                      range = IDBKeyRange.bound(
                        [_setFilter1Value, _setFilter2Value, utcFilterValue],
                        [_setFilter1Value, _setFilter2Value, utcFilterValue2],
                      );
                    }
                  }
                }
              }
            } else {
              range = IDBKeyRange.bound(
                [_setFilter1Value, _setFilter2Value, -1],
                [_setFilter1Value, _setFilter2Value, '\uffff'],
              );
            }
            const countRequest = range ? index.count(range) : index.count();
            // eslint-disable-next-line consistent-return
            countRequest.onsuccess = () => {
              indexCount = countRequest.result;
              if (indexCount < _startRow) {
                return resolve({
                  rows: [],
                  count: indexCount,
                });
              }
            };

            let cursorRequest: IDBRequest<IDBCursorWithValue | null>;
            if (_rangeColOrder === 'desc') {
              cursorRequest = index.openCursor(range, 'prev');
            } else {
              cursorRequest = index.openCursor(range);
            }

            const rows: Call[] = [];
            let count: number = 0;

            // eslint-disable-next-line consistent-return
            cursorRequest.onsuccess = (event) => {
              const cursor = (event.target as IDBRequest).result as IDBCursorWithValue;

              if (cursor === null) {
                return resolve({ rows, count: indexCount });
              }
              const value = cursor.value as Call;
              if (cursor) {
                if (count < _startRow) {
                  count = _startRow;
                  // move cursor forward to startRow position
                  cursor.advance(_startRow);
                } else if (count >= _startRow && count < _endRow) {
                  rows.push(value);
                  count += 1;
                  cursor.continue();
                } else {
                  // go beyond the endRow
                  return resolve({ rows, count: indexCount });
                }
              } else {
                // all data supplied
                return resolve({ rows, count: indexCount });
              }
            };

            cursorRequest.onerror = (event) => reject();
          }
        });

      const getData = async () => {
        let rowsViewed: number = 0;
        //   let rowsRetrieved: number = 0;
        const records = [];
        for (let i = 0; i < setFilter2Values.length; i += 1) {
          const filter2Value = setFilter2Values[i];
          const rowsRetrieved = records.length;
          const newStartRow = startRow - rowsViewed < 0 ? 0 : startRow - rowsViewed;
          const newEndRow = endRow - rowsViewed;

          if (rowsRetrieved < endRow - startRow) {
            // find data on index
            // eslint-disable-next-line no-await-in-loop
            const myResult = await getRowsForOneValue(
              setCol1,
              setCol2,
              newStartRow,
              newEndRow,
              setFilter1Value,
              filter2Value,
              rangeCol,
              rangeColOrder,
              rangeFilterType,
              rangeFilterValue,
              rangeFilterValue2,
            );
            records.push(...myResult.rows);
            rowsViewed += myResult.count;
          } else {
            // stop iteration when requiered number of records obtained
            break;
          }
        }

        return {
          rows: records,
        };
      };
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        if (db !== null) {
          const transaction = db.transaction(`calls-${organizationId}`, 'readwrite');
          const objectStore = transaction.objectStore(`calls-${organizationId}`);
          const indexExists = objectStore.indexNames.contains(`${setCol1}-${setCol2}-${rangeCol}`);

          // placeholder for all headlines
          const headlinesIndexExists = Array.from(graphData.values())
            .filter((graph) => graph.metric)
            .map((graph) => ({
              metric: graph.metric,
              exists: objectStore.indexNames.contains(`${graph.metric!}-${setCol1}-${setCol2}-${rangeCol}`),
            }));

          // eslint-disable-next-line consistent-return
          transaction.oncomplete = async (event) => {
            if (!indexExists || headlinesIndexExists.find(({ exists }) => !exists)) {
              //   console.log(`Index doesn't exists.`);
              // index doesn't exist - create index

              const request: IDBOpenDBRequest = window.indexedDB.open(dbName, version + 1);

              db!.onversionchange = () => {
                db!.close();
              };

              request.onerror = (e) => {
                // Handle errors
                console.log('error opening db');
              };

              request.onsuccess = async (e) => {
                const myDb: IDBDatabase = (e.target as IDBOpenDBRequest).result;

                // save db and version to global var
                db = myDb;
                version += 1;
                setDbVersion(version);
                const result = await getData();
                setIndexesModified((oldIndexesModified) => (oldIndexesModified || 0) + 1);
                return resolve(result);
              };

              request.onupgradeneeded = async (e) => {
                // upgrade and create index
                const myTransaction = (e.target as IDBOpenDBRequest).transaction;
                const myStore = myTransaction?.objectStore(`calls-${organizationId}`);

                if (!indexExists) {
                  myStore?.createIndex(`${setCol1}-${setCol2}-${rangeCol}`, [setCol1, setCol2, rangeCol]);
                }

                // placeholder for all headlines
                headlinesIndexExists
                  .filter(({ exists, metric }) => !exists && metric !== setCol1 && metric !== setCol2)
                  .forEach(({ metric }) => {
                    myStore?.createIndex(`${metric!}-${setCol1}-${setCol2}-${rangeCol}`, [
                      metric!,
                      setCol1,
                      setCol2,
                      rangeCol,
                    ]);
                  });

                // if (myStore) {
                //   myStore.transaction.oncomplete = () => {
                //     setIndexesModified(
                //       (oldIndexesModified) => (oldIndexesModified || 0) + 1
                //     );
                //   };
                // }
              };
            } else {
              const result = await getData();
              return resolve(result);
            }
          };
        }
      });
    },
    [organizationId],
  );

  //   const getRowsBySetMultisetFilters = useCallback(
  //     (
  //       manyValuesFilter: string, // the coll that has more values
  //       multiSetCol: string,
  //       setCol: string,
  //       startRow: number,
  //       endRow: number,
  //       multiSetFilterValues: string[],
  //       setFilterValues: string[],
  //       rangeCol: string,
  //       rangeColOrder: string | undefined,
  //       rangeFilterType: string | undefined,
  //       rangeFilterValue: string | undefined,
  //       rangeFilterValue2: string | undefined
  //     ): Promise<{ rows: Call[] }> => {
  //       const getRowsForOneValue = async (
  //         _multiSetCol: string,
  //         _setCol: string,
  //         _startRow: number,
  //         _endRow: number,
  //         _multiSetFilterValue: string,
  //         _setFilterValue: string,
  //         _rangeCol: string,
  //         _rangeColOrder: string | undefined,
  //         _rangeFilterType: string | undefined,
  //         _rangeFilterValue: string | undefined,
  //         _rangeFilterValue2: string | undefined
  //       ): Promise<{ rows: Call[]; count: number }> =>
  //         new Promise((resolve, reject) => {
  //           if (db !== null) {
  //             let indexCount: number = 0;
  //             const transaction = db.transaction(
  //               `calls-${organizationId}`,
  //               "readwrite"
  //             );
  //             const objectStore = transaction.objectStore(
  //               `calls-${organizationId}`
  //             );
  //             const matchingCol = multiSetColumns.get(_multiSetCol);
  //             const index = objectStore.index(
  //               `${matchingCol}_${_setCol}_${_rangeCol}`
  //             );
  //             let range: IDBKeyRange | null = null;

  //             if (_rangeFilterType) {
  //               if (_rangeCol === "index") {
  //                 if (
  //                   _rangeFilterType === "afterDate" &&
  //                   _rangeFilterValue !== undefined
  //                 ) {
  //                   const utcFilterValue =
  //                     convertIndexFilterValue(_rangeFilterValue);
  //                   if (utcFilterValue !== undefined) {
  //                     range = IDBKeyRange.bound(
  //                       [_multiSetFilterValue, _setFilterValue, utcFilterValue],
  //                       [_multiSetFilterValue, _setFilterValue, "\uffff"]
  //                     );
  //                   }
  //                 } else if (
  //                   _rangeFilterType === "beforeDate" &&
  //                   _rangeFilterValue !== undefined
  //                 ) {
  //                   const utcFilterValue =
  //                     convertIndexFilterValue(_rangeFilterValue);
  //                   if (utcFilterValue !== undefined) {
  //                     range = IDBKeyRange.bound(
  //                       [_multiSetFilterValue, _setFilterValue, ""],
  //                       [_multiSetFilterValue, _setFilterValue, utcFilterValue],
  //                       undefined,
  //                       true
  //                     );
  //                   }
  //                 } else if (
  //                   _rangeFilterType === "betweenDates" &&
  //                   _rangeFilterValue !== undefined &&
  //                   _rangeFilterValue2 !== undefined
  //                 ) {
  //                   const utcFilterValue =
  //                     convertIndexFilterValue(_rangeFilterValue);
  //                   const utcFilterValue2 =
  //                     convertIndexFilterValue(_rangeFilterValue2);
  //                   if (
  //                     utcFilterValue !== undefined &&
  //                     utcFilterValue2 !== undefined
  //                   ) {
  //                     if (utcFilterValue2 < utcFilterValue) {
  //                       range = IDBKeyRange.bound(
  //                         [_multiSetFilterValue, _setFilterValue, utcFilterValue],
  //                         [_multiSetFilterValue, _setFilterValue, "\uffff"]
  //                       );
  //                     } else {
  //                       range = IDBKeyRange.bound(
  //                         [_multiSetFilterValue, _setFilterValue, utcFilterValue],
  //                         [_multiSetFilterValue, _setFilterValue, utcFilterValue2]
  //                       );
  //                     }
  //                   }
  //                 }
  //               }
  //             } else {
  //               range = IDBKeyRange.bound(
  //                 [_multiSetFilterValue, _setFilterValue, -1],
  //                 [_multiSetFilterValue, _setFilterValue, "\uffff"]
  //               );
  //             }
  //             const countRequest = range ? index.count(range) : index.count();
  //             // eslint-disable-next-line consistent-return
  //             countRequest.onsuccess = () => {
  //               indexCount = countRequest.result;
  //               if (indexCount < _startRow) {
  //                 return resolve({
  //                   rows: [],
  //                   count: indexCount,
  //                 });
  //               }
  //             };

  //             let cursorRequest: IDBRequest<IDBCursorWithValue | null>;
  //             if (_rangeColOrder === "desc") {
  //               cursorRequest = index.openCursor(range, "prev");
  //             } else {
  //               cursorRequest = index.openCursor(range);
  //             }

  //             const rows: Call[] = [];
  //             let count: number = 0;

  //             // eslint-disable-next-line consistent-return
  //             cursorRequest.onsuccess = (event) => {
  //               const cursor = (event.target as IDBRequest)
  //                 .result as IDBCursorWithValue;

  //               if (cursor === null) {
  //                 return resolve({ rows, count: indexCount });
  //               }
  //               const value = cursor.value as Call;
  //               if (cursor) {
  //                 if (count < _startRow) {
  //                   count = _startRow;
  //                   // move cursor forward to startRow position
  //                   cursor.advance(_startRow);
  //                 } else if (count >= _startRow && count < _endRow) {
  //                   rows.push(value);
  //                   count += 1;
  //                   cursor.continue();
  //                 } else {
  //                   // go beyond the endRow
  //                   return resolve({ rows, count: indexCount });
  //                 }
  //               } else {
  //                 // all data supplied
  //                 return resolve({ rows, count: indexCount });
  //               }
  //             };

  //             cursorRequest.onerror = (event) => reject();
  //           }
  //         });

  //       const getData = async () => {
  //         let rowsViewed: number = 0;
  //         //   let rowsRetrieved: number = 0;
  //         const records = [];

  //         // set filter has 1 value, multiset has several values
  //         if (manyValuesFilter === "multiset") {
  //           for (let i = 0; i < multiSetFilterValues.length; i += 1) {
  //             const rowsRetrieved = records.length;
  //             const newStartRow =
  //               startRow - rowsViewed < 0 ? 0 : startRow - rowsViewed;
  //             const newEndRow = endRow - rowsViewed;

  //             if (rowsRetrieved < endRow - startRow) {
  //               // find data on index
  //               // eslint-disable-next-line no-await-in-loop
  //               const myResult = await getRowsForOneValue(
  //                 multiSetCol,
  //                 setCol,
  //                 newStartRow,
  //                 newEndRow,
  //                 multiSetFilterValues[i],
  //                 setFilterValues[0],
  //                 rangeCol,
  //                 rangeColOrder,
  //                 rangeFilterType,
  //                 rangeFilterValue,
  //                 rangeFilterValue2
  //               );
  //               records.push(...myResult.rows);
  //               rowsViewed += myResult.count;
  //             } else {
  //               // stop iteration when requiered number of records obtained
  //               break;
  //             }
  //           }
  //         } else {
  //           for (let i = 0; i < setFilterValues.length; i += 1) {
  //             const rowsRetrieved = records.length;
  //             const newStartRow =
  //               startRow - rowsViewed < 0 ? 0 : startRow - rowsViewed;
  //             const newEndRow = endRow - rowsViewed;

  //             if (rowsRetrieved < endRow - startRow) {
  //               // find data on index
  //               // eslint-disable-next-line no-await-in-loop
  //               const myResult = await getRowsForOneValue(
  //                 multiSetCol,
  //                 setCol,
  //                 newStartRow,
  //                 newEndRow,
  //                 multiSetFilterValues[0],
  //                 setFilterValues[i],
  //                 rangeCol,
  //                 rangeColOrder,
  //                 rangeFilterType,
  //                 rangeFilterValue,
  //                 rangeFilterValue2
  //               );
  //               records.push(...myResult.rows);
  //               rowsViewed += myResult.count;
  //             } else {
  //               // stop iteration when requiered number of records obtained
  //               break;
  //             }
  //           }
  //         }

  //         return {
  //           rows: records,
  //         };
  //       };

  //       // eslint-disable-next-line no-async-promise-executor
  //       return new Promise(async (resolve, reject) => {
  //         if (db !== null) {
  //           const transaction = db.transaction(
  //             `calls-${organizationId}`,
  //             "readwrite"
  //           );
  //           const objectStore = transaction.objectStore(
  //             `calls-${organizationId}`
  //           );
  //           const matchingCol = multiSetColumns.get(multiSetCol);
  //           const indexExists = objectStore.indexNames.contains(
  //             `${matchingCol}_${setCol}_${rangeCol}`
  //           );

  //           // eslint-disable-next-line consistent-return
  //           transaction.oncomplete = async (event) => {
  //             if (!indexExists) {
  //               // index doesn't exist - create index

  //               const request: IDBOpenDBRequest = window.indexedDB.open(
  //                 dbName,
  //                 version + 1
  //               );

  //               db!.onversionchange = () => {
  //                 db!.close();
  //               };

  //               request.onerror = (e) => {
  //                 // Handle errors
  //                 console.log("error opening db");
  //               };

  //               request.onsuccess = async (e) => {
  //                 const myDb: IDBDatabase = (e.target as IDBOpenDBRequest).result;

  //                 // save db and version to global var
  //                 db = myDb;
  //                 version += 1;

  //                 const result = await getData();
  //                 setIndexesModified(
  //                   (oldIndexesModified) => (oldIndexesModified || 0) + 1
  //                 );
  //                 return resolve(result);
  //               };

  //               request.onupgradeneeded = async (e) => {
  //                 // upgrade and create index
  //                 const myTransaction = (e.target as IDBOpenDBRequest)
  //                   .transaction;
  //                 const myStore = myTransaction?.objectStore(
  //                   `calls-${organizationId}`
  //                 );

  //                 myStore?.createIndex(
  //                   `${matchingCol}_${setCol}_${rangeCol}`,
  //                   `${matchingCol}_${setCol}_${rangeCol}`,
  //                   { multiEntry: true }
  //                 );
  //               };
  //             } else {
  //               const result = await getData();
  //               return resolve(result);
  //             }
  //           };
  //         }
  //       });
  //     },
  //     [organizationId]
  //   );

  const createServerSideDatasource = useCallback(
    () => ({
      getRows: async (params: IServerSideGetRowsParams) => {
        console.log('params', params);
        const requestParams = params.request;
        let response: { rows: Call[] } | undefined;

        // requested rows come in portion
        if (requestParams.startRow !== undefined && requestParams.endRow !== undefined) {
          const sortModel = requestParams.sortModel
            ? requestParams.sortModel[0]
            : //   : { colId: "index", sort: "asc" };
              undefined;

          const { filterModel } = requestParams;
          const setCols = Object.keys(filterModel)?.filter((col) => setColumns.includes(col));
          const rangeCols = Object.keys(filterModel)?.filter((col) => rangeColumns.includes(col));
          //   const multiSetCols = Object.keys(filterModel)?.filter((col) =>
          //     multiSetColumnsDisplayed.includes(col)
          //   );
          // default cases:

          // filter on 1 multiSet column AND filter on 0 or 1 range column
          // sorting on the same col as rangeCol filters
          //   if (
          //     filterModel &&
          //     multiSetCols &&
          //     multiSetCols.length === 1 && // only 1 multiset col filter
          //     (!setCols || setCols.length === 0) && // no set cols filters
          //     (!rangeCols || rangeCols.length < 2) && // 0 or 1 range filters
          //     (!sortModel ||
          //       !rangeCols ||
          //       rangeCols.length === 0 ||
          //       sortModel.colId === rangeCols[0]) // no sorting or no range filters or sorting and filters on the same col
          //   ) {
          //     const setFilter = filterModel[multiSetCols[0]];
          //     const rangeFilter = rangeCols?.[0]
          //       ? filterModel[rangeCols?.[0]]
          //       : undefined;
          //     response = await getRowsByMultiSetFilter(
          //       multiSetCols[0],
          //       requestParams.startRow,
          //       requestParams.endRow,
          //       setFilter.values,
          //       rangeCols?.[0] || sortModel?.colId || "index",
          //       sortModel?.sort,
          //       rangeFilter?.type,
          //       rangeFilter?.filter,
          //       rangeFilter?.filterTo
          //     );
          //     // filter on 1 multiSet column AND 1 filter on set column, sort by date
          //     //  filter by date available only if 1 multiset value and 1 set value selected
          //   } else if (
          //     filterModel &&
          //     multiSetCols &&
          //     multiSetCols.length === 1 && // only 1 multiset col filter
          //     setCols &&
          //     setCols.length === 1 && // 1 set col filter
          //     (filterModel[multiSetCols[0]].values.length === 1 ||
          //       filterModel[setCols[0]].values.length === 1) &&
          //     (!rangeCols ||
          //       rangeCols.length === 0 ||
          //       (rangeCols.length === 1 && rangeCols[0] === "index")) && // allows filter only by date here
          //     (!sortModel || sortModel.colId === "index")
          //   ) {
          //     const multiSetFilter = filterModel[multiSetCols[0]];
          //     const setFilter = filterModel[setCols[0]];
          //     const rangeFilter = rangeCols?.[0]
          //       ? filterModel[rangeCols?.[0]]
          //       : undefined;
          //     const manyValuesFilter =
          //       setFilter.values.length > 1 ? "set" : "multiset";
          //     response = await getRowsBySetMultisetFilters(
          //       manyValuesFilter,
          //       multiSetCols[0],
          //       setCols[0],
          //       requestParams.startRow,
          //       requestParams.endRow,
          //       multiSetFilter.values,
          //       setFilter.values,
          //       "index",
          //       sortModel?.sort,
          //       rangeFilter?.type,
          //       rangeFilter?.filter,
          //       rangeFilter?.filterTo
          //     );
          //   }
          //   else
          // filter on 1 set column AND filter on 0 or 1 range column
          // sorting on the same col as rangeCol filters

          if (
            filterModel &&
            setCols &&
            setCols.length === 1 && // only 1 set col filter
            // (!multiSetCols || multiSetCols.length === 0) && // no multiset columns
            (!rangeCols || rangeCols.length < 2) && // 0 or 1 range filters
            (!sortModel || !rangeCols || rangeCols.length === 0 || sortModel.colId === rangeCols[0]) // no sorting or no range filters or sorting and filters on the same col
          ) {
            const setFilter = filterModel[setCols[0]];
            const rangeFilter = rangeCols?.[0] ? filterModel[rangeCols?.[0]] : undefined;
            response = await getRowsBySetFilter(
              setCols[0],
              requestParams.startRow,
              requestParams.endRow,
              setFilter.values,
              rangeCols?.[0] || sortModel?.colId || 'index',
              sortModel?.sort,
              rangeFilter?.type,
              rangeFilter?.filter,
              rangeFilter?.filterTo,
            );
          } else if (
            // 2 set filters applied
            // one of the set filters has only 1 value
            filterModel &&
            setCols &&
            setCols.length === 2 &&
            (filterModel[setCols[0]].values.length === 1 || filterModel[setCols[1]].values.length === 1) &&
            (!rangeCols || rangeCols.length < 2) &&
            (!sortModel || !rangeCols || rangeCols.length === 0 || sortModel.colId === rangeCols[0]) // no sorting or no range filters or sorting and filters on the same col
          ) {
            let firstSetCol: string | undefined;
            let secondSetCol: string | undefined;
            let firstSetFilter: { values?: Array<string> } | undefined;
            let secondSetFilter: { values?: Array<string> } | undefined;
            setCols.forEach((col) => {
              if (filterModel[col]?.values?.length === 1 && firstSetCol === undefined) {
                firstSetCol = col;
                firstSetFilter = filterModel[col];
              } else {
                secondSetCol = col;
                secondSetFilter = filterModel[col];
              }
            });
            const rangeFilter = rangeCols?.[0] ? filterModel[rangeCols?.[0]] : undefined;

            if (
              firstSetCol &&
              secondSetCol &&
              firstSetFilter &&
              firstSetFilter.values &&
              firstSetFilter.values[0] &&
              secondSetFilter &&
              secondSetFilter.values
            ) {
              response = await getRowsBy2SetFilters(
                firstSetCol,
                secondSetCol,
                requestParams.startRow,
                requestParams.endRow,
                firstSetFilter?.values?.[0],
                secondSetFilter?.values,
                rangeCols?.[0] || sortModel?.colId || 'index',
                sortModel?.sort,
                rangeFilter?.type,
                rangeFilter?.filter,
                rangeFilter?.filterTo,
              );
            }
          }

          // sort and filter on the same range column - default behavior
          else if (
            filterModel &&
            Object.keys(filterModel).length === 1 &&
            sortModel &&
            filterModel[sortModel.colId] !== undefined
          ) {
            const filter = filterModel[sortModel.colId];
            response = await getSortedAndFilteredByOneCol(
              sortModel.colId,
              requestParams.startRow,
              requestParams.endRow,
              sortModel.sort,
              filter.type,
              filter.filter,
              filter.filterTo,
            );
          }
          // just sort, no filters
          else if (!filterModel || Object.keys(filterModel).length === 0) {
            response = await getSortedRows(
              requestParams.startRow,
              requestParams.endRow,
              sortModel?.colId || 'index',
              sortModel?.sort || 'asc',
            );
          }

          if (response && response.rows) {
            // supply rows for requested block to grid
            //   console.log(requestParams.startRow + response.rows.length);
            if (response.rows.length === requestParams.endRow - requestParams.startRow) {
              params.success({
                rowData: response.rows,
              });
            } else {
              // last set of data
              // console.log(requestParams.startRow + response.rows.length);
              // rowCount let get rid of constantly lodaing rows in the end of the grid
              params.success({
                rowData: response.rows,
                rowCount: requestParams.startRow + response.rows.length,
              });
            }
          } else {
            params.fail();
          }
        }
      },
    }),
    [
      getRowsBy2SetFilters,
      //   getRowsByMultiSetFilter,
      getRowsBySetFilter,
      //   getRowsBySetMultisetFilters,
      getSortedAndFilteredByOneCol,
      getSortedRows,
    ],
  );

  // show loading pop up when populating db
  //   useEffect(() => {
  //     if (!gridReady) {
  //       return;
  //     }
  //     if (gridReady && (dbCleared || !dbCreated)) {
  //       gridRef.current?.api.showLoadingOverlay();
  //     } else if (gridReady && !dbCleared) {
  //       gridRef.current?.api.hideOverlay();
  //     }
  //   }, [gridReady, dbCleared, dbCreated]);

  useEffect(() => {
    if (dbCreated && gridReady) {
      // register datasource
      const serverSideDataSource = createServerSideDatasource();
      // didn't find it in the docs - old versions used setGridOptions api
      gridRef.current?.api.setServerSideDatasource(serverSideDataSource);
    }
  }, [dbCreated, gridReady, createServerSideDatasource]);

  // useEffect(() => {
  //   if (fromPhoneLoaded && toPhoneLoaded && resultLoaded && dispositionLoaded) {
  //     if (
  //       gridReady &&
  //       gridRef &&
  //       gridRef.current &&
  //       gridRef.current.api !== undefined
  //     ) {
  //       const getGrid = localStorage.getItem("c2g-filters");
  //       if (!getGrid) {
  //         localStorage.setItem("c2g-filters", JSON.stringify({}));
  //         gridRef.current.api.setFilterModel({});
  //       }
  //       if (getGrid) {
  //         gridRef.current.api.setFilterModel(JSON.parse(getGrid));
  //       }
  //     }
  //   }
  // }, [
  //   gridReady,
  //   gridRef,
  //   fromPhoneLoaded,
  //   toPhoneLoaded,
  //   resultLoaded,
  //   dispositionLoaded,
  // ]);

  const onFilterChanged = useCallback((event: FilterChangedEvent) => {
    // console.log("filterModel", event.api.getFilterModel());
    const triggeredCol = event.columns[0];
    const myColId = triggeredCol.getColId();
    const filterModel = event.api.getFilterModel();
    //localStorage.setItem(`c2g-filters`, JSON.stringify(filterModel));
    localStorage.setItem('C2G-saveGridConfig-filter', JSON.stringify(filterModel));
    setFilterRef(filterModel);
    setReportFilter(filterModel);
    const setColsFiltered = Object.keys(filterModel).filter((col) => setColumns.includes(col));
    // const multiSetColsFiltered = Object.keys(filterModel).filter((col) =>
    //   multiSetColumnsDisplayed.includes(col)
    // );
    // range col
    if (rangeColumns.includes(myColId)) {
      if (triggeredCol && triggeredCol.isFilterActive()) {
        event.columnApi.applyColumnState({
          state: [{ colId: myColId, sort: 'desc' }],
          defaultState: { sort: null },
        });
        rangeColumns.forEach((colId) => {
          if (colId !== myColId) {
            const column = event.columnApi.getColumn(colId);
            if (column?.getColDef()) {
              column.getColDef().filter = false;
              column.getColDef().sortable = false;
            }
          }
        });
      } else if (triggeredCol && triggeredCol.isFilterActive() === false) {
        // no other filters
        if (
          setColsFiltered.length === 0
          // && multiSetColsFiltered.length === 0
        ) {
          rangeColumns.forEach((colId) => {
            const column = event.columnApi.getColumn(colId);
            if (column?.getColDef()) {
              column.getColDef().filter = 'agTextColumnFilter';
              column.getColDef().sortable = true;
            }
          });
          // only set filters
        } else if (
          setColsFiltered.length > 0
          //    && multiSetColsFiltered.length === 0
        ) {
          if (setColsFiltered.every((col) => filterModel[col].values && filterModel[col].values.length === 1)) {
            rangeColumns.forEach((colId) => {
              const column = event.columnApi.getColumn(colId);
              if (column?.getColDef()) {
                column.getColDef().filter = 'agTextColumnFilter';
                column.getColDef().sortable = true;
              }
            });
          } else {
            rangeColumns.forEach((colId) => {
              const column = event.columnApi.getColumn(colId);
              if (column?.getColDef()) {
                column.getColDef().filter = 'agTextColumnFilter';
                column.getColDef().sortable = false;
              }
            });
          }
          // only multiset filter
        }
        //   else if (
        //   setColsFiltered.length === 0 &&
        //   multiSetColsFiltered.length === 1
        // ) {
        //   if (
        //     multiSetColsFiltered.every(
        //       (col) =>
        //         filterModel[col].values && filterModel[col].values.length === 1
        //     )
        //   ) {
        //     rangeColumns.forEach((colId) => {
        //       const column = event.columnApi.getColumn(colId);
        //       if (column?.getColDef()) {
        //         column.getColDef().filter = "agTextColumnFilter";
        //         column.getColDef().sortable = true;
        //       }
        //     });
        //   } else {
        //     rangeColumns.forEach((colId) => {
        //       const column = event.columnApi.getColumn(colId);
        //       if (column?.getColDef()) {
        //         column.getColDef().filter = "agTextColumnFilter";
        //         column.getColDef().sortable = false;
        //       }
        //     });
        //   }
        // } else if (
        //   setColsFiltered.length === 0 &&
        //   multiSetColsFiltered.length === 1
        // ) {
        //   if (
        //     setColsFiltered
        //       .concat(multiSetColsFiltered)
        //       .every(
        //         (col) =>
        //           filterModel[col].values &&
        //           filterModel[col].values.length === 1
        //       )
        //   ) {
        //     rangeColumns.forEach((colId) => {
        //       const column = event.columnApi.getColumn(colId);
        //       if (column?.getColDef()) {
        //         if (colId === "index") {
        //           column.getColDef().filter = "agTextColumnFilter";
        //           column.getColDef().sortable = true;
        //         } else {
        //           column.getColDef().filter = false;
        //           column.getColDef().sortable = false;
        //         }
        //       }
        //     });
        //   } else {
        //     rangeColumns.forEach((colId) => {
        //       const column = event.columnApi.getColumn(colId);
        //       if (column?.getColDef()) {
        //         if (colId === "index") {
        //           column.getColDef().filter = "agTextColumnFilter";
        //           column.getColDef().sortable = false;
        //         } else {
        //           column.getColDef().filter = false;
        //           column.getColDef().sortable = false;
        //         }
        //       }
        //     });
        //   }
        // }
      }
      event.api.refreshHeader();
    }
    if (setColumns.includes(myColId)) {
      // set filter on
      if (triggeredCol && triggeredCol.isFilterActive() === true) {
        // 1 set cols on
        if (
          setColsFiltered.length === 1
          // && multiSetColsFiltered.length === 0
        ) {
          if (filterModel[myColId] && filterModel[myColId].values && filterModel[myColId].values.length !== 1) {
            // more than one value selected in set - disable other sorting
            rangeColumns.forEach((colId) => {
              const column = event.columnApi.getColumn(colId);
              if (column?.getColDef()) {
                column.getColDef().sortable = false;
              }
            });
            // disable another set column
            setColumns
              // .concat(multiSetColumnsDisplayed)
              .forEach((colId) => {
                if (colId !== myColId) {
                  const column = event.columnApi.getColumn(colId);
                  if (column?.getColDef()) {
                    column.getColDef().filter = false;
                  }
                }
              });
          }
        }
        // 2 set columns on
        else if (
          setColsFiltered.length === 2
          //    && multiSetColsFiltered.length === 0
        ) {
          // disable another set and multiset columns
          setColumns
            //   .concat(multiSetColumnsDisplayed)
            .forEach((colId) => {
              if (filterModel[colId] === undefined) {
                const column = event.columnApi.getColumn(colId);
                if (column?.getColDef()) {
                  column.getColDef().filter = false;
                }
              }
            });
          //  at least one of set cols has many values
          if (setColsFiltered.some((col) => filterModel[col].values?.length !== 1)) {
            // disable range col sorting
            rangeColumns.forEach((colId) => {
              const column = event.columnApi.getColumn(colId);
              if (column?.getColDef()) {
                column.getColDef().sortable = false;
              }
            });
          }
          // combination of set and multiset columns
        }
        // else if (
        //   setColsFiltered.length === 1
        //   && multiSetColsFiltered.length === 1
        // ) {
        //   // disable another set and multiset columns
        //   setColumns.concat(multiSetColumnsDisplayed).forEach((colId) => {
        //     if (filterModel[colId] === undefined) {
        //       const column = event.columnApi.getColumn(colId);
        //       if (column?.getColDef()) {
        //         column.getColDef().filter = false;
        //       }
        //     }
        //   });
        //   // allow filters only by date (index) and sort only if 1 values selected for each set/multiset filter
        //   rangeColumns.forEach((colId) => {
        //     if (colId !== "index") {
        //       const column = event.columnApi.getColumn(colId);
        //       if (column?.getColDef()) {
        //         column.getColDef().sortable = false;
        //         column.getColDef().filter = false;
        //       }
        //     } else if (
        //       colId === "index" &&
        //       setColsFiltered
        //         .concat(multiSetColsFiltered)
        //         .some((col) => filterModel[col].values?.length !== 1)
        //     ) {
        //       const column = event.columnApi.getColumn(colId);
        //       if (column?.getColDef()) {
        //         column.getColDef().sortable = false;
        //       }
        //     }
        //   });
        // }
        // set filter off
      } else if (triggeredCol && triggeredCol.isFilterActive() === false) {
        // enable sorting
        rangeColumns.forEach((colId) => {
          const column = event.columnApi.getColumn(colId);
          if (column?.getColDef()) {
            column.getColDef().sortable = true;
          }
        });
        setColumns
          // .concat(multiSetColumnsDisplayed)
          .forEach((colId) => {
            if (colId !== myColId) {
              const column = event.columnApi.getColumn(colId);
              if (column?.getColDef()) {
                column.getColDef().filter = 'agSetColumnFilter';
              }
            }
          });
      }

      event.api.refreshHeader();
    }
    // else if (multiSetColumnsDisplayed.includes(myColId)) {
    //   const filteredSetCols = Object.keys(filterModel).filter((col) =>
    //     setColumns.includes(col)
    //   );
    //   // multiset filter on
    //   if (triggeredCol && triggeredCol.isFilterActive() === true) {
    //     // disable other multiset cols
    //     multiSetColumnsDisplayed.forEach((colId) => {
    //       if (colId !== myColId) {
    //         const column = event.columnApi.getColumn(colId);
    //         if (column?.getColDef()) {
    //           column.getColDef().filter = false;
    //         }
    //       }
    //     });

    //     if (
    //       filterModel[myColId] &&
    //       filterModel[myColId].values &&
    //       filterModel[myColId].values.length === 1
    //     ) {
    //       // there is set col filter - disable other set cols
    //       if (filteredSetCols.length > 0) {
    //         setColumns.forEach((colId) => {
    //           if (filterModel[colId] === undefined) {
    //             const column = event.columnApi.getColumn(colId);
    //             if (column?.getColDef()) {
    //               column.getColDef().filter = false;
    //             }
    //           }
    //         });
    //         rangeColumns.forEach((colId) => {
    //           const column = event.columnApi.getColumn(colId);
    //           if (column?.getColDef()) {
    //             if (colId === "index") {
    //               column.getColDef().sortable = false;
    //               column.getColDef().filter = false;
    //             } else {
    //               column.getColDef().sortable = true;
    //               column.getColDef().filter = "agTextColumnFilter";
    //             }
    //           }
    //         });
    //       } else {
    //         setColumns.forEach((colId) => {
    //           const column = event.columnApi.getColumn(colId);
    //           if (column?.getColDef()) {
    //             column.getColDef().filter = "agSetColumnFilter";
    //           }
    //         });
    //         rangeColumns.forEach((colId) => {
    //           const column = event.columnApi.getColumn(colId);
    //           if (column?.getColDef()) {
    //             column.getColDef().sortable = true;
    //             column.getColDef().filter = "agTextColumnFilter";
    //           }
    //         });
    //       }
    //     }
    //     // multiset col has more than 1 value or 0
    //     if (
    //       filterModel[myColId] &&
    //       filterModel[myColId].values &&
    //       filterModel[myColId].values.length !== 1
    //     ) {
    //       setColumns.forEach((colId) => {
    //         if (filterModel[colId] === undefined) {
    //           const column = event.columnApi.getColumn(colId);
    //           if (column?.getColDef()) {
    //             column.getColDef().filter = false;
    //           }
    //         }
    //       });
    //       rangeColumns.forEach((colId) => {
    //         const column = event.columnApi.getColumn(colId);
    //         if (column?.getColDef()) {
    //           column.getColDef().sortable = false;
    //         }
    //       });
    //     }
    //   }
    // multisetfilter is OFF
    //   else if (triggeredCol && triggeredCol.isFilterActive() === false) {
    //     // there is still set column
    //     if (filteredSetCols.length > 0) {
    //       if (filterModel[filteredSetCols[0]]?.values?.length === 1) {
    //         setColumns.concat(multiSetColumnsDisplayed).forEach((colId) => {
    //           const column = event.columnApi.getColumn(colId);
    //           if (column?.getColDef()) {
    //             column.getColDef().filter = "agSetColumnFilter";
    //           }
    //         });
    //         rangeColumns.forEach((colId) => {
    //           const column = event.columnApi.getColumn(colId);
    //           if (column?.getColDef()) {
    //             column.getColDef().sortable = false;
    //             column.getColDef().filter = "agTextColumnFilter";
    //           }
    //         });
    //       } else {
    //         // left set has more than one value
    //         setColumns.concat(multiSetColumnsDisplayed).forEach((colId) => {
    //           const column = event.columnApi.getColumn(colId);
    //           if (column?.getColDef()) {
    //             column.getColDef().filter = false;
    //           }
    //         });
    //         rangeColumns.forEach((colId) => {
    //           const column = event.columnApi.getColumn(colId);
    //           if (column?.getColDef()) {
    //             column.getColDef().sortable = false;
    //           }
    //         });
    //       }
    //     } else {
    //       // no other filters - enable all
    //       rangeColumns.forEach((colId) => {
    //         const column = event.columnApi.getColumn(colId);
    //         if (column?.getColDef()) {
    //           column.getColDef().sortable = true;
    //           column.getColDef().filter = "agTextColumnFilter";
    //         }
    //       });
    //       setColumns.concat(multiSetColumnsDisplayed).forEach((colId) => {
    //         if (colId !== myColId) {
    //           const column = event.columnApi.getColumn(colId);
    //           if (column?.getColDef()) {
    //             column.getColDef().filter = "agSetColumnFilter";
    //           }
    //         }
    //       });
    //     }
    //   }
    // }
  }, []);

  const onSortChanged = useCallback((event: SortChangedEvent) => {
    const sortedCol = event.columnApi.getColumnState().filter((col) => col.sort !== null);
    const filterModel = event.api.getFilterModel();
    const newFilterModel = { ...filterModel };
    Object.keys(filterModel).forEach((key) => {
      if (key !== sortedCol[0].colId && rangeColumns.includes(key)) {
        delete newFilterModel[key];
      }
    });

    if (Object.keys(newFilterModel).length === 0) {
      event.api.setFilterModel(null);
    } else {
      event.api.setFilterModel(newFilterModel);
    }
  }, []);

  const getCall = useCallback(async (resp: any, callId: string, startTime: string) => {
    const { callUsers, to, from, toLeg, fromLeg, recordingsList } = resp;
    const allEvents = callUsers
      .reduce((events: Array<any>, user: any) => events.concat(user.events), [])
      .sort((a: any, b: any) => {
        if (a.body.eventTime < b.body.eventTime) {
          return -1;
        }
        if (a.body.eventTime > b.body.eventTime) {
          return 1;
        }
        return 0;
      });

    const callHistory = [] as CallLeg[];

    allEvents.forEach((event: any) => {
      const { direction } = event.body.parties[0];
      const fromExt = event.body.parties[0].from.extensionId;
      const fromPhone = event.body.parties[0].from.phoneNumber;
      const fromName = event.body.parties[0].from.name;
      const toExt = event.body.parties[0].to.extensionId;
      const toPhone = event.body.parties[0].to.phoneNumber;
      const toName = event.body.parties[0].to.name;
      const status = event.body.parties[0].status.code;
      const { eventTime } = event.body;
      let state;
      if (status === 'Setup') {
        state = 'Setup';
      } else if (status === 'Proceeding') {
        state = 'Ringing';
      } else if (direction === 'Outbound' && status === 'Answered') {
        state = 'Connected/Answered';
      } else if (direction === 'Inbound' && status === 'Answered') {
        state = 'Answered';
      } else if (status === 'Voicemail') {
        state = 'Forwarded to voicemail';
      } else if (status === 'FaxReceive') {
        state = 'Fax receiving started';
      } else if (status === 'Hold') {
        state = 'Put on hold';
      } else if (status === 'VMScreening') {
        state = 'Listening to voicemail';
      } else {
        state = status;
      }
      callHistory.push({
        id: event.uuid,
        eventTime: new Date(eventTime).toLocaleString('en-CA'),
        direction,
        state,
        fromExt,
        fromPhone,
        fromName,
        toExt,
        toPhone,
        toName,
        status,
      });
    });
    console.log('callHistory', callHistory);
    setCallLog([...callHistory]);
    setTimelineEvents(allEvents);
    setTransferEvents({
      from,
      to,
    });
    setRecordingsDisplay(() => {
      if (recordingsList && Array.isArray(recordingsList)) {
        return recordingsList;
      }
      return undefined;
    });
  }, []);

  const getCxCall = useCallback((resp: { callData: any }) => {
    const extStates = Object.keys(resp.callData).filter((key) => key.includes('#'));
    const { callEnd } = resp.callData;
    let direction: string | undefined;
    if (resp.callData.callEnd) {
      direction = resp.callData.callEnd.event_type === 'ACD-CALL' ? 'Inbound' : 'Outbound';
    }

    const legs = extStates
      .map((key) => {
        const [extensionId, legState] = key.split('#');
        const extensionData = resp.callData[extensionId];
        let party;
        if (extensionData.extension === 'agent') {
          party = `${extensionData.agentFirstName || ''} ${extensionData.agentLastName || ''}`;
        }
        if (extensionData.extension === 'queue') {
          party = `${extensionData.queueName || ''}`;
        }
        let myState = '';
        let transferDestination;
        if (legState.includes('abandon')) {
          myState = 'Ringing';
        } else if (legState.includes('transfer')) {
          [, transferDestination] = legState.split('-');
          if (regexCheck(transferDestination, exPhonePattern)) {
            myState = 'Transferred to EX';
          } else {
            myState = 'Transferred';
          }
        } else {
          myState = legState.replace('Time', '');
        }

        return {
          id: key,
          eventTime: new Date(resp.callData[key].replace('T', ' ').replace('.000Z', '')).toLocaleString('en-CA'),
          direction: direction !== undefined ? direction : 'Inbound',
          state: myState.length > 0 ? `${myState.charAt(0).toUpperCase()}${myState.slice(1)}` : '',
          fromPhone: myState.includes('Transferred') ? party : extensionData.ani || '',
          toPhone: myState.includes('Transferred') ? transferDestination : extensionData.dnis || '',
          fromName: direction === 'Outbound' ? party : '',
          toName: direction === 'Inbound' ? party : '',
        };
      })
      .sort((a, b) => {
        if (a.eventTime < b.eventTime) {
          return -1;
        }
        if (a.eventTime > b.eventTime) {
          return 1;
        }
        if (a.eventTime === b.eventTime) {
          if (a.state === 'Connected' && b.state === 'Ringing') return 1;
          if (a.state === 'Ringing' && b.state === 'Connected') return -1;
          return 0;
        }
        return 0;
      }) as CallLeg[];

    if (callEnd) {
      const legTimestamp = new Date(callEnd.call_start);
      legTimestamp.setSeconds(legTimestamp.getSeconds() + parseInt(callEnd.call_duration, 10));
      legs.push({
        id: 'call-end-state',
        state: 'Ended',
        eventTime: legTimestamp.toLocaleString('en-CA'),
        direction: direction !== undefined ? direction : 'Inbound',
        fromPhone: callEnd.ani,
        toPhone: callEnd.dnis,
        fromName: direction === 'Outbound' ? callEnd.gate_name || '' : '',
        toName: direction === 'Inbound' ? callEnd.gate_name || '' : '',
      });
    }

    setCallLog(legs);
  }, []);

  const onSelectionChanged = useCallback(
    async (event: SelectionChangedEvent) => {
      if (leaderboardUrl === undefined) {
        return;
      }
      const selectedRows = event.api.getSelectedRows();
      try {
        if (selectedRows[0]?.component === 'EX') {
          const res = await fetch(`${leaderboardUrl.replace('/summary', '/call')}/${selectedRows[0]?.callId}`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
          const resp = await res.json();
          getCall(resp, selectedRows[0]?.callId, selectedRows[0]?.index);
        } else if (selectedRows[0]?.component === 'CX') {
          const res = await fetch(`${cxCallApi}/${selectedRows[0]?.callId}`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
          const resp = await res.json();
          getCxCall(resp);
          setTimelineEvents(resp);
        }
      } catch (err) {
        console.log(err);
        setCallLog(undefined);
      }
      //   try {
      //     if (selectedRows[0].transcript === undefined) {
      //       throw new Error('no transcript');
      //     }
      //     const { transcript } = await fetch(selectedRows[0].transcript, {
      //       method: 'GET',
      //     }).then((response) => response.json());
      //     const removedRecordedPrompt = transcript.replace('This call is being recorded. ', '');
      //     setSelectedC2GInfo({
      //       ...selectedRows[0],
      //       transcript: removedRecordedPrompt,
      //     });
      //   } catch (err) {
      //     setSelectedC2GInfo(selectedRows[0]);
      //   }
    },
    [getCall, leaderboardUrl],
  );
  useEffect(() => {
    const fetchedDateRange = localStorage.getItem('C2G-date-range');
    if (fetchedDateRange) {
      if (fetchedDateRange === 'manual') {
        const fetchedStart = localStorage.getItem('C2G-startTimeRef');
        const fetchedEnd = localStorage.getItem('C2G-endTimeRef');
        if (fetchedStart && fetchedEnd) {
          return setDateRangeSelected(`${fetchedStart},${fetchedEnd}`);
        }
        return setDateRangeSelected(`manual`);
      }
      return setDateRangeSelected(fetchedDateRange);
    }
    return setDateRangeSelected('initial');
  }, []);

  const selectDateRange = useCallback((range: string) => {
    setError(undefined);
    if (range === 'manual') {
      //   console.log(startTimeRef.current?.value, endTimeRef.current?.value);
      if (startTimeRef.current?.value === undefined || startTimeRef.current?.value === '') {
        setError('Start date is required');
      } else if (
        startTimeRef.current?.value &&
        endTimeRef.current?.value &&
        startTimeRef.current.value > endTimeRef.current.value
      ) {
        setError('Invalid date range');
      } else {
        setDateRangeSelected(`${startTimeRef.current?.value},${endTimeRef.current?.value}`);
      }
    } else {
      setOpenRangeForm(false);
      setDateRangeSelected(range);
    }
  }, []);

  useEffect(() => {
    // clear db
    if (db !== null && dateRangeSelected !== 'initial') {
      const transaction = db.transaction([`calls-${organizationId}`], 'readwrite');
      const objectStore = transaction.objectStore(`calls-${organizationId}`);
      const clearRequest = objectStore.clear();

      clearRequest.onsuccess = (event) => {
        console.log('Object store cleared successfully');
        resetGraphData(graphData, setGraphData);
        setProgress(0);
        dateChanged = new Date().getTime();
        setDbCleared(true);
        setLoading(true);

        gridRef?.current?.api?.refreshServerSide();
      };
    }
  }, [dateRangeSelected, organizationId]);

  return (
    <div className={mode === 'light' ? 'light' : 'dark'}>
      {legacyUI && (
        <div className="C2G-headerbar" style={{ top: 60 }}>
          <div className="C2G-header">
            <div className="header-left">
              <button
                className={`C2G-button ${dateRangeSelected === 'today' && !openRangeForm ? ' selected' : ''}`}
                type="button"
                onClick={() => {
                  localStorage.setItem('C2G-date-range', 'today');
                  selectDateRange('today');
                }}
              >
                Today
              </button>
              <button
                className={`C2G-button ${dateRangeSelected === 'yesterday' && !openRangeForm ? ' selected' : ''}`}
                type="button"
                onClick={() => {
                  localStorage.setItem('C2G-date-range', 'yesterday');
                  selectDateRange('yesterday');
                }}
              >
                Yesterday
              </button>
              <button
                className={`C2G-button ${dateRangeSelected === 'last7Days' && !openRangeForm ? ' selected' : ''}`}
                type="button"
                onClick={() => {
                  localStorage.setItem('C2G-date-range', 'last7Days');
                  selectDateRange('last7Days');
                }}
              >
                Last 7 days
              </button>
              <button
                className={`C2G-button ${dateRangeSelected === 'thisMonth' && !openRangeForm ? ' selected' : ''}`}
                type="button"
                onClick={() => {
                  localStorage.setItem('C2G-date-range', 'thisMonth');
                  selectDateRange('thisMonth');
                }}
              >
                This Month
              </button>
              <button
                className={`C2G-button ${dateRangeSelected === 'lastMonth' && !openRangeForm ? ' selected' : ''}`}
                type="button"
                onClick={() => {
                  localStorage.setItem('C2G-date-range', 'lastMonth');
                  selectDateRange('lastMonth');
                }}
              >
                Last Month
              </button>
              <button
                className={`C2G-button ${
                  openRangeForm || dateRangeSelected === 'manual' || dateRangeSelected?.includes(',') ? ' selected' : ''
                }`}
                type="button"
                onClick={(e) => {
                  setOpenRangeForm(!openRangeForm);
                  handleDateRangeClick(e);
                }}
              >
                Date Range
              </button>
              <Menu
                className="date-form-parent"
                anchorEl={anchorEl}
                open={openRangeForm}
                aria-haspopup
                onClose={handleDateRangeClose}
                style={{
                  zIndex: 1000000000,
                  top: 45,
                  padding: 0,
                }}
              >
                <div
                  className="date-form-container"
                  style={{
                    background: mode === 'light' ? 'white' : '#333',
                    padding: 0,
                    borderRadius: 8,
                  }}
                >
                  <form className="date-form" style={{ padding: '10px 20px' }}>
                    <div
                      className="date-rows"
                      style={{
                        display: 'flex',
                        gap: '15px',
                        flexDirection: 'row',
                      }}
                    >
                      <div
                        className={`date-row ${mode === 'light' ? 'light-bg' : 'dark-bg'}`}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginBottom: 10,
                          alignItems: 'center',
                          gap: 10,
                        }}
                      >
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label style={{ color: mode === 'light' ? 'black' : 'white' }} htmlFor="start">
                          Start:
                        </label>
                        <input
                          type="date"
                          id="start"
                          defaultValue={dateRangeSelected?.split(',')?.[0]}
                          ref={startTimeRef}
                          onChange={(e) => {
                            localStorage.setItem('C2G-startTimeRef', e.target.value);
                          }}
                          style={{
                            background: mode === 'light' ? '#f0f0f0' : '#555',
                            border: '1px solid #ccc',
                            borderRadius: 4,
                            padding: '4px 10px',
                            width: '80%',
                            textTransform: 'uppercase',
                            fontFamily: 'Arial, sans-serif',
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className={`date-row ${mode === 'light' ? 'light-bg' : 'dark-bg'}`}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: 10,
                        alignItems: 'center',
                        gap: 10,
                      }}
                    >
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label style={{ color: mode === 'light' ? 'black' : 'white' }} htmlFor="end">
                        End:
                      </label>
                      <input
                        type="date"
                        id="end"
                        ref={endTimeRef}
                        defaultValue={dateRangeSelected?.split(',')?.[1]}
                        onChange={(e) => {
                          localStorage.setItem('C2G-endTimeRef', e.target.value);
                        }}
                        style={{
                          background: mode === 'light' ? '#f0f0f0' : '#555',
                          border: '1px solid #ccc',
                          borderRadius: 4,
                          padding: '4px 10px',
                          width: '80%',
                          textTransform: 'uppercase',
                          fontFamily: 'Arial, sans-serif',
                        }}
                      />
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        localStorage.setItem('C2G-date-range', 'manual');
                        selectDateRange('manual');
                      }}
                      style={{
                        padding: 10,
                        borderRadius: 6,
                        background: mode === 'light' ? '#0684bd' : '#333',
                        color: 'white',
                        cursor: 'pointer',
                        border: mode === 'light' ? '1px solid' : '1px solid gray',
                      }}
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </Menu>
            </div>
            <div className="header-right">
              <button
                onClick={() =>
                  setOpenSidebar((prev) => {
                    localStorage.setItem('C2G-sidebar', JSON.stringify(!prev));
                    return !prev;
                  })
                }
                type="button"
                className="C2G-button C2G-nav-button"
                style={{ width: 30 }}
              >
                {openSidebar ? (
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                    <path d="M800-240v-480h80v480h-80Zm-320 0-57-56 144-144H80v-80h487L424-664l56-56 240 240-240 240Z" />
                  </svg>
                ) : (
                  <svg
                    style={{ transform: 'rotate(180deg)' }}
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path d="M800-240v-480h80v480h-80Zm-320 0-57-56 144-144H80v-80h487L424-664l56-56 240 240-240 240Z" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {!legacyUI && (
        <div className="C2G-headerbar-new" style={{ background: mode === 'light' ? '#fff' : '#333' }}>
          <div className="C2G-header">
            <div className="header-left" style={{ paddingLeft: 10 }}>
              <div className="sa-navbar-subbar-selectors">
                <button
                  className={`sa-selector-tab ${dateRangeSelected === 'today' && !openRangeForm ? ' selected' : ''} ${
                    mode === 'light' ? 'light' : 'dark'
                  }`}
                  type="button"
                  onClick={() => {
                    localStorage.setItem('C2G-date-range', 'today');
                    selectDateRange('today');
                  }}
                >
                  Today
                </button>
                <button
                  className={`sa-selector-tab ${
                    dateRangeSelected === 'yesterday' && !openRangeForm ? ' selected' : ''
                  } ${mode === 'light' ? 'light' : 'dark'}`}
                  type="button"
                  onClick={() => {
                    localStorage.setItem('C2G-date-range', 'yesterday');
                    selectDateRange('yesterday');
                  }}
                >
                  Yesterday
                </button>
                <button
                  className={`sa-selector-tab ${
                    dateRangeSelected === 'last7Days' && !openRangeForm ? ' selected' : ''
                  } ${mode === 'light' ? 'light' : 'dark'}`}
                  type="button"
                  onClick={() => {
                    localStorage.setItem('C2G-date-range', 'last7Days');
                    selectDateRange('last7Days');
                  }}
                >
                  Last 7 days
                </button>
                <button
                  className={`sa-selector-tab ${
                    dateRangeSelected === 'thisMonth' && !openRangeForm ? ' selected' : ''
                  } ${mode === 'light' ? 'light' : 'dark'}`}
                  type="button"
                  onClick={() => {
                    localStorage.setItem('C2G-date-range', 'thisMonth');
                    selectDateRange('thisMonth');
                  }}
                >
                  This Month
                </button>
                <button
                  className={`sa-selector-tab ${
                    dateRangeSelected === 'lastMonth' && !openRangeForm ? ' selected' : ''
                  }  ${mode === 'light' ? 'light' : 'dark'}`}
                  type="button"
                  onClick={() => {
                    localStorage.setItem('C2G-date-range', 'lastMonth');
                    selectDateRange('lastMonth');
                  }}
                >
                  Last Month
                </button>
                <button
                  className={`sa-selector-tab ${
                    openRangeForm || dateRangeSelected === 'manual' || dateRangeSelected?.includes(',')
                      ? ' selected'
                      : ''
                  }  ${mode === 'light' ? 'light' : 'dark'}`}
                  type="button"
                  onClick={(e) => {
                    setOpenRangeForm(!openRangeForm);
                    handleDateRangeClick(e);
                  }}
                >
                  Date Range
                </button>
                <Menu
                  className="date-form-parent"
                  anchorEl={anchorEl}
                  open={openRangeForm}
                  aria-haspopup
                  onClose={handleDateRangeClose}
                  style={{
                    zIndex: 1000000000,
                    top: 45,
                    padding: 0,
                  }}
                  PaperProps={{
                    style: {
                      backgroundColor: mode === 'light' ? 'white' : '#222',
                      borderRadius: 8,
                      padding: 0,
                    },
                  }}
                >
                  <div
                    className="date-form-container"
                    style={{
                      background: mode === 'light' ? 'white' : '#222',
                      padding: 0,
                      borderRadius: 8,
                    }}
                  >
                    <form className="date-form" style={{ padding: '5px 10px', flexDirection: 'row' }}>
                      <div className="date-rows" style={{ display: 'flex', gap: 15 }}>
                        <div
                          className={`date-row ${mode === 'light' ? 'light-bg' : 'dark-bg'}`}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 10,
                          }}
                        >
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label style={{ color: mode === 'light' ? 'black' : 'white' }} htmlFor="start">
                            Start:
                          </label>
                          <input
                            type="date"
                            id="start"
                            defaultValue={dateRangeSelected?.split(',')?.[0]}
                            ref={startTimeRef}
                            onChange={(e) => {
                              localStorage.setItem('C2G-startTimeRef', e.target.value);
                            }}
                            style={{
                              background: mode === 'light' ? '#f0f0f0' : '#555',
                              border: '1px solid #ccc',
                              borderRadius: 4,
                              padding: '4px 10px',
                              width: '80%',
                              textTransform: 'uppercase',
                              fontFamily: 'Arial, sans-serif',
                            }}
                          />
                        </div>
                        <div
                          className={`date-row ${mode === 'light' ? 'light-bg' : 'dark-bg'}`}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 10,
                          }}
                        >
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label style={{ color: mode === 'light' ? 'black' : 'white' }} htmlFor="end">
                            End:
                          </label>
                          <input
                            type="date"
                            id="end"
                            ref={endTimeRef}
                            defaultValue={dateRangeSelected?.split(',')?.[1]}
                            onChange={(e) => {
                              localStorage.setItem('C2G-endTimeRef', e.target.value);
                            }}
                            style={{
                              background: mode === 'light' ? '#f0f0f0' : '#555',
                              border: '1px solid #ccc',
                              borderRadius: 4,
                              padding: '4px 10px',
                              width: '80%',
                              textTransform: 'uppercase',
                              fontFamily: 'Arial, sans-serif',
                            }}
                          />
                        </div>
                      </div>
                      <div className="submit-button" style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
                        <button
                          type="button"
                          onClick={() => {
                            localStorage.setItem('C2G-date-range', 'manual');
                            selectDateRange('manual');
                          }}
                          style={{
                            padding: '6px 10px',
                            borderRadius: 6,
                            background: mode === 'light' ? '#0684bd' : '#222',
                            color: 'white',
                            cursor: 'pointer',
                            border: mode === 'light' ? '1px solid' : '1px solid gray',
                            fontSize: '0.9em',
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </Menu>
              </div>
            </div>
            <div className="header-right">
              <button
                onClick={() =>
                  setOpenSidebar((prev) => {
                    localStorage.setItem('C2G-sidebar', JSON.stringify(!prev));
                    return !prev;
                  })
                }
                type="button"
                className="C2G-button C2G-nav-button"
                style={{ width: 30 }}
              >
                {openSidebar ? (
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                    <path d="M800-240v-480h80v480h-80Zm-320 0-57-56 144-144H80v-80h487L424-664l56-56 240 240-240 240Z" />
                  </svg>
                ) : (
                  <svg
                    style={{ transform: 'rotate(180deg)' }}
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path d="M800-240v-480h80v480h-80Zm-320 0-57-56 144-144H80v-80h487L424-664l56-56 240 240-240 240Z" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      <div
        className={`C2G-page ${openSidebar ? 'C2G-sidebar-open ' : 'C2G-sidebar-closed '}${
          mode === 'light' ? ' light ' : ' dark '
        }`}
        style={{ paddingTop: legacyUI ? 80 : 50 }}
      >
        <div className="C2G-parent">
          {/* {page === "c2g" && ( */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {/* main datagrid accordion */}
            <Accordion
              elevation={1}
              style={{
                margin: 7,
                marginTop: 0,
                display: layout?.find((item) => item.title === 'Calls')?.visible ? 'block' : 'none',
                order: layout.findIndex((item) => item.title === 'Calls'),
                background: mode === 'light' ? 'white' : '#333',
              }}
              expanded={expandedAccordions.calls}
              className="C2G-ag-grid-container moveable"
            >
              <AccordionSummary
                className="C2G-ag-grid-header sticky-header"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  color: 'white',
                  minHeight: 50,
                  maxHeight: 50,
                  backgroundColor: mode === 'light' ? '#0684bd' : 'rgb(24, 24, 24)',
                  position: 'relative',
                }}
              >
                <Box
                  width="100%"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  className="C2G-ag-header-left"
                  aria-hidden="true"
                  onClick={() =>
                    setCallsAccordionExpanded((prev) => ({
                      ...prev,
                      calls: !prev.calls,
                    }))
                  }
                >
                  <b
                    style={{
                      marginLeft: 5,
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    {expandedAccordions.calls ? (
                      <svg
                        className="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        style={{ color: 'white' }}
                      >
                        <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
                      </svg>
                    ) : (
                      <svg
                        className="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        style={{ color: 'white' }}
                      >
                        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                      </svg>
                    )}
                    Calls
                    {filterRef && Object.keys(filterRef).length > 0 && (
                      <button
                        className="C2G-button"
                        type="button"
                        style={{ width: 35 }}
                        aria-label="header-button"
                        onClick={(e) => {
                          setOpenSidebar(true);
                          e.stopPropagation();
                        }}
                      >
                        <span
                          style={{
                            fontFamily: 'agGridAlpine',
                            color: 'white',
                            fontSize: '1.4em',
                          }}
                          className="ag-theme-alpine ag-icon-filter"
                        />
                      </button>
                    )}
                  </b>
                </Box>
                <div className="C2G-ag-header-right" style={{ display: 'flex', alignItems: 'center' }}>
                  <button
                    type="button"
                    aria-label="header-button"
                    onClick={() => setGridHeightValue((prev) => (prev < 9 ? prev + 1 : prev))}
                    className="header-button"
                  >
                    <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ fill: 'white' }}>
                      <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    aria-label="header-button"
                    onClick={() => setGridHeightValue((prev) => (prev > 1 ? prev - 1 : prev))}
                    className="header-button"
                  >
                    <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ fill: 'white' }}>
                      <path d="M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    aria-label="header-button"
                    onClick={() => setFontValue((prev) => (prev < 3 ? prev + 1 : prev))}
                    className="header-button"
                  >
                    <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ fill: 'white' }}>
                      <path d="M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    aria-label="header-button"
                    onClick={() => setFontValue((prev) => (prev > 1 ? prev - 1 : prev))}
                    className="header-button header-button-small"
                  >
                    <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ fill: 'white' }}>
                      <path d="M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z" />
                    </svg>
                  </button>
                </div>
              </AccordionSummary>
              <div
                role="tabpanel"
                id="simple-tabpanel-0"
                aria-labelledby="simple-tab-0"
                style={{
                  height: `calc(100px * ${gridHeightValue})`,
                  width: '100%',
                }}
                className={mode === 'light' ? 'C2G-grid ag-theme-alpine' : 'C2G-grid ag-theme-alpine-dark'}
              >
                <AgGridReact
                  ref={gridRef}
                  // onGridReady={onGridReady}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  onFilterChanged={onFilterChanged}
                  onColumnMoved={(e) => {
                    const newColumnState = e.columnApi.getColumnState();
                    localStorage.setItem('C2G-saveGridConfig', JSON.stringify(newColumnState));
                  }}
                  onColumnResized={(e) => {
                    const newColumnState = e.columnApi.getColumnState();
                    localStorage.setItem('C2G-saveGridConfig', JSON.stringify(newColumnState));
                  }}
                  // onFilterModified={onFilterModified}
                  onSortChanged={onSortChanged}
                  rowModelType="serverSide"
                  serverSideInfiniteScroll // load data in portions
                  onGridReady={() => {
                    const safeParse = (key: string) => {
                      try {
                        const storedValue = localStorage.getItem(key);
                        return storedValue ? JSON.parse(storedValue) : null;
                      } catch (e) {
                        // eslint-disable-next-line no-console
                        console.error(`Error parsing ${key} from localStorage`, e);
                        return null;
                      }
                    };

                    const savedGridConfigFilter = safeParse('C2G-saveGridConfig-filter') || {};
                    const saveGridConfig = safeParse('C2G-saveGridConfig') || [];

                    // Apply models if API is ready
                    if (gridRef.current?.api && gridRef.current?.columnApi) {
                      gridRef.current.api.setFilterModel(savedGridConfigFilter);
                      gridRef.current.columnApi.applyColumnState({
                        state: saveGridConfig,
                        applyOrder: true,
                      });
                    }
                    setGridReady(true);
                  }}
                  rowSelection="single"
                  onSelectionChanged={onSelectionChanged}
                  getRowId={getRowId}
                  sideBar={{
                    toolPanels: [
                      'filters',
                      {
                        id: 'columns',
                        labelDefault: 'Columns',
                        labelKey: 'columns',
                        iconKey: 'columns',
                        toolPanel: 'agColumnsToolPanel',
                        toolPanelParams: {
                          suppressRowGroups: true,
                          suppressValues: true,
                          suppressPivots: true,
                          suppressPivotMode: true,
                          suppressColumnSelectAll: true,
                          suppressColumnExpandAll: true,
                        },
                      },
                    ],
                  }}
                  //   floatingFiltersHeight={0}
                  enableCellChangeFlash
                  animateRows
                />
                {error && <div className="assistive-prompt">{error}</div>}
              </div>
              <div
                className={`${progress >= 100 ? 'C2G-progress-loading-complete' : ''}`}
                style={{
                  height: 12,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div
                  className="C2G-progress-meter-container"
                  style={{
                    width: `${progress > 100 ? '' : `calc(${progress}%)`}`,
                    height: '100%',
                    alignItems: 'center',
                  }}
                >
                  <span
                    className={`${progress >= 100 ? 'C2G-progress-prompt-complete' : ''}`}
                    style={{
                      fontSize: '0.7em',
                      width: 10,
                      whiteSpace: 'nowrap',
                      textAlign: 'end',
                      height: 9,
                      position: 'absolute',
                      left: 3,
                      color: progress > 100 ? 'red' : '',
                    }}
                  >
                    {progress > 100 ? 'Maximum number of records loaded.' : `${progress}%`}
                  </span>
                </div>
              </div>
            </Accordion>
            <Accordion
              elevation={1}
              style={{
                margin: 7,
                display: layout?.find((item) => item.title === 'Report')?.visible ? 'block' : 'none',
                order: layout.findIndex((item) => item.title === 'Report'),
                background: mode === 'light' ? 'white' : '#333',
              }}
              expanded={expandedAccordions.report}
              className="C2G-ag-grid-container moveable"
            >
              <AccordionSummary
                aria-controls="panel1-content"
                id="panel1-header"
                className="C2G-ag-grid-header sticky-header2"
                style={{
                  minHeight: 50,
                  maxHeight: 50,
                  backgroundColor: mode === 'light' ? '#0684bd' : 'rgb(24, 24, 24)',
                  position: 'relative',
                }}
              >
                <Box
                  className="sticky-header"
                  width="100%"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    style={{ color: 'white' }}
                    onClick={() => {
                      setDrawerOpen(false);
                    }}
                  >
                    <Box
                      width="100%"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      className="C2G-ag-header-left"
                      aria-hidden="true"
                      onClick={() =>
                        setCallsAccordionExpanded((prev) => ({
                          ...prev,
                          report: !prev.report,
                        }))
                      }
                    >
                      <b
                        style={{
                          marginLeft: 5,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {expandedAccordions.report ? (
                          <svg
                            className="MuiSvgIcon-root"
                            focusable="false"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                            style={{ color: 'white' }}
                          >
                            <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />{' '}
                          </svg>
                        ) : (
                          <svg
                            className="MuiSvgIcon-root"
                            focusable="false"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                            style={{ color: 'white' }}
                          >
                            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                          </svg>
                        )}
                        Summary
                      </b>
                      {summaryFilterRef && Object.keys(summaryFilterRef).length > 0 && (
                        <button
                          className="C2G-button"
                          type="button"
                          style={{ width: 35 }}
                          aria-label="header-button"
                          onClick={(e) => {
                            setOpenSidebar(true);
                            e.stopPropagation();
                          }}
                        >
                          <span
                            style={{
                              fontFamily: 'agGridAlpine',
                              color: 'white',
                              fontSize: '1.4em',
                            }}
                            className="ag-theme-alpine ag-icon-filter"
                          />
                        </button>
                      )}
                    </Box>
                  </Typography>
                  {/* <div style={{ marginRight: 8, paddingRight: 3 }}>
                    <Button
                      onClick={() =>
                        heightHandler(setWidgetSetting, "decrease")
                      }
                      style={{
                        minWidth: 24,
                        minHeight: 24,
                        paddingLeft: 5,
                        paddingRight: 5,
                        paddingTop: 4,
                        paddingBottom: 4,
                      }}
                    >
                      <ShrinkIcon
                        color={widgetSetting === 0 ? "#ffffffaa" : "white"}
                        style={{ width: 24 }}
                      />
                    </Button>
                    <Button
                      onClick={() =>
                        heightHandler(setWidgetSetting, "increase")
                      }
                      style={{
                        minWidth: 24,
                        minHeight: 24,
                        paddingLeft: 5,
                        paddingRight: 5,
                        paddingTop: 4,
                        paddingBottom: 4,
                      }}
                    >
                      <GrowIcon
                        color={widgetSetting === 3 ? "#ffffffaa" : "white"}
                        style={{ width: 24 }}
                      />
                    </Button>
                  </div> */}
                  <button
                    style={{ border: 0, background: 'none', cursor: 'pointer' }}
                    type="button"
                    onClick={() => setHeadlinesEnabled((prev) => !prev)}
                  >
                    <PieChartRounded style={{ color: 'white' }} />
                  </button>
                </Box>
              </AccordionSummary>
              {!loading && (
                <div
                  role="tabpanel"
                  id="simple-tabpanel-0"
                  aria-labelledby="simple-tab-0"
                  style={{
                    // height: 'auto',
                    width: '100%',
                  }}
                  className={mode === 'light' ? 'C2G-grid ag-theme-alpine' : 'C2G-grid ag-theme-alpine-dark'}
                >
                  <Report
                    filterModel={reportFilter}
                    organizationId={organizationId}
                    version={dbVersion}
                    index={lastIndex}
                    fontValue={fontValue}
                    mode={mode}
                    headlinesEnabled={headlinesEnabled}
                    hasCX={!!token}
                    setSummaryFilterRef={setSummaryFilterRef}
                  />
                </div>
              )}
            </Accordion>
            {/* headlines widget accordion  */}
            {/* <Accordion
              elevation={1}
              className="C2G-ag-grid-container moveable"
              expanded={expandedAccordions.headlines}
              style={{
                backgroundColor: mode === "light" ? "white" : "rgb(24, 24, 24)",
                position: "relative",
                margin: 7,
                borderRadius: "5px 5px 0px 0px",
                display: layout?.find((item) => item.title === "Headlines")
                  ?.visible
                  ? "block"
                  : "none",
                order: layout.findIndex((item) => item.title === "Headlines"),
              }}
            >
              <AccordionSummary
                aria-controls="panel1-content"
                id="panel1-header"
                className="C2G-ag-grid-header sticky-header2"
                style={{
                  minHeight: 50,
                  maxHeight: 50,
                  backgroundColor:
                    mode === "light" ? "#0684bd" : "rgb(24, 24, 24)",
                  position: "relative",
                }}
              >
                <Box
                  className="sticky-header"
                  width="100%"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    style={{ color: "white" }}
                    onClick={() => {
                      setDrawerOpen(false);
                    }}
                  >
                    <Box
                      width="100%"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      className="C2G-ag-header-left"
                      aria-hidden="true"
                      onClick={() =>
                        setCallsAccordionExpanded((prev) => ({
                          ...prev,
                          headlines: !prev.headlines,
                        }))
                      }
                    >
                      <b
                        style={{
                          marginLeft: 5,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {expandedAccordions.headlines ? (
                          <svg
                            className="MuiSvgIcon-root"
                            focusable="false"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                            style={{ color: "white" }}
                          >
                            <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />{" "}
                          </svg>
                        ) : (
                          <svg
                            className="MuiSvgIcon-root"
                            focusable="false"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                            style={{ color: "white" }}
                          >
                            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                          </svg>
                        )}
                        Headlines
                      </b>
                    </Box>
                  </Typography>
                  <div style={{ marginRight: 8, paddingRight: 3 }}>
                    <Button
                      onClick={() =>
                        heightHandler(setWidgetSetting, "decrease")
                      }
                      style={{
                        minWidth: 24,
                        minHeight: 24,
                        paddingLeft: 5,
                        paddingRight: 5,
                        paddingTop: 4,
                        paddingBottom: 4,
                      }}
                    >
                      <ShrinkIcon
                        color={widgetSetting === 0 ? "#ffffffaa" : "white"}
                        style={{ width: 24 }}
                      />
                    </Button>
                    <Button
                      onClick={() =>
                        heightHandler(setWidgetSetting, "increase")
                      }
                      style={{
                        minWidth: 24,
                        minHeight: 24,
                        paddingLeft: 5,
                        paddingRight: 5,
                        paddingTop: 4,
                        paddingBottom: 4,
                      }}
                    >
                      <GrowIcon
                        color={widgetSetting === 2 ? "#ffffffaa" : "white"}
                        style={{ width: 24 }}
                      />
                    </Button>
                  </div>
                </Box>
              </AccordionSummary>
              <AccordionDetails
                className="C2G-headlines-master-container"
                style={{
                  border:
                    mode === "light"
                      ? "1px solid #babfc7"
                      : "1px solid #68686e",
                  paddingRight: drawerOpen ? 282 : 32,
                  paddingBottom: 0,
                  paddingLeft: 0,
                  height: "100%",
                  minHeight: widgetSetting >= 2 ? 268 : 214,
                }}
              >
                <DragDropContext
                  onDragEnd={(e: any) =>
                    widgetSetting >= 2
                      ? ""
                      : handleOnDragEnd(e, graphData, setGraphData)
                  }
                >
                  <Droppable
                    type="group"
                    direction="horizontal"
                    droppableId="C2G-widget-dragdropables"
                  >
                    {(provided: any) => (
                      <Grid
                        container={widgetSetting >= 2}
                        spacing={widgetSetting >= 2 ? 1 : 1}
                        className="C2G-widget-row"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {graphData &&
                          Array.from(graphData.entries())
                            .filter(([_, graph]) => graph.visible)
                            .map(([key, graph]) => ({
                              key,
                              ...graph,
                            }))
                            .map((graph, i) => (
                              <Draggable
                                key={graph.key}
                                draggableId={graph.key}
                                index={i}
                                isDragDisabled={widgetSetting >= 2}
                              >
                                {(providedInner: any) => (
                                  <Grid
                                    item
                                    className="provided-container"
                                    xs={gapHandler(widgetSetting, "md")}
                                    md={gapHandler(widgetSetting, "lg")}
                                    lg={gapHandler(widgetSetting, "xl")}
                                    xl={gapHandler(widgetSetting, "xl")}
                                    ref={providedInner.innerRef}
                                    {...providedInner.draggableProps}
                                    {...providedInner.dragHandleProps}
                                  >
                                    <C2GHeadlinesWidget
                                      title={graph.key}
                                      graphData={
                                        graphData!.get(
                                          graph.key
                                        ) as WidgetGraphData
                                      }
                                      mode={mode}
                                      widgetSetting={widgetSetting}
                                      loading={loading}
                                      filterRef={filterRef}
                                      organizationId={organizationId}
                                      indexesModified={indexesModified}
                                      isBarChart={graph.isBarChart!}
                                    />
                                  </Grid>
                                )}
                              </Draggable>
                            ))}
                        {provided.placeholder}
                      </Grid>
                    )}
                  </Droppable>
                </DragDropContext>

                <div
                  className={
                    expandedAccordions.headlines
                      ? "headlines-menu-container-open"
                      : "headlines-menu-container-closed"
                  }
                  style={{
                    overflowY: expandedAccordions.headlines
                      ? "visible"
                      : "hidden",
                    display: expandedAccordions.headlines ? "block" : "hidden",
                    position: "absolute",
                    top: "50px",
                    right: 0,
                    width: 30,
                    height: expandedAccordions.headlines
                      ? "calc(100% - 52px)"
                      : 0,
                    backgroundColor: mode === "light" ? "white" : "#181d1f",
                    border:
                      mode === "light"
                        ? "1px solid #babfc7"
                        : "1px solid #68686e",
                  }}
                >
                  <div
                    tabIndex={0}
                    role="button"
                    className="headlines-title"
                    style={{
                      overflowY: expandedAccordions.calls
                        ? "visible"
                        : "hidden",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: 30,
                      borderLeft: drawerOpen
                        ? borderHandler(mode)
                        : "2px solid transparent",
                      transitionDuration: "0.2s",
                      animation: "fadein 0.2s ease forwards",
                    }}
                    onClick={() => {
                      setDrawerOpen((prev) => !prev);
                    }}
                    onKeyDown={() => {
                      setDrawerOpen((prev) => !prev);
                    }}
                  >
                    <DonutSmall
                      className="icon"
                      style={{
                        marginTop: 15,
                        color: mode === "light" ? "black" : "white",
                        transform: "scale(0.8)",
                      }}
                      fontSize="small"
                    />
                    <p
                      style={{
                        overflowY: expandedAccordions.calls
                          ? "visible"
                          : "hidden",
                        color: mode === "light" ? "black" : "white",
                        writingMode: "vertical-rl",
                        textOrientation: "mixed",
                        fontSize: "0.8em",
                        userSelect: "none",
                        margin: 0,
                        paddingTop: 4,
                        paddingLeft: 8,
                        width: 10,
                        height: 54,
                      }}
                    >
                      Charts
                    </p>
                  </div>
                  {drawerOpen && (
                    <div
                      style={{
                        borderLeft:
                          mode === "light"
                            ? "1px solid #babfc7"
                            : "1px solid #68686e",
                        borderRight:
                          mode === "light"
                            ? "1px solid #babfc7"
                            : "1px solid #68686e",
                        borderBottom:
                          mode === "light"
                            ? "1px solid #babfc7"
                            : "1px solid #68686e",
                        backgroundColor:
                          mode === "light" ? "white " : "#222628",
                        position: "absolute",
                        right: "30px",
                        top: "0px",
                        width: 228,
                        height: "calc(100% - 24px)",
                        padding: 12,
                        paddingLeft: 8,
                        overflowY: "scroll",
                      }}
                    >
                      {Array.from(graphData.entries()).map((item) => (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            style={{
                              color: mode === "light" ? "#2196f3" : "white",
                              padding: 0,
                              margin: 0,
                              height: 24,
                              width: 24,
                            }}
                            checked={item[1].visible}
                            onClick={() => {
                              setGraphData((prev) => {
                                const newMap = new Map(
                                  [...prev].map(([key, value]) =>
                                    key === item[0]
                                      ? [
                                          key,
                                          {
                                            ...value,
                                            visible: !value.visible,
                                          },
                                        ]
                                      : [key, value]
                                  )
                                );
                                const configurations = Array.from(newMap).map(
                                  ([key, value]) => ({
                                    key,
                                    visible: value.visible,
                                    title: value.title,
                                    isBarChart: value.isBarChart,
                                  })
                                );

                                localStorage.setItem(
                                  "C2G-graphs",
                                  JSON.stringify(configurations)
                                );
                                return newMap;
                              });
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <p
                              style={{
                                paddingLeft: 4,
                                color: mode === "light" ? "#333" : "white",
                                fontSize: 12,
                                margin: 0,
                              }}
                            >
                              {item[0]}
                            </p>
                            <div
                              style={{
                                width: 60,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                                gap: 4,
                              }}
                            >
                              {item[1].title !== "Platform Transfers" && (
                                <button
                                  className="c2g-graph-swap-button"
                                  disabled={
                                    item[1].title === "Platform Transfers"
                                  }
                                  style={{
                                    background: buttonColorSelector(
                                      mode,
                                      !item[1].isBarChart
                                    ),
                                    padding: 0,
                                    margin: 0,
                                    height: 22,
                                    width: 22,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: 0,
                                    borderRadius: 4,
                                    cursor: "pointer",
                                  }}
                                  type="button"
                                  onClick={() => {
                                    setGraphData((prev) => {
                                      const newMap = new Map(
                                        [...prev].map(([key, value]) =>
                                          key === item[0]
                                            ? [
                                                key,
                                                {
                                                  ...value,
                                                  isBarChart: false,
                                                },
                                              ]
                                            : [key, value]
                                        )
                                      );
                                      const configurations = Array.from(
                                        newMap
                                      ).map(([key, value]) => ({
                                        key,
                                        visible: value.visible,
                                        title: value.title,
                                        isBarChart: value.isBarChart,
                                      }));

                                      localStorage.setItem(
                                        "C2G-graphs",
                                        JSON.stringify(configurations)
                                      );
                                      return newMap;
                                    });
                                  }}
                                >
                                  <PieChart
                                    style={{
                                      width: 22,
                                      height: 22,
                                      color: !item[1].isBarChart
                                        ? "black"
                                        : "#121212",
                                    }}
                                  />
                                </button>
                              )}
                              <button
                                className="c2g-graph-swap-button"
                                style={{
                                  background: buttonColorSelector(
                                    mode,
                                    item[1].isBarChart
                                  ),
                                  padding: 0,
                                  margin: 0,
                                  height: 22,
                                  width: 22,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  border: 0,
                                  borderRadius: 4,
                                }}
                                type="button"
                                onClick={() => {
                                  setGraphData((prev) => {
                                    const newMap = new Map(
                                      [...prev].map(([key, value]) =>
                                        key === item[0]
                                          ? [
                                              key,
                                              {
                                                ...value,
                                                isBarChart: true,
                                              },
                                            ]
                                          : [key, value]
                                      )
                                    );
                                    const configurations = Array.from(
                                      newMap
                                    ).map(([key, value]) => ({
                                      key,
                                      visible: value.visible,
                                      title: value.title,
                                      isBarChart: value.isBarChart,
                                    }));

                                    localStorage.setItem(
                                      "C2G-graphs",
                                      JSON.stringify(configurations)
                                    );
                                    return newMap;
                                  });
                                }}
                              >
                                <Equalizer
                                  style={{
                                    width: 22,
                                    height: 22,
                                    color: item[1].isBarChart
                                      ? "black"
                                      : "#121212",
                                  }}
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </AccordionDetails>
            </Accordion> */}

            {/* transcript & Recordings */}
            {callLog && (
              <div
                className="C2G-container moveable"
                style={{
                  marginTop: 20,
                  display: layout?.find((item) => item.title === 'Transcript & Playback')?.visible ? 'block' : 'none',
                  order: layout.findIndex((item) => item.title === 'Transcript & Playback'),
                }}
              >
                <h3>Call Recording & Transcript</h3>
                <div className="transcript-recording-container">
                  {recordingsDisplay && recordingsDisplay[0]?.recordingUrl && (
                    <>
                      {/* <button
                    type="button"
                    onClick={() => {
                      window.open(recordingUrl, '_blank');
                    }}
                  >
                    Recording
                  </button> */}
                      <audio
                        ref={recordingPlayerRef}
                        className="recording-container"
                        src={recordingsDisplay[0]?.recordingUrl}
                        controls
                      />
                    </>
                  )}

                  {/* {transcriptExists !== undefined &&  (
                  <button type="button" onClick={() => clickOnTranscript(transcriptExists)}>
                    Load Transcript
                  </button>
                  // JSON.stringify(fetchedTranscript)
                )} */}
                  {fetchedTranscript !== undefined && (
                    <div className="transcript-container">
                      {/* <button type="button" onClick={() => clickOnTranscript(transcriptExists)} >fetch transcript</button> */}
                      {fetchedTranscript.map((transcriptBlock) => {
                        const { start, end, text } = transcriptBlock;
                        return (
                          <div onClick={() => recordingNavigation(start)} className="transcript-row">
                            <span className="time-row">{formatTranscriptFloatsToMMSS(start)}</span>
                            <span className="transcript-row-text">{text}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* timeline (to be replaced) */}

            {callLog && (
              <Accordion
                expanded={expandedAccordions.c2g}
                style={{
                  background: '#00000000',
                  margin: 6,
                  display: layout?.find((item) => item.title === 'Cradle to Grave')?.visible ? 'block' : 'none',
                  order: layout.findIndex((item) => item.title === 'Cradle to Grave'),
                }}
              >
                <AccordionSummary
                  style={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    color: 'white',
                    minHeight: 50,
                    maxHeight: 50,
                    backgroundColor: mode === 'light' ? '#0684bd' : 'rgb(24, 24, 24)',
                    position: 'relative',
                  }}
                  className="C2G-ag-grid-header sticky-header"
                >
                  <Typography
                    onClick={() => {
                      setCallsAccordionExpanded((prev) => ({
                        ...prev,
                        c2g: !prev.c2g,
                      }));
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    {expandedAccordions.c2g ? (
                      <svg
                        className="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        style={{ color: 'white' }}
                      >
                        <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />{' '}
                      </svg>
                    ) : (
                      <svg
                        className="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        style={{ color: 'white' }}
                      >
                        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                      </svg>
                    )}
                    Cradle To Grave
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  className="C2G-headlines-master-container"
                  style={{
                    background: '#00000000',
                    padding: 0,
                    display: 'block',
                  }}
                >
                  <div
                    className="C2G-container moveable"
                    style={{
                      margin: 0,
                      background: '#00000000',
                      border: '1px solid #68686e',
                    }}
                  >
                    <C2GTimeline
                      events={timelineEvents}
                      transferEvents={transferEvents}
                      historicalUsers={historicalUsers}
                      historicalQueues={historicalQueues}
                      mode={mode}
                      cxAgents={cxAgents}
                      orgId={organizationId}
                    />
                  </div>
                </AccordionDetails>
              </Accordion>
            )}
          </div>

          {/* )} {page === "agents" && <Queues token={token} agentLeaderboard />} */}
        </div>
        <div className="C2G-sidebar">
          <div className="C2G-sidebar-parent" style={{ color: 'white', top: legacyUI ? 140 : 110 }}>
            <div
              style={{
                color: 'white',
                height: '100%',
              }}
            >
              <div style={{ position: 'relative', height: '100%' }}>
                <ListItem button onClick={() => setSidebarOptions((p) => (p === 'call journey' ? '' : 'call journey'))}>
                  <ListItemText primary="Call Journey" />
                  {sidebarOptions === 'call journey' ? (
                    <svg style={{ height: 30, width: 30, fill: 'white' }}>
                      <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
                    </svg>
                  ) : (
                    <svg style={{ height: 30, width: 30, fill: 'white' }}>
                      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                    </svg>
                  )}
                </ListItem>
                <Collapse in={sidebarOptions === 'call journey'}>
                  <div style={{ height: '100%' }}>
                    <DragDropContext onDragEnd={(e: any) => handleSidebarOnDragEnd(e, layout, setLayout)}>
                      <Droppable droppableId="orderHandlers">
                        {(provided: any) => (
                          <div {...provided.droppableProps} ref={provided.innerRef}>
                            {layout.map((item, i) => (
                              <Draggable key={item.title} draggableId={item.title} index={i}>
                                {(providedInner: any) => (
                                  <ListItem
                                    {...providedInner.draggableProps}
                                    ref={providedInner.innerRef}
                                    disableGutters
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'start',
                                        alignItems: 'center',
                                        width: '100%',
                                      }}
                                    >
                                      <Checkbox
                                        checked={item.visible}
                                        style={{
                                          color: 'inherit',
                                          marginRight: 0,
                                          marginLeft: 19,
                                          padding: 6,
                                        }}
                                        onChange={() => {
                                          setLayout((prevLayout) => {
                                            const updatedLayout = [...prevLayout];
                                            updatedLayout[i].visible = !updatedLayout[i].visible;
                                            localStorage.setItem('C2G-layout-config', JSON.stringify(updatedLayout));
                                            return updatedLayout;
                                          });
                                        }}
                                      />
                                      <div
                                        className="handle"
                                        {...providedInner.dragHandleProps}
                                        style={{
                                          letterSpacing: '-0.4em',
                                          fontSize: '0.7em',
                                          padding: '0px 10px 0px 0px',
                                        }}
                                      >
                                        ⠇⠇⠇⠇
                                      </div>
                                      <span>{item.title}</span>
                                    </div>
                                  </ListItem>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                </Collapse>
                {/* {organizationId && organizationId === "3154756020" && (
                  <ActiveFilterView
                    orgId={organizationId || ""}
                    typeOfDisplay="Insights"
                    filterRef={filterRef}
                    mode={mode}
                  />
                )}
                {organizationId && organizationId === "3154756020" && (
                  <ActiveFilterView
                    orgId={organizationId || ""}
                    typeOfDisplay="Summary"
                    filterRef={summaryFilterRef}
                    mode={mode}
                  />
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
